(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'kotlinx-serialization-kotlinx-serialization-core'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'kotlinx-serialization-kotlinx-serialization-core'.");
    }
    globalThis['kotlinx-serialization-kotlinx-serialization-core'] = factory(typeof globalThis['kotlinx-serialization-kotlinx-serialization-core'] === 'undefined' ? {} : globalThis['kotlinx-serialization-kotlinx-serialization-core'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var VOID = kotlin_kotlin.$_$.d;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var StringCompanionObject_instance = kotlin_kotlin.$_$.y2;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var emptyList = kotlin_kotlin.$_$.c9;
  var LazyThreadSafetyMode_PUBLICATION_getInstance = kotlin_kotlin.$_$.v3;
  var lazy = kotlin_kotlin.$_$.so;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var toString = kotlin_kotlin.$_$.hh;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var asList = kotlin_kotlin.$_$.s7;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var zip = kotlin_kotlin.$_$.yc;
  var toMap = kotlin_kotlin.$_$.oc;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.j4;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var mapCapacity = kotlin_kotlin.$_$.ua;
  var LinkedHashMap_init_$Create$_0 = kotlin_kotlin.$_$.i4;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var KtMap = kotlin_kotlin.$_$.g7;
  var isInterface = kotlin_kotlin.$_$.rg;
  var captureStack = kotlin_kotlin.$_$.gf;
  var listOf = kotlin_kotlin.$_$.sa;
  var IllegalArgumentException_init_$Init$ = kotlin_kotlin.$_$.m5;
  var IllegalArgumentException_init_$Init$_0 = kotlin_kotlin.$_$.o5;
  var IllegalArgumentException_init_$Init$_1 = kotlin_kotlin.$_$.q5;
  var IllegalArgumentException = kotlin_kotlin.$_$.hn;
  var collectionSizeOrDefault = kotlin_kotlin.$_$.b8;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b1;
  var KClass = kotlin_kotlin.$_$.ui;
  var Triple = kotlin_kotlin.$_$.tn;
  var getKClass = kotlin_kotlin.$_$.si;
  var Pair = kotlin_kotlin.$_$.pn;
  var Entry = kotlin_kotlin.$_$.f7;
  var KtMutableMap = kotlin_kotlin.$_$.k7;
  var LinkedHashMap = kotlin_kotlin.$_$.c7;
  var HashMap = kotlin_kotlin.$_$.z6;
  var KtSet = kotlin_kotlin.$_$.n7;
  var KtMutableSet = kotlin_kotlin.$_$.l7;
  var LinkedHashSet = kotlin_kotlin.$_$.d7;
  var HashSet = kotlin_kotlin.$_$.a7;
  var Collection = kotlin_kotlin.$_$.y6;
  var KtList = kotlin_kotlin.$_$.e7;
  var KtMutableList = kotlin_kotlin.$_$.i7;
  var ArrayList = kotlin_kotlin.$_$.x6;
  var copyToArray = kotlin_kotlin.$_$.x8;
  var Result = kotlin_kotlin.$_$.qn;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var equals = kotlin_kotlin.$_$.sf;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var isBlank = kotlin_kotlin.$_$.dk;
  var toList = kotlin_kotlin.$_$.lc;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var HashSet_init_$Create$ = kotlin_kotlin.$_$.g4;
  var toHashSet = kotlin_kotlin.$_$.hc;
  var toBooleanArray = kotlin_kotlin.$_$.ec;
  var withIndex = kotlin_kotlin.$_$.wc;
  var to = kotlin_kotlin.$_$.ip;
  var lazy_0 = kotlin_kotlin.$_$.to;
  var contentEquals = kotlin_kotlin.$_$.f8;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var Long = kotlin_kotlin.$_$.kn;
  var Char = kotlin_kotlin.$_$.ym;
  var Duration__toIsoString_impl_9h6wsm = kotlin_kotlin.$_$.n;
  var Duration = kotlin_kotlin.$_$.om;
  var Companion_getInstance = kotlin_kotlin.$_$.d3;
  var Instant = kotlin_kotlin.$_$.pm;
  var Companion_getInstance_0 = kotlin_kotlin.$_$.e3;
  var Uuid = kotlin_kotlin.$_$.um;
  var Companion_getInstance_1 = kotlin_kotlin.$_$.g3;
  var toIntOrNull = kotlin_kotlin.$_$.xl;
  var hashCode = kotlin_kotlin.$_$.bg;
  var LinkedHashMap_init_$Create$_1 = kotlin_kotlin.$_$.k4;
  var ArrayList_init_$Create$_1 = kotlin_kotlin.$_$.b4;
  var HashSet_init_$Create$_0 = kotlin_kotlin.$_$.h4;
  var LinkedHashSet_init_$Create$ = kotlin_kotlin.$_$.m4;
  var LinkedHashSet_init_$Create$_0 = kotlin_kotlin.$_$.n4;
  var HashMap_init_$Create$ = kotlin_kotlin.$_$.d4;
  var HashMap_init_$Create$_0 = kotlin_kotlin.$_$.e4;
  var isArray = kotlin_kotlin.$_$.jg;
  var arrayIterator = kotlin_kotlin.$_$.ef;
  var until = kotlin_kotlin.$_$.mi;
  var step = kotlin_kotlin.$_$.li;
  var getValue = kotlin_kotlin.$_$.u9;
  var longArray = kotlin_kotlin.$_$.wg;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var get_lastIndex = kotlin_kotlin.$_$.ea;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var invert = kotlin_kotlin.$_$.qe;
  var countTrailingZeroBits = kotlin_kotlin.$_$.jo;
  var getOrNull = kotlin_kotlin.$_$.s9;
  var joinToString = kotlin_kotlin.$_$.aa;
  var indexOf = kotlin_kotlin.$_$.v9;
  var contentToString = kotlin_kotlin.$_$.l8;
  var Enum = kotlin_kotlin.$_$.en;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var KTypeParameter = kotlin_kotlin.$_$.zi;
  var HashSet_init_$Create$_1 = kotlin_kotlin.$_$.f4;
  var booleanArray = kotlin_kotlin.$_$.ff;
  var emptyMap = kotlin_kotlin.$_$.d9;
  var contentHashCode = kotlin_kotlin.$_$.j8;
  var ByteCompanionObject_instance = kotlin_kotlin.$_$.t2;
  var isByteArray = kotlin_kotlin.$_$.lg;
  var BooleanCompanionObject_instance = kotlin_kotlin.$_$.s2;
  var isBooleanArray = kotlin_kotlin.$_$.kg;
  var Companion_getInstance_2 = kotlin_kotlin.$_$.h3;
  var isCharArray = kotlin_kotlin.$_$.mg;
  var charArray = kotlin_kotlin.$_$.if;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.u2;
  var isDoubleArray = kotlin_kotlin.$_$.og;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var isFloatArray = kotlin_kotlin.$_$.pg;
  var IntCompanionObject_instance = kotlin_kotlin.$_$.w2;
  var isIntArray = kotlin_kotlin.$_$.qg;
  var Companion_getInstance_3 = kotlin_kotlin.$_$.i3;
  var isLongArray = kotlin_kotlin.$_$.re;
  var coerceAtLeast = kotlin_kotlin.$_$.wh;
  var copyOf = kotlin_kotlin.$_$.s8;
  var copyOf_0 = kotlin_kotlin.$_$.q8;
  var copyOf_1 = kotlin_kotlin.$_$.r8;
  var copyOf_2 = kotlin_kotlin.$_$.t8;
  var copyOf_3 = kotlin_kotlin.$_$.u8;
  var copyOf_4 = kotlin_kotlin.$_$.w8;
  var copyOf_5 = kotlin_kotlin.$_$.p8;
  var Companion_getInstance_4 = kotlin_kotlin.$_$.m3;
  var _ULongArray___get_size__impl__ju6dtr = kotlin_kotlin.$_$.e2;
  var ULongArray = kotlin_kotlin.$_$.yn;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.a2;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.c2;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var Companion_getInstance_5 = kotlin_kotlin.$_$.l3;
  var _UIntArray___get_size__impl__r6l8ci = kotlin_kotlin.$_$.u1;
  var UIntArray = kotlin_kotlin.$_$.wn;
  var _UIntArray___init__impl__ghjpc6 = kotlin_kotlin.$_$.q1;
  var _UInt___init__impl__l7qpdl = kotlin_kotlin.$_$.n1;
  var UIntArray__get_impl_gp5kza = kotlin_kotlin.$_$.s1;
  var _UInt___get_data__impl__f0vqqw = kotlin_kotlin.$_$.o1;
  var ShortCompanionObject_instance = kotlin_kotlin.$_$.x2;
  var isShortArray = kotlin_kotlin.$_$.sg;
  var Companion_getInstance_6 = kotlin_kotlin.$_$.n3;
  var _UShortArray___get_size__impl__jqto1b = kotlin_kotlin.$_$.n2;
  var UShortArray = kotlin_kotlin.$_$.ao;
  var _UShortArray___init__impl__9b26ef = kotlin_kotlin.$_$.j2;
  var _UShort___init__impl__jigrne = kotlin_kotlin.$_$.g2;
  var UShortArray__get_impl_fnbhmx = kotlin_kotlin.$_$.l2;
  var _UShort___get_data__impl__g0245 = kotlin_kotlin.$_$.h2;
  var Companion_getInstance_7 = kotlin_kotlin.$_$.k3;
  var _UByteArray___get_size__impl__h6pkdv = kotlin_kotlin.$_$.l1;
  var UByteArray = kotlin_kotlin.$_$.un;
  var _UByteArray___init__impl__ip4y9n = kotlin_kotlin.$_$.i1;
  var _UByte___init__impl__g9hnc4 = kotlin_kotlin.$_$.e1;
  var UByteArray__get_impl_t5f3hv = kotlin_kotlin.$_$.j1;
  var _UByte___get_data__impl__jof9qr = kotlin_kotlin.$_$.f1;
  var _ULongArray___get_storage__impl__28e64j = kotlin_kotlin.$_$.f2;
  var _ULongArray___init__impl__twm1l3_0 = kotlin_kotlin.$_$.b2;
  var ULongArray__set_impl_z19mvh = kotlin_kotlin.$_$.d2;
  var _UIntArray___get_storage__impl__92a0v0 = kotlin_kotlin.$_$.v1;
  var _UIntArray___init__impl__ghjpc6_0 = kotlin_kotlin.$_$.r1;
  var UIntArray__set_impl_7f2zu2 = kotlin_kotlin.$_$.t1;
  var copyOf_6 = kotlin_kotlin.$_$.o8;
  var _UShortArray___get_storage__impl__t2jpv5 = kotlin_kotlin.$_$.o2;
  var _UShortArray___init__impl__9b26ef_0 = kotlin_kotlin.$_$.k2;
  var UShortArray__set_impl_6d8whp = kotlin_kotlin.$_$.m2;
  var _UByteArray___get_storage__impl__d4kctt = kotlin_kotlin.$_$.m1;
  var _UByteArray___init__impl__ip4y9n_0 = kotlin_kotlin.$_$.h1;
  var UByteArray__set_impl_jvcicn = kotlin_kotlin.$_$.k1;
  var trimIndent = kotlin_kotlin.$_$.km;
  var Unit = kotlin_kotlin.$_$.co;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var lastOrNull = kotlin_kotlin.$_$.ka;
  var get_lastIndex_0 = kotlin_kotlin.$_$.fa;
  var last = kotlin_kotlin.$_$.na;
  var ULong = kotlin_kotlin.$_$.zn;
  var UInt = kotlin_kotlin.$_$.xn;
  var UByte = kotlin_kotlin.$_$.vn;
  var UShort = kotlin_kotlin.$_$.bo;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var get_js = kotlin_kotlin.$_$.ug;
  var PrimitiveClasses_getInstance = kotlin_kotlin.$_$.b3;
  var findAssociatedObject = kotlin_kotlin.$_$.b;
  var get_indices = kotlin_kotlin.$_$.y9;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var get_indices_0 = kotlin_kotlin.$_$.w9;
  var get_longArrayClass = kotlin_kotlin.$_$.se;
  var mapOf = kotlin_kotlin.$_$.wa;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  //endregion
  //region block: pre-declaration
  initMetadataForInterface(SerializationStrategy, 'SerializationStrategy');
  initMetadataForInterface(DeserializationStrategy, 'DeserializationStrategy');
  initMetadataForInterface(KSerializer, 'KSerializer', VOID, VOID, [SerializationStrategy, DeserializationStrategy]);
  initMetadataForClass(AbstractPolymorphicSerializer, 'AbstractPolymorphicSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PolymorphicSerializer, 'PolymorphicSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForClass(SealedClassSerializer$$inlined$groupingBy$1);
  initMetadataForClass(SealedClassSerializer, 'SealedClassSerializer', VOID, AbstractPolymorphicSerializer);
  initMetadataForInterface(StringFormat, 'StringFormat');
  initMetadataForInterface(BinaryFormat, 'BinaryFormat');
  initMetadataForClass(SerializationException, 'SerializationException', SerializationException_init_$Create$, IllegalArgumentException);
  initMetadataForClass(UnknownFieldException, 'UnknownFieldException', VOID, SerializationException);
  initMetadataForClass(MissingFieldException, 'MissingFieldException', VOID, SerializationException);
  function get_isNullable() {
    return false;
  }
  function get_isInline() {
    return false;
  }
  function get_annotations() {
    return emptyList();
  }
  initMetadataForInterface(SerialDescriptor, 'SerialDescriptor');
  initMetadataForClass(ContextDescriptor, 'ContextDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(elementNames$1);
  initMetadataForClass(elementNames$$inlined$Iterable$1);
  initMetadataForClass(elementDescriptors$1);
  initMetadataForClass(elementDescriptors$$inlined$Iterable$1);
  initMetadataForClass(ClassSerialDescriptorBuilder, 'ClassSerialDescriptorBuilder');
  initMetadataForInterface(CachedNames, 'CachedNames');
  initMetadataForClass(SerialDescriptorImpl, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(SerialKind, 'SerialKind');
  initMetadataForObject(ENUM, 'ENUM', VOID, SerialKind);
  initMetadataForObject(CONTEXTUAL, 'CONTEXTUAL', VOID, SerialKind);
  initMetadataForClass(PrimitiveKind, 'PrimitiveKind', VOID, SerialKind);
  initMetadataForObject(BOOLEAN, 'BOOLEAN', VOID, PrimitiveKind);
  initMetadataForObject(BYTE, 'BYTE', VOID, PrimitiveKind);
  initMetadataForObject(CHAR, 'CHAR', VOID, PrimitiveKind);
  initMetadataForObject(SHORT, 'SHORT', VOID, PrimitiveKind);
  initMetadataForObject(INT, 'INT', VOID, PrimitiveKind);
  initMetadataForObject(LONG, 'LONG', VOID, PrimitiveKind);
  initMetadataForObject(FLOAT, 'FLOAT', VOID, PrimitiveKind);
  initMetadataForObject(DOUBLE, 'DOUBLE', VOID, PrimitiveKind);
  initMetadataForObject(STRING, 'STRING', VOID, PrimitiveKind);
  initMetadataForClass(StructureKind, 'StructureKind', VOID, SerialKind);
  initMetadataForObject(CLASS, 'CLASS', VOID, StructureKind);
  initMetadataForObject(LIST, 'LIST', VOID, StructureKind);
  initMetadataForObject(MAP, 'MAP', VOID, StructureKind);
  initMetadataForObject(OBJECT, 'OBJECT', VOID, StructureKind);
  initMetadataForClass(PolymorphicKind, 'PolymorphicKind', VOID, SerialKind);
  initMetadataForObject(SEALED, 'SEALED', VOID, PolymorphicKind);
  initMetadataForObject(OPEN, 'OPEN', VOID, PolymorphicKind);
  function decodeSerializableValue(deserializer) {
    return deserializer.a71(this);
  }
  initMetadataForInterface(Decoder, 'Decoder');
  function decodeSequentially() {
    return false;
  }
  function decodeCollectionSize(descriptor) {
    return -1;
  }
  function decodeSerializableElement$default(descriptor, index, deserializer, previousValue, $super) {
    previousValue = previousValue === VOID ? null : previousValue;
    return $super === VOID ? this.z74(descriptor, index, deserializer, previousValue) : $super.z74.call(this, descriptor, index, deserializer, previousValue);
  }
  initMetadataForInterface(CompositeDecoder, 'CompositeDecoder');
  initMetadataForClass(AbstractDecoder, 'AbstractDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  function encodeNotNullMark() {
  }
  function beginCollection(descriptor, collectionSize) {
    return this.n74(descriptor);
  }
  function encodeSerializableValue(serializer, value) {
    serializer.z70(this, value);
  }
  function encodeNullableSerializableValue(serializer, value) {
    var isNullabilitySupported = serializer.y70().n72();
    if (isNullabilitySupported) {
      return this.f76(isInterface(serializer, SerializationStrategy) ? serializer : THROW_CCE(), value);
    }
    if (value == null) {
      this.i75();
    } else {
      this.i76();
      this.f76(serializer, value);
    }
  }
  initMetadataForInterface(Encoder, 'Encoder');
  function shouldEncodeElementDefault(descriptor, index) {
    return true;
  }
  initMetadataForInterface(CompositeEncoder, 'CompositeEncoder');
  initMetadataForClass(AbstractEncoder, 'AbstractEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForObject(NothingSerializer_0, 'NothingSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DurationSerializer, 'DurationSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(InstantSerializer, 'InstantSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UuidSerializer, 'UuidSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapLikeDescriptor, 'MapLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(LinkedHashMapClassDesc, 'LinkedHashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ListLikeDescriptor, 'ListLikeDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(ArrayListClassDesc, 'ArrayListClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashSetClassDesc, 'HashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(LinkedHashSetClassDesc, 'LinkedHashSetClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(HashMapClassDesc, 'HashMapClassDesc', VOID, MapLikeDescriptor);
  initMetadataForClass(ArrayClassDesc, 'ArrayClassDesc', VOID, ListLikeDescriptor);
  initMetadataForClass(PrimitiveArrayDescriptor, 'PrimitiveArrayDescriptor', VOID, ListLikeDescriptor);
  initMetadataForClass(AbstractCollectionSerializer, 'AbstractCollectionSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapLikeSerializer, 'MapLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(LinkedHashMapSerializer, 'LinkedHashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(CollectionLikeSerializer, 'CollectionLikeSerializer', VOID, AbstractCollectionSerializer);
  initMetadataForClass(CollectionSerializer, 'CollectionSerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(ArrayListSerializer, 'ArrayListSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashSetSerializer, 'HashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(LinkedHashSetSerializer, 'LinkedHashSetSerializer', VOID, CollectionSerializer);
  initMetadataForClass(HashMapSerializer, 'HashMapSerializer', VOID, MapLikeSerializer);
  initMetadataForClass(ReferenceArraySerializer, 'ReferenceArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArraySerializer, 'PrimitiveArraySerializer', VOID, CollectionLikeSerializer);
  initMetadataForClass(PrimitiveArrayBuilder, 'PrimitiveArrayBuilder');
  initMetadataForCompanion(Companion);
  initMetadataForClass(ElementMarker, 'ElementMarker');
  initMetadataForClass(PluginGeneratedSerialDescriptor, 'PluginGeneratedSerialDescriptor', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(EnumDescriptor, 'EnumDescriptor', VOID, PluginGeneratedSerialDescriptor);
  initMetadataForClass(EnumSerializer, 'EnumSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlineClassDescriptor, 'InlineClassDescriptor', VOID, PluginGeneratedSerialDescriptor);
  function typeParametersSerializers() {
    return get_EMPTY_SERIALIZER_ARRAY();
  }
  initMetadataForInterface(GeneratedSerializer, 'GeneratedSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(InlinePrimitiveDescriptor$1, VOID, VOID, VOID, [GeneratedSerializer]);
  initMetadataForObject(NoOpEncoder, 'NoOpEncoder', VOID, AbstractEncoder);
  initMetadataForObject(NothingSerialDescriptor, 'NothingSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForClass(NullableSerializer, 'NullableSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerialDescriptorForNullable, 'SerialDescriptorForNullable', VOID, VOID, [SerialDescriptor, CachedNames]);
  initMetadataForClass(ObjectSerializer, 'ObjectSerializer', VOID, VOID, [KSerializer]);
  initMetadataForInterface(SerializerFactory, 'SerializerFactory');
  initMetadataForObject(ByteArraySerializer_0, 'ByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(BooleanArraySerializer_0, 'BooleanArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(CharArraySerializer_0, 'CharArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(DoubleArraySerializer_0, 'DoubleArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(FloatArraySerializer_0, 'FloatArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(IntArraySerializer_0, 'IntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(LongArraySerializer_0, 'LongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForClass(ByteArrayBuilder, 'ByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(BooleanArrayBuilder, 'BooleanArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(CharArrayBuilder, 'CharArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(DoubleArrayBuilder, 'DoubleArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(FloatArrayBuilder, 'FloatArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(IntArrayBuilder, 'IntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(LongArrayBuilder, 'LongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(ULongArraySerializer_0, 'ULongArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UIntArraySerializer_0, 'UIntArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(ShortArraySerializer_0, 'ShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UShortArraySerializer_0, 'UShortArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForObject(UByteArraySerializer_0, 'UByteArraySerializer', VOID, PrimitiveArraySerializer, [KSerializer]);
  initMetadataForClass(ULongArrayBuilder, 'ULongArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UIntArrayBuilder, 'UIntArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(ShortArrayBuilder, 'ShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UShortArrayBuilder, 'UShortArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForClass(UByteArrayBuilder, 'UByteArrayBuilder', VOID, PrimitiveArrayBuilder);
  initMetadataForObject(StringSerializer, 'StringSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ByteSerializer, 'ByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(LongSerializer, 'LongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(DoubleSerializer, 'DoubleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(IntSerializer, 'IntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(BooleanSerializer, 'BooleanSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(FloatSerializer, 'FloatSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(PrimitiveSerialDescriptor_0, 'PrimitiveSerialDescriptor', VOID, VOID, [SerialDescriptor]);
  initMetadataForObject(CharSerializer, 'CharSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ShortSerializer, 'ShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UnitSerializer, 'UnitSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(TaggedDecoder, 'TaggedDecoder', VOID, VOID, [Decoder, CompositeDecoder]);
  initMetadataForClass(NamedValueDecoder, 'NamedValueDecoder', VOID, TaggedDecoder);
  initMetadataForClass(TaggedEncoder, 'TaggedEncoder', VOID, VOID, [Encoder, CompositeEncoder]);
  initMetadataForClass(NamedValueEncoder, 'NamedValueEncoder', VOID, TaggedEncoder);
  initMetadataForClass(MapEntry, 'MapEntry', VOID, VOID, [Entry]);
  initMetadataForClass(KeyValueSerializer, 'KeyValueSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(MapEntrySerializer_0, 'MapEntrySerializer', VOID, KeyValueSerializer);
  initMetadataForClass(PairSerializer_0, 'PairSerializer', VOID, KeyValueSerializer);
  initMetadataForClass(TripleSerializer_0, 'TripleSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(ULongSerializer, 'ULongSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UIntSerializer, 'UIntSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UByteSerializer, 'UByteSerializer', VOID, VOID, [KSerializer]);
  initMetadataForObject(UShortSerializer, 'UShortSerializer', VOID, VOID, [KSerializer]);
  initMetadataForClass(SerializersModule, 'SerializersModule');
  initMetadataForClass(SerialModuleImpl, 'SerialModuleImpl', VOID, SerializersModule);
  initMetadataForClass(ContextualProvider, 'ContextualProvider');
  initMetadataForClass(Argless, 'Argless', VOID, ContextualProvider);
  initMetadataForClass(WithTypeArguments, 'WithTypeArguments', VOID, ContextualProvider);
  function contextual(kClass, serializer) {
    return this.y7l(kClass, SerializersModuleCollector$contextual$lambda(serializer));
  }
  initMetadataForInterface(SerializersModuleCollector, 'SerializersModuleCollector');
  initMetadataForClass(SerializableWith, 'SerializableWith', VOID, VOID, VOID, VOID, 0);
  initMetadataForClass(createCache$1);
  initMetadataForClass(createParametrizedCache$1);
  //endregion
  function KSerializer() {
  }
  function SerializationStrategy() {
  }
  function DeserializationStrategy() {
  }
  function findPolymorphicSerializer(_this__u8e3s4, decoder, klassName) {
    var tmp0_elvis_lhs = _this__u8e3s4.b71(decoder, klassName);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered(klassName, _this__u8e3s4.c71());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function findPolymorphicSerializer_0(_this__u8e3s4, encoder, value) {
    var tmp0_elvis_lhs = _this__u8e3s4.d71(encoder, value);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throwSubtypeNotRegistered_0(getKClassFromExpression(value), _this__u8e3s4.c71());
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.m71('type', serializer_2(StringCompanionObject_instance).y70());
      $this$buildSerialDescriptor.m71('value', buildSerialDescriptor('kotlinx.serialization.Polymorphic<' + this$0.n71_1.o() + '>', CONTEXTUAL_getInstance(), []));
      $this$buildSerialDescriptor.g71_1 = this$0.o71_1;
      return Unit_instance;
    };
  }
  function PolymorphicSerializer$descriptor$delegate$lambda(this$0) {
    return function () {
      var tmp = OPEN_getInstance();
      return withContext(buildSerialDescriptor('kotlinx.serialization.Polymorphic', tmp, [], PolymorphicSerializer$descriptor$delegate$lambda$lambda(this$0)), this$0.n71_1);
    };
  }
  function PolymorphicSerializer$_get_descriptor_$ref_8tw9if() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 22);
  }
  function PolymorphicSerializer(baseClass) {
    AbstractPolymorphicSerializer.call(this);
    this.n71_1 = baseClass;
    this.o71_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.p71_1 = lazy(tmp_0, PolymorphicSerializer$descriptor$delegate$lambda(this));
  }
  protoOf(PolymorphicSerializer).c71 = function () {
    return this.n71_1;
  };
  protoOf(PolymorphicSerializer).y70 = function () {
    var tmp0 = this.p71_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, PolymorphicSerializer$_get_descriptor_$ref_8tw9if(), null);
    return tmp0.u1();
  };
  protoOf(PolymorphicSerializer).toString = function () {
    return 'kotlinx.serialization.PolymorphicSerializer(baseClass: ' + toString(this.n71_1) + ')';
  };
  function SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, $this) {
    SealedClassSerializer.call($this, serialName, baseClass, subclasses, subclassSerializers);
    $this.s71_1 = asList(classAnnotations);
    return $this;
  }
  function SealedClassSerializer_init_$Create$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations) {
    return SealedClassSerializer_init_$Init$(serialName, baseClass, subclasses, subclassSerializers, classAnnotations, objectCreate(protoOf(SealedClassSerializer)));
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s = this$0.v71_1.s1().t();
      while (_iterator__ex2g4s.u()) {
        var element = _iterator__ex2g4s.v();
        // Inline function 'kotlin.collections.component1' call
        var name = element.t1();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element.u1();
        $this$buildSerialDescriptor.m71(name, serializer.y70());
      }
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.m71('type', serializer_2(StringCompanionObject_instance).y70());
      var tmp = 'kotlinx.serialization.Sealed<' + this$0.r71_1.o() + '>';
      var tmp_0 = CONTEXTUAL_getInstance();
      var elementDescriptor = buildSerialDescriptor(tmp, tmp_0, [], SealedClassSerializer$descriptor$delegate$lambda$lambda$lambda(this$0));
      $this$buildSerialDescriptor.m71('value', elementDescriptor);
      $this$buildSerialDescriptor.g71_1 = this$0.s71_1;
      return Unit_instance;
    };
  }
  function SealedClassSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = SEALED_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], SealedClassSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function SealedClassSerializer$_get_descriptor_$ref_m511rz() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 23);
  }
  function SealedClassSerializer$$inlined$groupingBy$1($this) {
    this.w71_1 = $this;
  }
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).x71 = function () {
    return this.w71_1.t();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).y71 = function (element) {
    return element.u1().y70().z71();
  };
  protoOf(SealedClassSerializer$$inlined$groupingBy$1).a72 = function (element) {
    return this.y71(element);
  };
  function SealedClassSerializer(serialName, baseClass, subclasses, subclassSerializers) {
    AbstractPolymorphicSerializer.call(this);
    this.r71_1 = baseClass;
    this.s71_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.t71_1 = lazy(tmp_0, SealedClassSerializer$descriptor$delegate$lambda(serialName, this));
    if (!(subclasses.length === subclassSerializers.length)) {
      throw IllegalArgumentException_init_$Create$('All subclasses of sealed class ' + this.r71_1.o() + ' should be marked @Serializable');
    }
    this.u71_1 = toMap(zip(subclasses, subclassSerializers));
    var tmp_1 = this;
    // Inline function 'kotlin.collections.groupingBy' call
    var this_0 = this.u71_1.s1();
    // Inline function 'kotlin.collections.aggregate' call
    var tmp0 = new SealedClassSerializer$$inlined$groupingBy$1(this_0);
    // Inline function 'kotlin.collections.mutableMapOf' call
    // Inline function 'kotlin.collections.aggregateTo' call
    var destination = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp0.x71();
    while (_iterator__ex2g4s.u()) {
      var e = _iterator__ex2g4s.v();
      var key = tmp0.a72(e);
      var accumulator = destination.w2(key);
      accumulator == null && !destination.u2(key);
      if (!(accumulator == null)) {
        // Inline function 'kotlin.error' call
        var message = "Multiple sealed subclasses of '" + toString(this.r71_1) + "' have the same serial name '" + key + "':" + (" '" + toString(accumulator.t1()) + "', '" + toString(e.t1()) + "'");
        throw IllegalStateException_init_$Create$(toString(message));
      }
      // Inline function 'kotlin.collections.set' call
      destination.z2(key, e);
    }
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination_0 = LinkedHashMap_init_$Create$_0(mapCapacity(destination.n1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s_0 = destination.s1().t();
    while (_iterator__ex2g4s_0.u()) {
      var element = _iterator__ex2g4s_0.v();
      var tmp_2 = element.t1();
      var tmp$ret$12 = element.u1().u1();
      destination_0.z2(tmp_2, tmp$ret$12);
    }
    tmp_1.v71_1 = destination_0;
  }
  protoOf(SealedClassSerializer).c71 = function () {
    return this.r71_1;
  };
  protoOf(SealedClassSerializer).y70 = function () {
    var tmp0 = this.t71_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, SealedClassSerializer$_get_descriptor_$ref_m511rz(), null);
    return tmp0.u1();
  };
  protoOf(SealedClassSerializer).b71 = function (decoder, klassName) {
    // Inline function 'kotlin.collections.get' call
    var this_0 = this.v71_1;
    var tmp0_elvis_lhs = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).w2(klassName);
    return tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).b71.call(this, decoder, klassName) : tmp0_elvis_lhs;
  };
  protoOf(SealedClassSerializer).d71 = function (encoder, value) {
    var tmp0_elvis_lhs = this.u71_1.w2(getKClassFromExpression(value));
    var tmp1_safe_receiver = tmp0_elvis_lhs == null ? protoOf(AbstractPolymorphicSerializer).d71.call(this, encoder, value) : tmp0_elvis_lhs;
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, SerializationStrategy) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  };
  function StringFormat() {
  }
  function BinaryFormat() {
  }
  function UnknownFieldException_init_$Init$(index, $this) {
    UnknownFieldException.call($this, 'An unknown field for index ' + index);
    return $this;
  }
  function UnknownFieldException_init_$Create$(index) {
    var tmp = UnknownFieldException_init_$Init$(index, objectCreate(protoOf(UnknownFieldException)));
    captureStack(tmp, UnknownFieldException_init_$Create$);
    return tmp;
  }
  function UnknownFieldException(message) {
    SerializationException_init_$Init$_0(message, this);
    captureStack(this, UnknownFieldException);
  }
  function MissingFieldException_init_$Init$(missingFields, serialName, $this) {
    var tmp0_message = missingFields.n1() === 1 ? "Field '" + missingFields.l1(0) + "' is required for type with serial name '" + serialName + "', but it was missing" : 'Fields ' + toString(missingFields) + " are required for type with serial name '" + serialName + "', but they were missing";
    MissingFieldException.call($this, tmp0_message, null, missingFields, serialName);
    return $this;
  }
  function MissingFieldException_init_$Create$(missingFields, serialName) {
    var tmp = MissingFieldException_init_$Init$(missingFields, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$);
    return tmp;
  }
  function MissingFieldException_init_$Init$_0(missingField, serialName, $this) {
    var tmp0_missingFields = listOf(missingField);
    var tmp1_message = "Field '" + missingField + "' is required for type with serial name '" + serialName + "', but it was missing";
    MissingFieldException.call($this, tmp1_message, null, tmp0_missingFields, serialName);
    return $this;
  }
  function MissingFieldException_init_$Create$_0(missingField, serialName) {
    var tmp = MissingFieldException_init_$Init$_0(missingField, serialName, objectCreate(protoOf(MissingFieldException)));
    captureStack(tmp, MissingFieldException_init_$Create$_0);
    return tmp;
  }
  function MissingFieldException(message, cause, missingFields, serialName) {
    SerializationException_init_$Init$_1(message, cause, this);
    captureStack(this, MissingFieldException);
    this.f72_1 = missingFields;
    this.g72_1 = serialName;
  }
  protoOf(MissingFieldException).h72 = function (newMessage) {
    return new MissingFieldException(newMessage, this, this.f72_1, this.g72_1);
  };
  function SerializationException_init_$Init$($this) {
    IllegalArgumentException_init_$Init$($this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$() {
    var tmp = SerializationException_init_$Init$(objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$);
    return tmp;
  }
  function SerializationException_init_$Init$_0(message, $this) {
    IllegalArgumentException_init_$Init$_0(message, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException_init_$Create$_0(message) {
    var tmp = SerializationException_init_$Init$_0(message, objectCreate(protoOf(SerializationException)));
    captureStack(tmp, SerializationException_init_$Create$_0);
    return tmp;
  }
  function SerializationException_init_$Init$_1(message, cause, $this) {
    IllegalArgumentException_init_$Init$_1(message, cause, $this);
    SerializationException.call($this);
    return $this;
  }
  function SerializationException() {
    captureStack(this, SerializationException);
  }
  function serializer(_this__u8e3s4, type) {
    var tmp0_elvis_lhs = serializerByKTypeImpl(_this__u8e3s4, type, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      platformSpecificSerializerNotRegistered(kclass(type));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl(_this__u8e3s4, type, failOnMissingTypeArgSerializer) {
    var rootClass = kclass(type);
    var isNullable = type.l();
    // Inline function 'kotlin.collections.map' call
    var this_0 = type.k();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var _iterator__ex2g4s = this_0.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$2 = typeOrThrow(item);
      destination.j1(tmp$ret$2);
    }
    var typeArguments = destination;
    var tmp;
    if (typeArguments.r()) {
      var tmp_0;
      if (isInterface_0(rootClass) && !(_this__u8e3s4.j72(rootClass) == null)) {
        tmp_0 = null;
      } else {
        tmp_0 = findCachedSerializer(rootClass, isNullable);
      }
      tmp = tmp_0;
    } else {
      var tmp_1;
      if (_this__u8e3s4.i72()) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.Result.getOrNull' call
        var this_1 = findParametrizedCachedSerializer(rootClass, typeArguments, isNullable);
        tmp_1 = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
      }
      tmp = tmp_1;
    }
    var cachedSerializer = tmp;
    if (!(cachedSerializer == null))
      return cachedSerializer;
    var tmp_2;
    if (typeArguments.r()) {
      var tmp0_elvis_lhs = serializerOrNull(rootClass);
      var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? _this__u8e3s4.j72(rootClass) : tmp0_elvis_lhs;
      var tmp_3;
      if (tmp1_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_3 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_3 = tmp1_elvis_lhs;
      }
      tmp_2 = tmp_3;
    } else {
      var tmp2_elvis_lhs = serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer);
      var tmp_4;
      if (tmp2_elvis_lhs == null) {
        return null;
      } else {
        tmp_4 = tmp2_elvis_lhs;
      }
      var serializers = tmp_4;
      var tmp3_elvis_lhs = parametrizedSerializerOrNull(rootClass, serializers, serializerByKTypeImpl$lambda(typeArguments));
      var tmp4_elvis_lhs = tmp3_elvis_lhs == null ? _this__u8e3s4.k72(rootClass, serializers) : tmp3_elvis_lhs;
      var tmp_5;
      if (tmp4_elvis_lhs == null) {
        // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
        tmp_5 = isInterface_0(rootClass) ? new PolymorphicSerializer(rootClass) : null;
      } else {
        tmp_5 = tmp4_elvis_lhs;
      }
      tmp_2 = tmp_5;
    }
    var contextualSerializer = tmp_2;
    var tmp_6;
    if (contextualSerializer == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_6 = isInterface(contextualSerializer, KSerializer) ? contextualSerializer : THROW_CCE();
    }
    var tmp6_safe_receiver = tmp_6;
    return tmp6_safe_receiver == null ? null : nullable(tmp6_safe_receiver, isNullable);
  }
  function serializerOrNull(_this__u8e3s4) {
    var tmp0_elvis_lhs = compiledSerializerImpl(_this__u8e3s4);
    return tmp0_elvis_lhs == null ? builtinSerializerOrNull(_this__u8e3s4) : tmp0_elvis_lhs;
  }
  function serializersForParameters(_this__u8e3s4, typeArguments, failOnMissingTypeArgSerializer) {
    var tmp;
    if (failOnMissingTypeArgSerializer) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s = typeArguments.t();
      while (_iterator__ex2g4s.u()) {
        var item = _iterator__ex2g4s.v();
        var tmp$ret$2 = serializer(_this__u8e3s4, item);
        destination.j1(tmp$ret$2);
      }
      tmp = destination;
    } else {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(typeArguments, 10));
      var _iterator__ex2g4s_0 = typeArguments.t();
      while (_iterator__ex2g4s_0.u()) {
        var item_0 = _iterator__ex2g4s_0.v();
        var tmp0_elvis_lhs = serializerOrNull_0(_this__u8e3s4, item_0);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          return null;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var tmp$ret$5 = tmp_0;
        destination_0.j1(tmp$ret$5);
      }
      tmp = destination_0;
    }
    var serializers = tmp;
    return serializers;
  }
  function parametrizedSerializerOrNull(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp0_elvis_lhs = builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray);
    return tmp0_elvis_lhs == null ? compiledParametrizedSerializer(_this__u8e3s4, serializers) : tmp0_elvis_lhs;
  }
  function nullable(_this__u8e3s4, shouldBeNullable) {
    if (shouldBeNullable)
      return get_nullable(_this__u8e3s4);
    return isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
  }
  function serializerOrNull_0(_this__u8e3s4, type) {
    return serializerByKTypeImpl(_this__u8e3s4, type, false);
  }
  function builtinParametrizedSerializer(_this__u8e3s4, serializers, elementClassifierIfArray) {
    var tmp;
    if (_this__u8e3s4.equals(getKClass(Collection)) || _this__u8e3s4.equals(getKClass(KtList)) || (_this__u8e3s4.equals(getKClass(KtMutableList)) || _this__u8e3s4.equals(getKClass(ArrayList)))) {
      tmp = new ArrayListSerializer(serializers.l1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashSet))) {
      tmp = new HashSetSerializer(serializers.l1(0));
    } else if (_this__u8e3s4.equals(getKClass(KtSet)) || (_this__u8e3s4.equals(getKClass(KtMutableSet)) || _this__u8e3s4.equals(getKClass(LinkedHashSet)))) {
      tmp = new LinkedHashSetSerializer(serializers.l1(0));
    } else if (_this__u8e3s4.equals(getKClass(HashMap))) {
      tmp = new HashMapSerializer(serializers.l1(0), serializers.l1(1));
    } else if (_this__u8e3s4.equals(getKClass(KtMap)) || (_this__u8e3s4.equals(getKClass(KtMutableMap)) || _this__u8e3s4.equals(getKClass(LinkedHashMap)))) {
      tmp = new LinkedHashMapSerializer(serializers.l1(0), serializers.l1(1));
    } else if (_this__u8e3s4.equals(getKClass(Entry))) {
      tmp = MapEntrySerializer(serializers.l1(0), serializers.l1(1));
    } else if (_this__u8e3s4.equals(getKClass(Pair))) {
      tmp = PairSerializer(serializers.l1(0), serializers.l1(1));
    } else if (_this__u8e3s4.equals(getKClass(Triple))) {
      tmp = TripleSerializer(serializers.l1(0), serializers.l1(1), serializers.l1(2));
    } else {
      var tmp_0;
      if (isReferenceArray(_this__u8e3s4)) {
        var tmp_1 = elementClassifierIfArray();
        tmp_0 = ArraySerializer((!(tmp_1 == null) ? isInterface(tmp_1, KClass) : false) ? tmp_1 : THROW_CCE(), serializers.l1(0));
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function compiledParametrizedSerializer(_this__u8e3s4, serializers) {
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$0 = copyToArray(serializers);
    return constructSerializerForGivenTypeArgs(_this__u8e3s4, tmp$ret$0.slice());
  }
  function serializer_0(type) {
    return serializer(EmptySerializersModule_0(), type);
  }
  function serializer_1(_this__u8e3s4) {
    var tmp0_elvis_lhs = serializerOrNull(_this__u8e3s4);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      serializerNotRegistered(_this__u8e3s4);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function serializerByKTypeImpl$lambda($typeArguments) {
    return function () {
      return $typeArguments.l1(0).j();
    };
  }
  function get_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE;
  }
  var SERIALIZERS_CACHE;
  function get_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return SERIALIZERS_CACHE_NULLABLE;
  }
  var SERIALIZERS_CACHE_NULLABLE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE;
  function get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE() {
    _init_properties_SerializersCache_kt__hgwi2p();
    return PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  }
  var PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE;
  function findCachedSerializer(clazz, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp0_safe_receiver = get_SERIALIZERS_CACHE().l72(clazz);
      var tmp_0;
      if (tmp0_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlinx.serialization.internal.cast' call
        tmp_0 = isInterface(tmp0_safe_receiver, KSerializer) ? tmp0_safe_receiver : THROW_CCE();
      }
      tmp = tmp_0;
    } else {
      tmp = get_SERIALIZERS_CACHE_NULLABLE().l72(clazz);
    }
    return tmp;
  }
  function findParametrizedCachedSerializer(clazz, types, isNullable) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp;
    if (!isNullable) {
      var tmp_0 = get_PARAMETRIZED_SERIALIZERS_CACHE().m72(clazz, types);
      tmp = new Result(tmp_0) instanceof Result ? tmp_0 : THROW_CCE();
    } else {
      tmp = get_PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE().m72(clazz, types);
    }
    return tmp;
  }
  function SERIALIZERS_CACHE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function SERIALIZERS_CACHE_NULLABLE$lambda(it) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var tmp0_elvis_lhs = serializerOrNull(it);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlinx.serialization.polymorphicIfInterface' call
      tmp = isInterface_0(it) ? new PolymorphicSerializer(it) : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var tmp1_safe_receiver = tmp;
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_nullable(tmp1_safe_receiver);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp_0 = isInterface(tmp2_safe_receiver, KSerializer) ? tmp2_safe_receiver : THROW_CCE();
    }
    return tmp_0;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    return parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda(types));
  }
  function PARAMETRIZED_SERIALIZERS_CACHE$lambda$lambda($types) {
    return function () {
      return $types.l1(0).j();
    };
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda(clazz, types) {
    _init_properties_SerializersCache_kt__hgwi2p();
    var serializers = ensureNotNull(serializersForParameters(EmptySerializersModule_0(), types, true));
    var tmp0_safe_receiver = parametrizedSerializerOrNull(clazz, serializers, PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda(types));
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : get_nullable(tmp0_safe_receiver);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlinx.serialization.internal.cast' call
      tmp = isInterface(tmp1_safe_receiver, KSerializer) ? tmp1_safe_receiver : THROW_CCE();
    }
    return tmp;
  }
  function PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda$lambda($types) {
    return function () {
      return $types.l1(0).j();
    };
  }
  var properties_initialized_SerializersCache_kt_q8kf25;
  function _init_properties_SerializersCache_kt__hgwi2p() {
    if (!properties_initialized_SerializersCache_kt_q8kf25) {
      properties_initialized_SerializersCache_kt_q8kf25 = true;
      SERIALIZERS_CACHE = createCache(SERIALIZERS_CACHE$lambda);
      SERIALIZERS_CACHE_NULLABLE = createCache(SERIALIZERS_CACHE_NULLABLE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE$lambda);
      PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE = createParametrizedCache(PARAMETRIZED_SERIALIZERS_CACHE_NULLABLE$lambda);
    }
  }
  function get_nullable(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4.y70().n72()) {
      tmp = isInterface(_this__u8e3s4, KSerializer) ? _this__u8e3s4 : THROW_CCE();
    } else {
      tmp = new NullableSerializer(_this__u8e3s4);
    }
    return tmp;
  }
  function ListSerializer(elementSerializer) {
    return new ArrayListSerializer(elementSerializer);
  }
  function serializer_2(_this__u8e3s4) {
    return StringSerializer_getInstance();
  }
  function serializer_3(_this__u8e3s4) {
    return IntSerializer_getInstance();
  }
  function BooleanArraySerializer() {
    return BooleanArraySerializer_getInstance();
  }
  function CharArraySerializer() {
    return CharArraySerializer_getInstance();
  }
  function DoubleArraySerializer() {
    return DoubleArraySerializer_getInstance();
  }
  function FloatArraySerializer() {
    return FloatArraySerializer_getInstance();
  }
  function IntArraySerializer() {
    return IntArraySerializer_getInstance();
  }
  function LongArraySerializer() {
    return LongArraySerializer_getInstance();
  }
  function serializer_4(_this__u8e3s4) {
    return ULongSerializer_getInstance();
  }
  function MapSerializer(keySerializer, valueSerializer) {
    return new LinkedHashMapSerializer(keySerializer, valueSerializer);
  }
  function serializer_5(_this__u8e3s4) {
    return UIntSerializer_getInstance();
  }
  function serializer_6(_this__u8e3s4) {
    return UByteSerializer_getInstance();
  }
  function serializer_7(_this__u8e3s4) {
    return UShortSerializer_getInstance();
  }
  function NothingSerializer() {
    return NothingSerializer_getInstance();
  }
  function ByteArraySerializer() {
    return ByteArraySerializer_getInstance();
  }
  function MapEntrySerializer(keySerializer, valueSerializer) {
    return new MapEntrySerializer_0(keySerializer, valueSerializer);
  }
  function PairSerializer(keySerializer, valueSerializer) {
    return new PairSerializer_0(keySerializer, valueSerializer);
  }
  function TripleSerializer(aSerializer, bSerializer, cSerializer) {
    return new TripleSerializer_0(aSerializer, bSerializer, cSerializer);
  }
  function ArraySerializer(kClass, elementSerializer) {
    return new ReferenceArraySerializer(kClass, elementSerializer);
  }
  function serializer_8(_this__u8e3s4) {
    return ByteSerializer_getInstance();
  }
  function serializer_9(_this__u8e3s4) {
    return BooleanSerializer_getInstance();
  }
  function serializer_10(_this__u8e3s4) {
    return CharSerializer_getInstance();
  }
  function serializer_11(_this__u8e3s4) {
    return DoubleSerializer_getInstance();
  }
  function serializer_12(_this__u8e3s4) {
    return FloatSerializer_getInstance();
  }
  function serializer_13(_this__u8e3s4) {
    return LongSerializer_getInstance();
  }
  function serializer_14(_this__u8e3s4) {
    return ShortSerializer_getInstance();
  }
  function ULongArraySerializer() {
    return ULongArraySerializer_getInstance();
  }
  function UIntArraySerializer() {
    return UIntArraySerializer_getInstance();
  }
  function ShortArraySerializer() {
    return ShortArraySerializer_getInstance();
  }
  function UShortArraySerializer() {
    return UShortArraySerializer_getInstance();
  }
  function UByteArraySerializer() {
    return UByteArraySerializer_getInstance();
  }
  function serializer_15(_this__u8e3s4) {
    return UnitSerializer_getInstance();
  }
  function serializer_16(_this__u8e3s4) {
    return DurationSerializer_getInstance();
  }
  function serializer_17(_this__u8e3s4) {
    return InstantSerializer_getInstance();
  }
  function serializer_18(_this__u8e3s4) {
    return UuidSerializer_getInstance();
  }
  function SetSerializer(elementSerializer) {
    return new LinkedHashSetSerializer(elementSerializer);
  }
  function getContextualDescriptor(_this__u8e3s4, descriptor) {
    var tmp0_safe_receiver = get_capturedKClass(descriptor);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      var tmp0_safe_receiver_0 = _this__u8e3s4.j72(tmp0_safe_receiver);
      tmp = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.y70();
    }
    return tmp;
  }
  function withContext(_this__u8e3s4, context) {
    return new ContextDescriptor(_this__u8e3s4, context);
  }
  function get_capturedKClass(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof ContextDescriptor) {
      tmp = _this__u8e3s4.s72_1;
    } else {
      if (_this__u8e3s4 instanceof SerialDescriptorForNullable) {
        tmp = get_capturedKClass(_this__u8e3s4.o72_1);
      } else {
        tmp = null;
      }
    }
    return tmp;
  }
  function ContextDescriptor(original, kClass) {
    this.r72_1 = original;
    this.s72_1 = kClass;
    this.t72_1 = this.r72_1.z71() + '<' + this.s72_1.o() + '>';
  }
  protoOf(ContextDescriptor).z71 = function () {
    return this.t72_1;
  };
  protoOf(ContextDescriptor).equals = function (other) {
    var tmp0_elvis_lhs = other instanceof ContextDescriptor ? other : null;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var another = tmp;
    return equals(this.r72_1, another.r72_1) && another.s72_1.equals(this.s72_1);
  };
  protoOf(ContextDescriptor).hashCode = function () {
    var result = this.s72_1.hashCode();
    result = imul(31, result) + getStringHashCode(this.t72_1) | 0;
    return result;
  };
  protoOf(ContextDescriptor).toString = function () {
    return 'ContextDescriptor(kClass: ' + toString(this.s72_1) + ', original: ' + toString(this.r72_1) + ')';
  };
  protoOf(ContextDescriptor).u72 = function () {
    return this.r72_1.u72();
  };
  protoOf(ContextDescriptor).n72 = function () {
    return this.r72_1.n72();
  };
  protoOf(ContextDescriptor).v72 = function () {
    return this.r72_1.v72();
  };
  protoOf(ContextDescriptor).w72 = function () {
    return this.r72_1.w72();
  };
  protoOf(ContextDescriptor).x72 = function () {
    return this.r72_1.x72();
  };
  protoOf(ContextDescriptor).y72 = function (index) {
    return this.r72_1.y72(index);
  };
  protoOf(ContextDescriptor).z72 = function (name) {
    return this.r72_1.z72(name);
  };
  protoOf(ContextDescriptor).a73 = function (index) {
    return this.r72_1.a73(index);
  };
  protoOf(ContextDescriptor).b73 = function (index) {
    return this.r72_1.b73(index);
  };
  protoOf(ContextDescriptor).c73 = function (index) {
    return this.r72_1.c73(index);
  };
  function SerialDescriptor() {
  }
  function get_elementNames(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementNames$$inlined$Iterable$1(_this__u8e3s4);
  }
  function get_elementDescriptors(_this__u8e3s4) {
    // Inline function 'kotlin.collections.Iterable' call
    return new elementDescriptors$$inlined$Iterable$1(_this__u8e3s4);
  }
  function elementNames$1($this_elementNames) {
    this.e73_1 = $this_elementNames;
    this.d73_1 = $this_elementNames.w72();
  }
  protoOf(elementNames$1).u = function () {
    return this.d73_1 > 0;
  };
  protoOf(elementNames$1).v = function () {
    var tmp = this.e73_1.w72();
    var _unary__edvuaz = this.d73_1;
    this.d73_1 = _unary__edvuaz - 1 | 0;
    return this.e73_1.y72(tmp - _unary__edvuaz | 0);
  };
  function elementNames$$inlined$Iterable$1($this_elementNames) {
    this.f73_1 = $this_elementNames;
  }
  protoOf(elementNames$$inlined$Iterable$1).t = function () {
    return new elementNames$1(this.f73_1);
  };
  function elementDescriptors$1($this_elementDescriptors) {
    this.h73_1 = $this_elementDescriptors;
    this.g73_1 = $this_elementDescriptors.w72();
  }
  protoOf(elementDescriptors$1).u = function () {
    return this.g73_1 > 0;
  };
  protoOf(elementDescriptors$1).v = function () {
    var tmp = this.h73_1.w72();
    var _unary__edvuaz = this.g73_1;
    this.g73_1 = _unary__edvuaz - 1 | 0;
    return this.h73_1.b73(tmp - _unary__edvuaz | 0);
  };
  function elementDescriptors$$inlined$Iterable$1($this_elementDescriptors) {
    this.i73_1 = $this_elementDescriptors;
  }
  protoOf(elementDescriptors$$inlined$Iterable$1).t = function () {
    return new elementDescriptors$1(this.i73_1);
  };
  function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
    var tmp;
    if (builderAction === VOID) {
      tmp = buildClassSerialDescriptor$lambda;
    } else {
      tmp = builderAction;
    }
    builderAction = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builderAction(sdBuilder);
    return new SerialDescriptorImpl(serialName, CLASS_getInstance(), sdBuilder.h71_1.n1(), toList(typeParameters), sdBuilder);
  }
  function PrimitiveSerialDescriptor(serialName, kind) {
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return PrimitiveDescriptorSafe(serialName, kind);
  }
  function ClassSerialDescriptorBuilder(serialName) {
    this.e71_1 = serialName;
    this.f71_1 = false;
    this.g71_1 = emptyList();
    this.h71_1 = ArrayList_init_$Create$_0();
    this.i71_1 = HashSet_init_$Create$();
    this.j71_1 = ArrayList_init_$Create$_0();
    this.k71_1 = ArrayList_init_$Create$_0();
    this.l71_1 = ArrayList_init_$Create$_0();
  }
  protoOf(ClassSerialDescriptorBuilder).j73 = function (elementName, descriptor, annotations, isOptional) {
    // Inline function 'kotlin.require' call
    if (!this.i71_1.j1(elementName)) {
      var message = "Element with name '" + elementName + "' is already registered in " + this.e71_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.collections.plusAssign' call
    this.h71_1.j1(elementName);
    // Inline function 'kotlin.collections.plusAssign' call
    this.j71_1.j1(descriptor);
    // Inline function 'kotlin.collections.plusAssign' call
    this.k71_1.j1(annotations);
    // Inline function 'kotlin.collections.plusAssign' call
    this.l71_1.j1(isOptional);
  };
  protoOf(ClassSerialDescriptorBuilder).m71 = function (elementName, descriptor, annotations, isOptional, $super) {
    annotations = annotations === VOID ? emptyList() : annotations;
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.j73(elementName, descriptor, annotations, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.j73.call(this, elementName, descriptor, annotations, isOptional);
    }
    return tmp;
  };
  function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
    var tmp;
    if (builder === VOID) {
      tmp = buildSerialDescriptor$lambda;
    } else {
      tmp = builder;
    }
    builder = tmp;
    // Inline function 'kotlin.text.isNotBlank' call
    // Inline function 'kotlin.require' call
    if (!!isBlank(serialName)) {
      var message = 'Blank serial names are prohibited';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    // Inline function 'kotlin.require' call
    if (!!equals(kind, CLASS_getInstance())) {
      var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
      throw IllegalArgumentException_init_$Create$(toString(message_0));
    }
    var sdBuilder = new ClassSerialDescriptorBuilder(serialName);
    builder(sdBuilder);
    return new SerialDescriptorImpl(serialName, kind, sdBuilder.h71_1.n1(), toList(typeParameters), sdBuilder);
  }
  function _get__hashCode__tgwhef($this) {
    var tmp0 = $this.v73_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
    return tmp0.u1();
  }
  function SerialDescriptorImpl$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.u73_1);
    };
  }
  function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
    return constructCallableReference(function (p0) {
      return _get__hashCode__tgwhef(p0);
    }, 1, 0, 24);
  }
  function SerialDescriptorImpl(serialName, kind, elementsCount, typeParameters, builder) {
    this.k73_1 = serialName;
    this.l73_1 = kind;
    this.m73_1 = elementsCount;
    this.n73_1 = builder.g71_1;
    this.o73_1 = toHashSet(builder.h71_1);
    var tmp = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = builder.h71_1;
    tmp.p73_1 = copyToArray(this_0);
    this.q73_1 = compactArray(builder.j71_1);
    var tmp_0 = this;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_1 = builder.k71_1;
    tmp_0.r73_1 = copyToArray(this_1);
    this.s73_1 = toBooleanArray(builder.l71_1);
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = withIndex(this.p73_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s = this_2.t();
    while (_iterator__ex2g4s.u()) {
      var item = _iterator__ex2g4s.v();
      var tmp$ret$4 = to(item.oh_1, item.nh_1);
      destination.j1(tmp$ret$4);
    }
    tmp_1.t73_1 = toMap(destination);
    this.u73_1 = compactArray(typeParameters);
    var tmp_2 = this;
    tmp_2.v73_1 = lazy_0(SerialDescriptorImpl$_hashCode$delegate$lambda(this));
  }
  protoOf(SerialDescriptorImpl).z71 = function () {
    return this.k73_1;
  };
  protoOf(SerialDescriptorImpl).u72 = function () {
    return this.l73_1;
  };
  protoOf(SerialDescriptorImpl).w72 = function () {
    return this.m73_1;
  };
  protoOf(SerialDescriptorImpl).x72 = function () {
    return this.n73_1;
  };
  protoOf(SerialDescriptorImpl).w73 = function () {
    return this.o73_1;
  };
  protoOf(SerialDescriptorImpl).y72 = function (index) {
    return getChecked(this.p73_1, index);
  };
  protoOf(SerialDescriptorImpl).z72 = function (name) {
    var tmp0_elvis_lhs = this.t73_1.w2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(SerialDescriptorImpl).a73 = function (index) {
    return getChecked(this.r73_1, index);
  };
  protoOf(SerialDescriptorImpl).b73 = function (index) {
    return getChecked(this.q73_1, index);
  };
  protoOf(SerialDescriptorImpl).c73 = function (index) {
    return getChecked_0(this.s73_1, index);
  };
  protoOf(SerialDescriptorImpl).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof SerialDescriptorImpl)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z71() === other.z71())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.u73_1, other.u73_1)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.w72() === other.w72())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.w72();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.b73(index).z71() === other.b73(index).z71())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.b73(index).u72(), other.b73(index).u72())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(SerialDescriptorImpl).hashCode = function () {
    return _get__hashCode__tgwhef(this);
  };
  protoOf(SerialDescriptorImpl).toString = function () {
    return toStringImpl(this);
  };
  function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function buildSerialDescriptor$lambda(_this__u8e3s4) {
    return Unit_instance;
  }
  function ENUM() {
    ENUM_instance = this;
    SerialKind.call(this);
  }
  var ENUM_instance;
  function ENUM_getInstance() {
    if (ENUM_instance == null)
      new ENUM();
    return ENUM_instance;
  }
  function CONTEXTUAL() {
    CONTEXTUAL_instance = this;
    SerialKind.call(this);
  }
  var CONTEXTUAL_instance;
  function CONTEXTUAL_getInstance() {
    if (CONTEXTUAL_instance == null)
      new CONTEXTUAL();
    return CONTEXTUAL_instance;
  }
  function SerialKind() {
  }
  protoOf(SerialKind).toString = function () {
    return ensureNotNull(getKClassFromExpression(this).o());
  };
  protoOf(SerialKind).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  function BOOLEAN() {
    BOOLEAN_instance = this;
    PrimitiveKind.call(this);
  }
  var BOOLEAN_instance;
  function BOOLEAN_getInstance() {
    if (BOOLEAN_instance == null)
      new BOOLEAN();
    return BOOLEAN_instance;
  }
  function BYTE() {
    BYTE_instance = this;
    PrimitiveKind.call(this);
  }
  var BYTE_instance;
  function BYTE_getInstance() {
    if (BYTE_instance == null)
      new BYTE();
    return BYTE_instance;
  }
  function CHAR() {
    CHAR_instance = this;
    PrimitiveKind.call(this);
  }
  var CHAR_instance;
  function CHAR_getInstance() {
    if (CHAR_instance == null)
      new CHAR();
    return CHAR_instance;
  }
  function SHORT() {
    SHORT_instance = this;
    PrimitiveKind.call(this);
  }
  var SHORT_instance;
  function SHORT_getInstance() {
    if (SHORT_instance == null)
      new SHORT();
    return SHORT_instance;
  }
  function INT() {
    INT_instance = this;
    PrimitiveKind.call(this);
  }
  var INT_instance;
  function INT_getInstance() {
    if (INT_instance == null)
      new INT();
    return INT_instance;
  }
  function LONG() {
    LONG_instance = this;
    PrimitiveKind.call(this);
  }
  var LONG_instance;
  function LONG_getInstance() {
    if (LONG_instance == null)
      new LONG();
    return LONG_instance;
  }
  function FLOAT() {
    FLOAT_instance = this;
    PrimitiveKind.call(this);
  }
  var FLOAT_instance;
  function FLOAT_getInstance() {
    if (FLOAT_instance == null)
      new FLOAT();
    return FLOAT_instance;
  }
  function DOUBLE() {
    DOUBLE_instance = this;
    PrimitiveKind.call(this);
  }
  var DOUBLE_instance;
  function DOUBLE_getInstance() {
    if (DOUBLE_instance == null)
      new DOUBLE();
    return DOUBLE_instance;
  }
  function STRING() {
    STRING_instance = this;
    PrimitiveKind.call(this);
  }
  var STRING_instance;
  function STRING_getInstance() {
    if (STRING_instance == null)
      new STRING();
    return STRING_instance;
  }
  function PrimitiveKind() {
    SerialKind.call(this);
  }
  function CLASS() {
    CLASS_instance = this;
    StructureKind.call(this);
  }
  var CLASS_instance;
  function CLASS_getInstance() {
    if (CLASS_instance == null)
      new CLASS();
    return CLASS_instance;
  }
  function LIST() {
    LIST_instance = this;
    StructureKind.call(this);
  }
  var LIST_instance;
  function LIST_getInstance() {
    if (LIST_instance == null)
      new LIST();
    return LIST_instance;
  }
  function MAP() {
    MAP_instance = this;
    StructureKind.call(this);
  }
  var MAP_instance;
  function MAP_getInstance() {
    if (MAP_instance == null)
      new MAP();
    return MAP_instance;
  }
  function OBJECT() {
    OBJECT_instance = this;
    StructureKind.call(this);
  }
  var OBJECT_instance;
  function OBJECT_getInstance() {
    if (OBJECT_instance == null)
      new OBJECT();
    return OBJECT_instance;
  }
  function StructureKind() {
    SerialKind.call(this);
  }
  function SEALED() {
    SEALED_instance = this;
    PolymorphicKind.call(this);
  }
  var SEALED_instance;
  function SEALED_getInstance() {
    if (SEALED_instance == null)
      new SEALED();
    return SEALED_instance;
  }
  function OPEN() {
    OPEN_instance = this;
    PolymorphicKind.call(this);
  }
  var OPEN_instance;
  function OPEN_getInstance() {
    if (OPEN_instance == null)
      new OPEN();
    return OPEN_instance;
  }
  function PolymorphicKind() {
    SerialKind.call(this);
  }
  function AbstractDecoder() {
  }
  protoOf(AbstractDecoder).x73 = function () {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(AbstractDecoder).y73 = function () {
    return true;
  };
  protoOf(AbstractDecoder).z73 = function () {
    return null;
  };
  protoOf(AbstractDecoder).a74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).b74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).c74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).d74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).e74 = function () {
    var tmp = this.x73();
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).f74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).g74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).h74 = function () {
    var tmp = this.x73();
    return tmp instanceof Char ? tmp.f2_1 : THROW_CCE();
  };
  protoOf(AbstractDecoder).i74 = function () {
    var tmp = this.x73();
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).j74 = function (enumDescriptor) {
    var tmp = this.x73();
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(AbstractDecoder).k74 = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).l74 = function (deserializer, previousValue) {
    return this.m74(deserializer);
  };
  protoOf(AbstractDecoder).n74 = function (descriptor) {
    return this;
  };
  protoOf(AbstractDecoder).o74 = function (descriptor) {
  };
  protoOf(AbstractDecoder).p74 = function (descriptor, index) {
    return this.a74();
  };
  protoOf(AbstractDecoder).q74 = function (descriptor, index) {
    return this.b74();
  };
  protoOf(AbstractDecoder).r74 = function (descriptor, index) {
    return this.c74();
  };
  protoOf(AbstractDecoder).s74 = function (descriptor, index) {
    return this.d74();
  };
  protoOf(AbstractDecoder).t74 = function (descriptor, index) {
    return this.e74();
  };
  protoOf(AbstractDecoder).u74 = function (descriptor, index) {
    return this.f74();
  };
  protoOf(AbstractDecoder).v74 = function (descriptor, index) {
    return this.g74();
  };
  protoOf(AbstractDecoder).w74 = function (descriptor, index) {
    return this.h74();
  };
  protoOf(AbstractDecoder).x74 = function (descriptor, index) {
    return this.i74();
  };
  protoOf(AbstractDecoder).y74 = function (descriptor, index) {
    return this.k74(descriptor.b73(index));
  };
  protoOf(AbstractDecoder).z74 = function (descriptor, index, deserializer, previousValue) {
    return this.l74(deserializer, previousValue);
  };
  protoOf(AbstractDecoder).b75 = function (descriptor, index, deserializer, previousValue) {
    // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
    var isNullabilitySupported = deserializer.y70().n72();
    var tmp;
    if (isNullabilitySupported || this.y73()) {
      tmp = this.l74(deserializer, previousValue);
    } else {
      tmp = this.z73();
    }
    return tmp;
  };
  function AbstractEncoder() {
  }
  protoOf(AbstractEncoder).n74 = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).o74 = function (descriptor) {
  };
  protoOf(AbstractEncoder).g75 = function (descriptor, index) {
    return true;
  };
  protoOf(AbstractEncoder).h75 = function (value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(AbstractEncoder).i75 = function () {
    throw SerializationException_init_$Create$_0("'null' is not supported by default");
  };
  protoOf(AbstractEncoder).j75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).k75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).l75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).m75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).n75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).o75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).p75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).q75 = function (value) {
    return this.h75(new Char(value));
  };
  protoOf(AbstractEncoder).r75 = function (value) {
    return this.h75(value);
  };
  protoOf(AbstractEncoder).s75 = function (enumDescriptor, index) {
    return this.h75(index);
  };
  protoOf(AbstractEncoder).t75 = function (descriptor) {
    return this;
  };
  protoOf(AbstractEncoder).u75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.j75(value);
    }
  };
  protoOf(AbstractEncoder).v75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.k75(value);
    }
  };
  protoOf(AbstractEncoder).w75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.l75(value);
    }
  };
  protoOf(AbstractEncoder).x75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.m75(value);
    }
  };
  protoOf(AbstractEncoder).y75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.n75(value);
    }
  };
  protoOf(AbstractEncoder).z75 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.o75(value);
    }
  };
  protoOf(AbstractEncoder).a76 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.p75(value);
    }
  };
  protoOf(AbstractEncoder).b76 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.q75(value);
    }
  };
  protoOf(AbstractEncoder).c76 = function (descriptor, index, value) {
    if (this.g75(descriptor, index)) {
      this.r75(value);
    }
  };
  protoOf(AbstractEncoder).d76 = function (descriptor, index) {
    return this.g75(descriptor, index) ? this.t75(descriptor.b73(index)) : NoOpEncoder_getInstance();
  };
  protoOf(AbstractEncoder).e76 = function (descriptor, index, serializer, value) {
    if (this.g75(descriptor, index)) {
      this.f76(serializer, value);
    }
  };
  protoOf(AbstractEncoder).g76 = function (descriptor, index, serializer, value) {
    if (this.g75(descriptor, index)) {
      this.h76(serializer, value);
    }
  };
  function Decoder() {
  }
  function CompositeDecoder() {
  }
  function Encoder() {
  }
  function CompositeEncoder() {
  }
  function decodeSequentially_0($this, compositeDecoder) {
    var klassName = compositeDecoder.x74($this.y70(), 0);
    var serializer = findPolymorphicSerializer($this, compositeDecoder, klassName);
    return compositeDecoder.a75($this.y70(), 1, serializer);
  }
  function AbstractPolymorphicSerializer() {
  }
  protoOf(AbstractPolymorphicSerializer).q71 = function (encoder, value) {
    var actualSerializer = findPolymorphicSerializer_0(this, encoder, value);
    // Inline function 'kotlinx.serialization.encoding.encodeStructure' call
    var descriptor = this.y70();
    var composite = encoder.n74(descriptor);
    composite.c76(this.y70(), 0, actualSerializer.y70().z71());
    var tmp = this.y70();
    // Inline function 'kotlinx.serialization.internal.cast' call
    var tmp$ret$2 = isInterface(actualSerializer, SerializationStrategy) ? actualSerializer : THROW_CCE();
    composite.e76(tmp, 1, tmp$ret$2, value);
    composite.o74(descriptor);
  };
  protoOf(AbstractPolymorphicSerializer).z70 = function (encoder, value) {
    return this.q71(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(AbstractPolymorphicSerializer).a71 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    var tmp$ret$1;
    $l$block: {
      var klassName = null;
      var value = null;
      if (composite.d75()) {
        tmp$ret$1 = decodeSequentially_0(this, composite);
        break $l$block;
      }
      mainLoop: while (true) {
        var index = composite.e75(this.y70());
        switch (index) {
          case -1:
            break mainLoop;
          case 0:
            klassName = composite.x74(this.y70(), index);
            break;
          case 1:
            var tmp0 = klassName;
            var tmp$ret$2;
            $l$block_0: {
              // Inline function 'kotlin.requireNotNull' call
              if (tmp0 == null) {
                var message = 'Cannot read polymorphic value before its type token';
                throw IllegalArgumentException_init_$Create$(toString(message));
              } else {
                tmp$ret$2 = tmp0;
                break $l$block_0;
              }
            }

            klassName = tmp$ret$2;
            var serializer = findPolymorphicSerializer(this, composite, klassName);
            value = composite.a75(this.y70(), index, serializer);
            break;
          default:
            var tmp0_elvis_lhs = klassName;
            throw SerializationException_init_$Create$_0('Invalid index in polymorphic deserialization of ' + (tmp0_elvis_lhs == null ? 'unknown class' : tmp0_elvis_lhs) + ('\n Expected 0, 1 or DECODE_DONE(-1), but found ' + index));
        }
      }
      var tmp0_0 = value;
      var tmp$ret$4;
      $l$block_1: {
        // Inline function 'kotlin.requireNotNull' call
        if (tmp0_0 == null) {
          var message_0 = 'Polymorphic value has not been read for class ' + klassName;
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          tmp$ret$4 = tmp0_0;
          break $l$block_1;
        }
      }
      var tmp = tmp$ret$4;
      tmp$ret$1 = !(tmp == null) ? tmp : THROW_CCE();
    }
    var result = tmp$ret$1;
    composite.o74(descriptor);
    return result;
  };
  protoOf(AbstractPolymorphicSerializer).b71 = function (decoder, klassName) {
    return decoder.c75().l76(this.c71(), klassName);
  };
  protoOf(AbstractPolymorphicSerializer).d71 = function (encoder, value) {
    return encoder.c75().m76(this.c71(), value);
  };
  function throwSubtypeNotRegistered(subClassName, baseClass) {
    var scope = "in the polymorphic scope of '" + baseClass.o() + "'";
    throw SerializationException_init_$Create$_0(subClassName == null ? 'Class discriminator was missing and no default serializers were registered ' + scope + '.' : "Serializer for subclass '" + subClassName + "' is not found " + scope + '.\n' + ("Check if class with serial name '" + subClassName + "' exists and serializer is registered in a corresponding SerializersModule.\n") + ("To be registered automatically, class '" + subClassName + "' has to be '@Serializable', and the base class '" + baseClass.o() + "' has to be sealed and '@Serializable'."));
  }
  function throwSubtypeNotRegistered_0(subClass, baseClass) {
    var tmp0_elvis_lhs = subClass.o();
    throwSubtypeNotRegistered(tmp0_elvis_lhs == null ? toString(subClass) : tmp0_elvis_lhs, baseClass);
  }
  function NothingSerializer_0() {
    NothingSerializer_instance = this;
    this.n76_1 = NothingSerialDescriptor_getInstance();
  }
  protoOf(NothingSerializer_0).y70 = function () {
    return this.n76_1;
  };
  protoOf(NothingSerializer_0).o76 = function (encoder, value) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' cannot be serialized");
  };
  protoOf(NothingSerializer_0).z70 = function (encoder, value) {
    var tmp;
    if (false) {
      tmp = value;
    } else {
      tmp = THROW_CCE();
    }
    return this.o76(encoder, tmp);
  };
  protoOf(NothingSerializer_0).a71 = function (decoder) {
    throw SerializationException_init_$Create$_0("'kotlin.Nothing' does not have instances");
  };
  var NothingSerializer_instance;
  function NothingSerializer_getInstance() {
    if (NothingSerializer_instance == null)
      new NothingSerializer_0();
    return NothingSerializer_instance;
  }
  function DurationSerializer() {
    DurationSerializer_instance = this;
    this.p76_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Duration', STRING_getInstance());
  }
  protoOf(DurationSerializer).y70 = function () {
    return this.p76_1;
  };
  protoOf(DurationSerializer).q76 = function (encoder, value) {
    encoder.r75(Duration__toIsoString_impl_9h6wsm(value));
  };
  protoOf(DurationSerializer).z70 = function (encoder, value) {
    return this.q76(encoder, value instanceof Duration ? value.sf_1 : THROW_CCE());
  };
  protoOf(DurationSerializer).r76 = function (decoder) {
    return Companion_getInstance().hp(decoder.i74());
  };
  protoOf(DurationSerializer).a71 = function (decoder) {
    return new Duration(this.r76(decoder));
  };
  var DurationSerializer_instance;
  function DurationSerializer_getInstance() {
    if (DurationSerializer_instance == null)
      new DurationSerializer();
    return DurationSerializer_instance;
  }
  function InstantSerializer() {
    InstantSerializer_instance = this;
    this.s76_1 = new PrimitiveSerialDescriptor_0('kotlin.time.Instant', STRING_getInstance());
  }
  protoOf(InstantSerializer).y70 = function () {
    return this.s76_1;
  };
  protoOf(InstantSerializer).t76 = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(InstantSerializer).z70 = function (encoder, value) {
    return this.t76(encoder, value instanceof Instant ? value : THROW_CCE());
  };
  protoOf(InstantSerializer).a71 = function (decoder) {
    return Companion_getInstance_0().sp(decoder.i74());
  };
  var InstantSerializer_instance;
  function InstantSerializer_getInstance() {
    if (InstantSerializer_instance == null)
      new InstantSerializer();
    return InstantSerializer_instance;
  }
  function UuidSerializer() {
    UuidSerializer_instance = this;
    this.u76_1 = new PrimitiveSerialDescriptor_0('kotlin.uuid.Uuid', STRING_getInstance());
  }
  protoOf(UuidSerializer).y70 = function () {
    return this.u76_1;
  };
  protoOf(UuidSerializer).v76 = function (encoder, value) {
    encoder.r75(value.toString());
  };
  protoOf(UuidSerializer).z70 = function (encoder, value) {
    return this.v76(encoder, value instanceof Uuid ? value : THROW_CCE());
  };
  protoOf(UuidSerializer).a71 = function (decoder) {
    return Companion_getInstance_1().jr(decoder.i74());
  };
  var UuidSerializer_instance;
  function UuidSerializer_getInstance() {
    if (UuidSerializer_instance == null)
      new UuidSerializer();
    return UuidSerializer_instance;
  }
  function CachedNames() {
  }
  function LinkedHashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.LinkedHashMap', keyDesc, valueDesc);
  }
  function ArrayListClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayListClassDesc).z71 = function () {
    return 'kotlin.collections.ArrayList';
  };
  function HashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(HashSetClassDesc).z71 = function () {
    return 'kotlin.collections.HashSet';
  };
  function LinkedHashSetClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(LinkedHashSetClassDesc).z71 = function () {
    return 'kotlin.collections.LinkedHashSet';
  };
  function HashMapClassDesc(keyDesc, valueDesc) {
    MapLikeDescriptor.call(this, 'kotlin.collections.HashMap', keyDesc, valueDesc);
  }
  function ArrayClassDesc(elementDesc) {
    ListLikeDescriptor.call(this, elementDesc);
  }
  protoOf(ArrayClassDesc).z71 = function () {
    return 'kotlin.Array';
  };
  function MapLikeDescriptor(serialName, keyDescriptor, valueDescriptor) {
    this.w76_1 = serialName;
    this.x76_1 = keyDescriptor;
    this.y76_1 = valueDescriptor;
    this.z76_1 = 2;
  }
  protoOf(MapLikeDescriptor).z71 = function () {
    return this.w76_1;
  };
  protoOf(MapLikeDescriptor).u72 = function () {
    return MAP_getInstance();
  };
  protoOf(MapLikeDescriptor).w72 = function () {
    return this.z76_1;
  };
  protoOf(MapLikeDescriptor).y72 = function (index) {
    return index.toString();
  };
  protoOf(MapLikeDescriptor).z72 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid map index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).c73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(MapLikeDescriptor).a73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(MapLikeDescriptor).b73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var tmp;
    switch (index % 2 | 0) {
      case 0:
        tmp = this.x76_1;
        break;
      case 1:
        tmp = this.y76_1;
        break;
      default:
        // Inline function 'kotlin.error' call

        var message_0 = 'Unreached';
        throw IllegalStateException_init_$Create$(toString(message_0));
    }
    return tmp;
  };
  protoOf(MapLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapLikeDescriptor))
      return false;
    if (!(this.z71() === other.z71()))
      return false;
    if (!equals(this.x76_1, other.x76_1))
      return false;
    if (!equals(this.y76_1, other.y76_1))
      return false;
    return true;
  };
  protoOf(MapLikeDescriptor).hashCode = function () {
    var result = getStringHashCode(this.z71());
    result = imul(31, result) + hashCode(this.x76_1) | 0;
    result = imul(31, result) + hashCode(this.y76_1) | 0;
    return result;
  };
  protoOf(MapLikeDescriptor).toString = function () {
    return this.z71() + '(' + toString(this.x76_1) + ', ' + toString(this.y76_1) + ')';
  };
  function ListLikeDescriptor(elementDescriptor) {
    this.c77_1 = elementDescriptor;
    this.d77_1 = 1;
  }
  protoOf(ListLikeDescriptor).u72 = function () {
    return LIST_getInstance();
  };
  protoOf(ListLikeDescriptor).w72 = function () {
    return this.d77_1;
  };
  protoOf(ListLikeDescriptor).y72 = function (index) {
    return index.toString();
  };
  protoOf(ListLikeDescriptor).z72 = function (name) {
    var tmp0_elvis_lhs = toIntOrNull(name);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$(name + ' is not a valid list index');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  };
  protoOf(ListLikeDescriptor).c73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return false;
  };
  protoOf(ListLikeDescriptor).a73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return emptyList();
  };
  protoOf(ListLikeDescriptor).b73 = function (index) {
    // Inline function 'kotlin.require' call
    if (!(index >= 0)) {
      var message = 'Illegal index ' + index + ', ' + this.z71() + ' expects only non-negative indices';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return this.c77_1;
  };
  protoOf(ListLikeDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ListLikeDescriptor))
      return false;
    if (equals(this.c77_1, other.c77_1) && this.z71() === other.z71())
      return true;
    return false;
  };
  protoOf(ListLikeDescriptor).hashCode = function () {
    return imul(hashCode(this.c77_1), 31) + getStringHashCode(this.z71()) | 0;
  };
  protoOf(ListLikeDescriptor).toString = function () {
    return this.z71() + '(' + toString(this.c77_1) + ')';
  };
  function PrimitiveArrayDescriptor(primitive) {
    ListLikeDescriptor.call(this, primitive);
    this.m77_1 = primitive.z71() + 'Array';
  }
  protoOf(PrimitiveArrayDescriptor).z71 = function () {
    return this.m77_1;
  };
  function LinkedHashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.p77_1 = new LinkedHashMapClassDesc(kSerializer.y70(), vSerializer.y70());
  }
  protoOf(LinkedHashMapSerializer).y70 = function () {
    return this.p77_1;
  };
  protoOf(LinkedHashMapSerializer).q77 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(LinkedHashMapSerializer).r77 = function (_this__u8e3s4) {
    return this.q77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).s77 = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.s1().t();
  };
  protoOf(LinkedHashMapSerializer).t77 = function (_this__u8e3s4) {
    return this.s77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).a3d = function () {
    return LinkedHashMap_init_$Create$();
  };
  protoOf(LinkedHashMapSerializer).u77 = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n1(), 2);
  };
  protoOf(LinkedHashMapSerializer).v77 = function (_this__u8e3s4) {
    return this.u77(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).w77 = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashMapSerializer).x77 = function (_this__u8e3s4) {
    return this.w77(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).y77 = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashMap_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashMapSerializer).z77 = function (_this__u8e3s4) {
    return this.y77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashMapSerializer).a78 = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashMapSerializer).b78 = function (_this__u8e3s4, size) {
    return this.a78(_this__u8e3s4 instanceof LinkedHashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ArrayListSerializer(element) {
    CollectionSerializer.call(this, element);
    this.k78_1 = new ArrayListClassDesc(element.y70());
  }
  protoOf(ArrayListSerializer).y70 = function () {
    return this.k78_1;
  };
  protoOf(ArrayListSerializer).a3d = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ArrayListSerializer).l78 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(ArrayListSerializer).v77 = function (_this__u8e3s4) {
    return this.l78(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).m78 = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(ArrayListSerializer).x77 = function (_this__u8e3s4) {
    return this.m78(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).n78 = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? ArrayList_init_$Create$_1(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(ArrayListSerializer).z77 = function (_this__u8e3s4) {
    return this.n78((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtList) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ArrayListSerializer).o78 = function (_this__u8e3s4, size) {
    return _this__u8e3s4.v5(size);
  };
  protoOf(ArrayListSerializer).b78 = function (_this__u8e3s4, size) {
    return this.o78(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ArrayListSerializer).p78 = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.g3(index, element);
  };
  protoOf(ArrayListSerializer).q78 = function (_this__u8e3s4, index, element) {
    return this.p78(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function HashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.y78_1 = new HashSetClassDesc(eSerializer.y70());
  }
  protoOf(HashSetSerializer).y70 = function () {
    return this.y78_1;
  };
  protoOf(HashSetSerializer).a3d = function () {
    return HashSet_init_$Create$();
  };
  protoOf(HashSetSerializer).z78 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(HashSetSerializer).v77 = function (_this__u8e3s4) {
    return this.z78(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).a79 = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashSetSerializer).x77 = function (_this__u8e3s4) {
    return this.a79(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).b79 = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashSetSerializer).z77 = function (_this__u8e3s4) {
    return this.b79((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashSetSerializer).c79 = function (_this__u8e3s4, size) {
  };
  protoOf(HashSetSerializer).b78 = function (_this__u8e3s4, size) {
    return this.c79(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(HashSetSerializer).d79 = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.j1(element);
  };
  protoOf(HashSetSerializer).q78 = function (_this__u8e3s4, index, element) {
    return this.d79(_this__u8e3s4 instanceof HashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function LinkedHashSetSerializer(eSerializer) {
    CollectionSerializer.call(this, eSerializer);
    this.f79_1 = new LinkedHashSetClassDesc(eSerializer.y70());
  }
  protoOf(LinkedHashSetSerializer).y70 = function () {
    return this.f79_1;
  };
  protoOf(LinkedHashSetSerializer).a3d = function () {
    // Inline function 'kotlin.collections.linkedSetOf' call
    return LinkedHashSet_init_$Create$();
  };
  protoOf(LinkedHashSetSerializer).g79 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(LinkedHashSetSerializer).v77 = function (_this__u8e3s4) {
    return this.g79(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).h79 = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(LinkedHashSetSerializer).x77 = function (_this__u8e3s4) {
    return this.h79(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).b79 = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? LinkedHashSet_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(LinkedHashSetSerializer).z77 = function (_this__u8e3s4) {
    return this.b79((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtSet) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LinkedHashSetSerializer).i79 = function (_this__u8e3s4, size) {
  };
  protoOf(LinkedHashSetSerializer).b78 = function (_this__u8e3s4, size) {
    return this.i79(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(LinkedHashSetSerializer).j79 = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.j1(element);
  };
  protoOf(LinkedHashSetSerializer).q78 = function (_this__u8e3s4, index, element) {
    return this.j79(_this__u8e3s4 instanceof LinkedHashSet ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function HashMapSerializer(kSerializer, vSerializer) {
    MapLikeSerializer.call(this, kSerializer, vSerializer);
    this.m79_1 = new HashMapClassDesc(kSerializer.y70(), vSerializer.y70());
  }
  protoOf(HashMapSerializer).y70 = function () {
    return this.m79_1;
  };
  protoOf(HashMapSerializer).q77 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(HashMapSerializer).r77 = function (_this__u8e3s4) {
    return this.q77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).s77 = function (_this__u8e3s4) {
    // Inline function 'kotlin.collections.iterator' call
    return _this__u8e3s4.s1().t();
  };
  protoOf(HashMapSerializer).t77 = function (_this__u8e3s4) {
    return this.s77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).a3d = function () {
    return HashMap_init_$Create$();
  };
  protoOf(HashMapSerializer).n79 = function (_this__u8e3s4) {
    return imul(_this__u8e3s4.n1(), 2);
  };
  protoOf(HashMapSerializer).v77 = function (_this__u8e3s4) {
    return this.n79(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).o79 = function (_this__u8e3s4) {
    return _this__u8e3s4;
  };
  protoOf(HashMapSerializer).x77 = function (_this__u8e3s4) {
    return this.o79(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).y77 = function (_this__u8e3s4) {
    var tmp0_elvis_lhs = _this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : null;
    return tmp0_elvis_lhs == null ? HashMap_init_$Create$_0(_this__u8e3s4) : tmp0_elvis_lhs;
  };
  protoOf(HashMapSerializer).z77 = function (_this__u8e3s4) {
    return this.y77((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, KtMap) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(HashMapSerializer).p79 = function (_this__u8e3s4, size) {
  };
  protoOf(HashMapSerializer).b78 = function (_this__u8e3s4, size) {
    return this.p79(_this__u8e3s4 instanceof HashMap ? _this__u8e3s4 : THROW_CCE(), size);
  };
  function ReferenceArraySerializer(kClass, eSerializer) {
    CollectionLikeSerializer.call(this, eSerializer);
    this.r79_1 = kClass;
    this.s79_1 = new ArrayClassDesc(eSerializer.y70());
  }
  protoOf(ReferenceArraySerializer).y70 = function () {
    return this.s79_1;
  };
  protoOf(ReferenceArraySerializer).t79 = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ReferenceArraySerializer).r77 = function (_this__u8e3s4) {
    return this.t79((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).u79 = function (_this__u8e3s4) {
    return arrayIterator(_this__u8e3s4);
  };
  protoOf(ReferenceArraySerializer).t77 = function (_this__u8e3s4) {
    return this.u79((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).a3d = function () {
    // Inline function 'kotlin.collections.arrayListOf' call
    return ArrayList_init_$Create$_0();
  };
  protoOf(ReferenceArraySerializer).v79 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(ReferenceArraySerializer).v77 = function (_this__u8e3s4) {
    return this.v79(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).w79 = function (_this__u8e3s4) {
    return toNativeArrayImpl(_this__u8e3s4, this.r79_1);
  };
  protoOf(ReferenceArraySerializer).x77 = function (_this__u8e3s4) {
    return this.w79(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).x79 = function (_this__u8e3s4) {
    return ArrayList_init_$Create$_1(asList(_this__u8e3s4));
  };
  protoOf(ReferenceArraySerializer).z77 = function (_this__u8e3s4) {
    return this.x79((!(_this__u8e3s4 == null) ? isArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ReferenceArraySerializer).y79 = function (_this__u8e3s4, size) {
    return _this__u8e3s4.v5(size);
  };
  protoOf(ReferenceArraySerializer).b78 = function (_this__u8e3s4, size) {
    return this.y79(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(ReferenceArraySerializer).z79 = function (_this__u8e3s4, index, element) {
    _this__u8e3s4.g3(index, element);
  };
  protoOf(ReferenceArraySerializer).q78 = function (_this__u8e3s4, index, element) {
    return this.z79(_this__u8e3s4 instanceof ArrayList ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  function MapLikeSerializer(keySerializer, valueSerializer) {
    AbstractCollectionSerializer.call(this);
    this.c78_1 = keySerializer;
    this.d78_1 = valueSerializer;
  }
  protoOf(MapLikeSerializer).e78 = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var progression = step(until(0, imul(size, 2)), 2);
    var inductionVariable = progression.x1_1;
    var last = progression.y1_1;
    var step_0 = progression.z1_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        this.f78(decoder, startIndex + index | 0, builder, false);
      }
       while (!(index === last));
  };
  protoOf(MapLikeSerializer).v78 = function (decoder, builder, startIndex, size) {
    return this.e78(decoder, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), startIndex, size);
  };
  protoOf(MapLikeSerializer).f78 = function (decoder, index, builder, checkIndex) {
    var key = decoder.a75(this.y70(), index, this.c78_1);
    var tmp;
    if (checkIndex) {
      // Inline function 'kotlin.also' call
      var this_0 = decoder.e75(this.y70());
      // Inline function 'kotlin.require' call
      if (!(this_0 === (index + 1 | 0))) {
        var message = 'Value must follow key in a map, index for key: ' + index + ', returned index for value: ' + this_0;
        throw IllegalArgumentException_init_$Create$(toString(message));
      }
      tmp = this_0;
    } else {
      tmp = index + 1 | 0;
    }
    var vIndex = tmp;
    var tmp_0;
    var tmp_1;
    if (builder.u2(key)) {
      var tmp_2 = this.d78_1.y70().u72();
      tmp_1 = !(tmp_2 instanceof PrimitiveKind);
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp_0 = decoder.z74(this.y70(), vIndex, this.d78_1, getValue(builder, key));
    } else {
      tmp_0 = decoder.a75(this.y70(), vIndex, this.d78_1);
    }
    var value = tmp_0;
    // Inline function 'kotlin.collections.set' call
    builder.z2(key, value);
  };
  protoOf(MapLikeSerializer).w78 = function (decoder, index, builder, checkIndex) {
    return this.f78(decoder, index, (!(builder == null) ? isInterface(builder, KtMutableMap) : false) ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(MapLikeSerializer).h78 = function (encoder, value) {
    var size = this.r77(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.y70();
    var composite = encoder.j76(descriptor, size);
    var iterator = this.t77(value);
    var index = 0;
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = iterator;
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var k = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var v = element.u1();
      var tmp = this.y70();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      composite.e76(tmp, _unary__edvuaz, this.c78_1, k);
      var tmp_0 = this.y70();
      var _unary__edvuaz_0 = index;
      index = _unary__edvuaz_0 + 1 | 0;
      composite.e76(tmp_0, _unary__edvuaz_0, this.d78_1, v);
    }
    composite.o74(descriptor);
  };
  protoOf(MapLikeSerializer).z70 = function (encoder, value) {
    return this.h78(encoder, value);
  };
  function CollectionSerializer(element) {
    CollectionLikeSerializer.call(this, element);
  }
  protoOf(CollectionSerializer).s78 = function (_this__u8e3s4) {
    return _this__u8e3s4.n1();
  };
  protoOf(CollectionSerializer).r77 = function (_this__u8e3s4) {
    return this.s78((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CollectionSerializer).t78 = function (_this__u8e3s4) {
    return _this__u8e3s4.t();
  };
  protoOf(CollectionSerializer).t77 = function (_this__u8e3s4) {
    return this.t78((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Collection) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  function CollectionLikeSerializer(elementSerializer) {
    AbstractCollectionSerializer.call(this);
    this.u78_1 = elementSerializer;
  }
  protoOf(CollectionLikeSerializer).h78 = function (encoder, value) {
    var size = this.r77(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.y70();
    var composite = encoder.j76(descriptor, size);
    var iterator = this.t77(value);
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        composite.e76(this.y70(), index, this.u78_1, iterator.v());
      }
       while (inductionVariable < size);
    composite.o74(descriptor);
  };
  protoOf(CollectionLikeSerializer).z70 = function (encoder, value) {
    return this.h78(encoder, value);
  };
  protoOf(CollectionLikeSerializer).v78 = function (decoder, builder, startIndex, size) {
    // Inline function 'kotlin.require' call
    if (!(size >= 0)) {
      var message = 'Size must be known in advance when using READ_ALL';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w78(decoder, startIndex + index | 0, builder, false);
      }
       while (inductionVariable < size);
  };
  protoOf(CollectionLikeSerializer).w78 = function (decoder, index, builder, checkIndex) {
    this.q78(builder, index, decoder.a75(this.y70(), index, this.u78_1));
  };
  function readSize($this, decoder, builder) {
    var size = decoder.f75($this.y70());
    $this.b78(builder, size);
    return size;
  }
  function AbstractCollectionSerializer() {
  }
  protoOf(AbstractCollectionSerializer).i78 = function (decoder, previous) {
    var tmp1_elvis_lhs = previous == null ? null : this.z77(previous);
    var builder = tmp1_elvis_lhs == null ? this.a3d() : tmp1_elvis_lhs;
    var startIndex = this.v77(builder);
    var compositeDecoder = decoder.n74(this.y70());
    if (compositeDecoder.d75()) {
      this.v78(compositeDecoder, builder, startIndex, readSize(this, compositeDecoder, builder));
    } else {
      $l$loop: while (true) {
        var index = compositeDecoder.e75(this.y70());
        if (index === -1)
          break $l$loop;
        this.g78(compositeDecoder, startIndex + index | 0, builder);
      }
    }
    compositeDecoder.o74(this.y70());
    return this.x77(builder);
  };
  protoOf(AbstractCollectionSerializer).a71 = function (decoder) {
    return this.i78(decoder, null);
  };
  protoOf(AbstractCollectionSerializer).g78 = function (decoder, index, builder, checkIndex, $super) {
    checkIndex = checkIndex === VOID ? true : checkIndex;
    var tmp;
    if ($super === VOID) {
      this.w78(decoder, index, builder, checkIndex);
      tmp = Unit_instance;
    } else {
      tmp = $super.w78.call(this, decoder, index, builder, checkIndex);
    }
    return tmp;
  };
  function PrimitiveArraySerializer(primitiveSerializer) {
    CollectionLikeSerializer.call(this, primitiveSerializer);
    this.b7a_1 = new PrimitiveArrayDescriptor(primitiveSerializer.y70());
  }
  protoOf(PrimitiveArraySerializer).y70 = function () {
    return this.b7a_1;
  };
  protoOf(PrimitiveArraySerializer).c7a = function (_this__u8e3s4) {
    return _this__u8e3s4.d7a();
  };
  protoOf(PrimitiveArraySerializer).v77 = function (_this__u8e3s4) {
    return this.c7a(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).e7a = function (_this__u8e3s4) {
    return _this__u8e3s4.f7a();
  };
  protoOf(PrimitiveArraySerializer).x77 = function (_this__u8e3s4) {
    return this.e7a(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PrimitiveArraySerializer).g7a = function (_this__u8e3s4, size) {
    return _this__u8e3s4.h7a(size);
  };
  protoOf(PrimitiveArraySerializer).b78 = function (_this__u8e3s4, size) {
    return this.g7a(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), size);
  };
  protoOf(PrimitiveArraySerializer).i7a = function (_this__u8e3s4) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use writeContents instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).t77 = function (_this__u8e3s4) {
    return this.i7a(_this__u8e3s4);
  };
  protoOf(PrimitiveArraySerializer).j7a = function (_this__u8e3s4, index, element) {
    // Inline function 'kotlin.error' call
    var message = 'This method lead to boxing and must not be used, use Builder.append instead';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(PrimitiveArraySerializer).q78 = function (_this__u8e3s4, index, element) {
    return this.j7a(_this__u8e3s4 instanceof PrimitiveArrayBuilder ? _this__u8e3s4 : THROW_CCE(), index, element);
  };
  protoOf(PrimitiveArraySerializer).a3d = function () {
    return this.z77(this.k7a());
  };
  protoOf(PrimitiveArraySerializer).n7a = function (encoder, value) {
    var size = this.r77(value);
    // Inline function 'kotlinx.serialization.encoding.encodeCollection' call
    var descriptor = this.b7a_1;
    var composite = encoder.j76(descriptor, size);
    this.m7a(composite, value, size);
    composite.o74(descriptor);
  };
  protoOf(PrimitiveArraySerializer).z70 = function (encoder, value) {
    return this.n7a(encoder, value);
  };
  protoOf(PrimitiveArraySerializer).h78 = function (encoder, value) {
    return this.n7a(encoder, value);
  };
  protoOf(PrimitiveArraySerializer).a71 = function (decoder) {
    return this.i78(decoder, null);
  };
  function PrimitiveArrayBuilder() {
  }
  protoOf(PrimitiveArrayBuilder).o7a = function (requiredCapacity, $super) {
    requiredCapacity = requiredCapacity === VOID ? this.d7a() + 1 | 0 : requiredCapacity;
    var tmp;
    if ($super === VOID) {
      this.h7a(requiredCapacity);
      tmp = Unit_instance;
    } else {
      tmp = $super.h7a.call(this, requiredCapacity);
    }
    return tmp;
  };
  function Companion() {
    Companion_instance_0 = this;
    this.p7a_1 = longArray(0);
  }
  var Companion_instance_0;
  function Companion_getInstance_8() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function prepareHighMarksArray($this, elementsCount) {
    var slotsCount = (elementsCount - 1 | 0) >>> 6 | 0;
    var elementsInLastSlot = elementsCount & 63;
    var highMarks = longArray(slotsCount);
    if (!(elementsInLastSlot === 0)) {
      highMarks[get_lastIndex(highMarks)] = shiftLeft(new Long(-1, -1), elementsCount);
    }
    return highMarks;
  }
  function markHigh($this, index) {
    var slot = (index >>> 6 | 0) - 1 | 0;
    var offsetInSlot = index & 63;
    $this.t7a_1[slot] = bitwiseOr($this.t7a_1[slot], shiftLeft(new Long(1, 0), offsetInSlot));
  }
  function nextUnmarkedHighIndex($this) {
    var inductionVariable = 0;
    var last = $this.t7a_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var slot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var slotOffset = imul(slot + 1 | 0, 64);
        var slotMarks = $this.t7a_1[slot];
        while (!equalsLong(slotMarks, new Long(-1, -1))) {
          var indexInSlot = countTrailingZeroBits(invert(slotMarks));
          slotMarks = bitwiseOr(slotMarks, shiftLeft(new Long(1, 0), indexInSlot));
          var index = slotOffset + indexInSlot | 0;
          if ($this.r7a_1($this.q7a_1, index)) {
            $this.t7a_1[slot] = slotMarks;
            return index;
          }
        }
        $this.t7a_1[slot] = slotMarks;
      }
       while (inductionVariable <= last);
    return -1;
  }
  function ElementMarker(descriptor, readIfAbsent) {
    Companion_getInstance_8();
    this.q7a_1 = descriptor;
    this.r7a_1 = readIfAbsent;
    var elementsCount = this.q7a_1.w72();
    if (elementsCount <= 64) {
      var tmp = this;
      var tmp_0;
      if (elementsCount === 64) {
        tmp_0 = new Long(0, 0);
      } else {
        tmp_0 = shiftLeft(new Long(-1, -1), elementsCount);
      }
      tmp.s7a_1 = tmp_0;
      this.t7a_1 = Companion_getInstance_8().p7a_1;
    } else {
      this.s7a_1 = new Long(0, 0);
      this.t7a_1 = prepareHighMarksArray(this, elementsCount);
    }
  }
  protoOf(ElementMarker).u7a = function (index) {
    if (index < 64) {
      this.s7a_1 = bitwiseOr(this.s7a_1, shiftLeft(new Long(1, 0), index));
    } else {
      markHigh(this, index);
    }
  };
  protoOf(ElementMarker).v7a = function () {
    var elementsCount = this.q7a_1.w72();
    while (!equalsLong(this.s7a_1, new Long(-1, -1))) {
      var index = countTrailingZeroBits(invert(this.s7a_1));
      this.s7a_1 = bitwiseOr(this.s7a_1, shiftLeft(new Long(1, 0), index));
      if (this.r7a_1(this.q7a_1, index)) {
        return index;
      }
    }
    if (elementsCount > 64) {
      return nextUnmarkedHighIndex(this);
    }
    return -1;
  };
  function createAnnotatedEnumSerializer(serialName, values, names, entryAnnotations, classAnnotations) {
    var descriptor = new EnumDescriptor(serialName, values.length);
    if (classAnnotations == null)
      null;
    else {
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable = 0;
      var last = classAnnotations.length;
      while (inductionVariable < last) {
        var element = classAnnotations[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        descriptor.i7b(element);
      }
    }
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var inductionVariable_0 = 0;
    var last_0 = values.length;
    while (inductionVariable_0 < last_0) {
      var item = values[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var tmp0_elvis_lhs = getOrNull(names, _unary__edvuaz);
      var elementName = tmp0_elvis_lhs == null ? item.z_1 : tmp0_elvis_lhs;
      descriptor.j7b(elementName);
      var tmp1_safe_receiver = getOrNull(entryAnnotations, _unary__edvuaz);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.collections.forEach' call
        var inductionVariable_1 = 0;
        var last_1 = tmp1_safe_receiver.length;
        while (inductionVariable_1 < last_1) {
          var element_0 = tmp1_safe_receiver[inductionVariable_1];
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          descriptor.k7b(element_0);
        }
      }
    }
    return EnumSerializer_init_$Create$(serialName, values, descriptor);
  }
  function createSimpleEnumSerializer(serialName, values) {
    return new EnumSerializer(serialName, values);
  }
  function _get_elementDescriptors__y23q9p($this) {
    var tmp0 = $this.y7b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('elementDescriptors', 1, tmp, EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a(), null);
    return tmp0.u1();
  }
  function EnumDescriptor$elementDescriptors$delegate$lambda($elementsCount, $name, this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = $elementsCount;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_1 = Array(tmp_0);
      while (tmp < tmp_0) {
        var tmp_2 = tmp;
        tmp_1[tmp_2] = buildSerialDescriptor($name + '.' + this$0.y72(tmp_2), OBJECT_getInstance(), []);
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function EnumDescriptor$_get_elementDescriptors_$ref_5lvk4a() {
    return constructCallableReference(function (p0) {
      return _get_elementDescriptors__y23q9p(p0);
    }, 1, 0, 25);
  }
  function EnumDescriptor(name, elementsCount) {
    PluginGeneratedSerialDescriptor.call(this, name, VOID, elementsCount);
    this.x7b_1 = ENUM_getInstance();
    var tmp = this;
    tmp.y7b_1 = lazy_0(EnumDescriptor$elementDescriptors$delegate$lambda(elementsCount, name, this));
  }
  protoOf(EnumDescriptor).u72 = function () {
    return this.x7b_1;
  };
  protoOf(EnumDescriptor).b73 = function (index) {
    return getChecked(_get_elementDescriptors__y23q9p(this), index);
  };
  protoOf(EnumDescriptor).equals = function (other) {
    if (this === other)
      return true;
    if (other == null)
      return false;
    if (!isInterface(other, SerialDescriptor))
      return false;
    if (!(other.u72() === ENUM_getInstance()))
      return false;
    if (!(this.z71() === other.z71()))
      return false;
    if (!equals(cachedSerialNames(this), cachedSerialNames(other)))
      return false;
    return true;
  };
  protoOf(EnumDescriptor).toString = function () {
    return joinToString(get_elementNames(this), ', ', this.z71() + '(', ')');
  };
  protoOf(EnumDescriptor).hashCode = function () {
    var result = getStringHashCode(this.z71());
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = get_elementNames(this).t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp1_elvis_lhs = element == null ? null : hashCode(element);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var elementsHashCode = accumulator;
    result = imul(31, result) + elementsHashCode | 0;
    return result;
  };
  function EnumSerializer_init_$Init$(serialName, values, descriptor, $this) {
    EnumSerializer.call($this, serialName, values);
    $this.c7c_1 = descriptor;
    return $this;
  }
  function EnumSerializer_init_$Create$(serialName, values, descriptor) {
    return EnumSerializer_init_$Init$(serialName, values, descriptor, objectCreate(protoOf(EnumSerializer)));
  }
  function createUnmarkedDescriptor($this, serialName) {
    var d = new EnumDescriptor(serialName, $this.b7c_1.length);
    // Inline function 'kotlin.collections.forEach' call
    var indexedObject = $this.b7c_1;
    var inductionVariable = 0;
    var last = indexedObject.length;
    while (inductionVariable < last) {
      var element = indexedObject[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      d.j7b(element.z_1);
    }
    return d;
  }
  function EnumSerializer$descriptor$delegate$lambda(this$0, $serialName) {
    return function () {
      var tmp0_elvis_lhs = this$0.c7c_1;
      return tmp0_elvis_lhs == null ? createUnmarkedDescriptor(this$0, $serialName) : tmp0_elvis_lhs;
    };
  }
  function EnumSerializer$_get_descriptor_$ref_j67dlw() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 26);
  }
  function EnumSerializer(serialName, values) {
    this.b7c_1 = values;
    this.c7c_1 = null;
    var tmp = this;
    tmp.d7c_1 = lazy_0(EnumSerializer$descriptor$delegate$lambda(this, serialName));
  }
  protoOf(EnumSerializer).y70 = function () {
    var tmp0 = this.d7c_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, EnumSerializer$_get_descriptor_$ref_j67dlw(), null);
    return tmp0.u1();
  };
  protoOf(EnumSerializer).e7c = function (encoder, value) {
    var index = indexOf(this.b7c_1, value);
    if (index === -1) {
      throw SerializationException_init_$Create$_0(toString(value) + ' is not a valid enum ' + this.y70().z71() + ', ' + ('must be one of ' + contentToString(this.b7c_1)));
    }
    encoder.s75(this.y70(), index);
  };
  protoOf(EnumSerializer).z70 = function (encoder, value) {
    return this.e7c(encoder, value instanceof Enum ? value : THROW_CCE());
  };
  protoOf(EnumSerializer).a71 = function (decoder) {
    var index = decoder.j74(this.y70());
    if (!(0 <= index ? index <= (this.b7c_1.length - 1 | 0) : false)) {
      throw SerializationException_init_$Create$_0('' + index + ' is not among valid ' + this.y70().z71() + ' enum values, ' + ('values size is ' + this.b7c_1.length));
    }
    return this.b7c_1[index];
  };
  protoOf(EnumSerializer).toString = function () {
    return 'kotlinx.serialization.internal.EnumSerializer<' + this.y70().z71() + '>';
  };
  function InlinePrimitiveDescriptor(name, primitiveSerializer) {
    return new InlineClassDescriptor(name, new InlinePrimitiveDescriptor$1(primitiveSerializer));
  }
  function InlineClassDescriptor(name, generatedSerializer) {
    PluginGeneratedSerialDescriptor.call(this, name, generatedSerializer, 1);
    this.r7c_1 = true;
  }
  protoOf(InlineClassDescriptor).v72 = function () {
    return this.r7c_1;
  };
  protoOf(InlineClassDescriptor).hashCode = function () {
    return imul(protoOf(PluginGeneratedSerialDescriptor).hashCode.call(this), 31);
  };
  protoOf(InlineClassDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof InlineClassDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z71() === other.z71())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(other.r7c_1 && contentEquals(this.z7b(), other.z7b()))) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.w72() === other.w72())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.w72();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.b73(index).z71() === other.b73(index).z71())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.b73(index).u72(), other.b73(index).u72())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  function InlinePrimitiveDescriptor$1($primitiveSerializer) {
    this.s7c_1 = $primitiveSerializer;
  }
  protoOf(InlinePrimitiveDescriptor$1).t7c = function () {
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return [this.s7c_1];
  };
  protoOf(InlinePrimitiveDescriptor$1).y70 = function () {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).z70 = function (encoder, value) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  protoOf(InlinePrimitiveDescriptor$1).a71 = function (decoder) {
    // Inline function 'kotlin.error' call
    var message = 'unsupported';
    throw IllegalStateException_init_$Create$(toString(message));
  };
  function missingFieldExceptionWithNewMessage(exception, message) {
    return exception.h72(message);
  }
  function jsonCachedSerialNames(_this__u8e3s4) {
    return cachedSerialNames(_this__u8e3s4);
  }
  function NoOpEncoder() {
    NoOpEncoder_instance = this;
    AbstractEncoder.call(this);
    this.v7c_1 = EmptySerializersModule_0();
  }
  protoOf(NoOpEncoder).c75 = function () {
    return this.v7c_1;
  };
  protoOf(NoOpEncoder).h75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).i75 = function () {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).j75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).k75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).l75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).m75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).n75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).o75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).p75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).q75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).r75 = function (value) {
    return Unit_instance;
  };
  protoOf(NoOpEncoder).s75 = function (enumDescriptor, index) {
    return Unit_instance;
  };
  var NoOpEncoder_instance;
  function NoOpEncoder_getInstance() {
    if (NoOpEncoder_instance == null)
      new NoOpEncoder();
    return NoOpEncoder_instance;
  }
  function error($this) {
    throw IllegalStateException_init_$Create$('Descriptor for type `kotlin.Nothing` does not have elements');
  }
  function NothingSerialDescriptor() {
    NothingSerialDescriptor_instance = this;
    this.w7c_1 = OBJECT_getInstance();
    this.x7c_1 = 'kotlin.Nothing';
  }
  protoOf(NothingSerialDescriptor).u72 = function () {
    return this.w7c_1;
  };
  protoOf(NothingSerialDescriptor).z71 = function () {
    return this.x7c_1;
  };
  protoOf(NothingSerialDescriptor).w72 = function () {
    return 0;
  };
  protoOf(NothingSerialDescriptor).y72 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).z72 = function (name) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).c73 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).b73 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).a73 = function (index) {
    error(this);
  };
  protoOf(NothingSerialDescriptor).toString = function () {
    return 'NothingSerialDescriptor';
  };
  protoOf(NothingSerialDescriptor).equals = function (other) {
    return this === other;
  };
  protoOf(NothingSerialDescriptor).hashCode = function () {
    return getStringHashCode(this.x7c_1) + imul(31, this.w7c_1.hashCode()) | 0;
  };
  var NothingSerialDescriptor_instance;
  function NothingSerialDescriptor_getInstance() {
    if (NothingSerialDescriptor_instance == null)
      new NothingSerialDescriptor();
    return NothingSerialDescriptor_instance;
  }
  function NullableSerializer(serializer) {
    this.y7c_1 = serializer;
    this.z7c_1 = new SerialDescriptorForNullable(this.y7c_1.y70());
  }
  protoOf(NullableSerializer).y70 = function () {
    return this.z7c_1;
  };
  protoOf(NullableSerializer).a7d = function (encoder, value) {
    if (!(value == null)) {
      encoder.i76();
      encoder.f76(this.y7c_1, value);
    } else {
      encoder.i75();
    }
  };
  protoOf(NullableSerializer).z70 = function (encoder, value) {
    return this.a7d(encoder, value);
  };
  protoOf(NullableSerializer).a71 = function (decoder) {
    return decoder.y73() ? decoder.m74(this.y7c_1) : decoder.z73();
  };
  protoOf(NullableSerializer).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof NullableSerializer))
      THROW_CCE();
    if (!equals(this.y7c_1, other.y7c_1))
      return false;
    return true;
  };
  protoOf(NullableSerializer).hashCode = function () {
    return hashCode(this.y7c_1);
  };
  function SerialDescriptorForNullable(original) {
    this.o72_1 = original;
    this.p72_1 = this.o72_1.z71() + '?';
    this.q72_1 = cachedSerialNames(this.o72_1);
  }
  protoOf(SerialDescriptorForNullable).z71 = function () {
    return this.p72_1;
  };
  protoOf(SerialDescriptorForNullable).w73 = function () {
    return this.q72_1;
  };
  protoOf(SerialDescriptorForNullable).n72 = function () {
    return true;
  };
  protoOf(SerialDescriptorForNullable).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SerialDescriptorForNullable))
      return false;
    if (!equals(this.o72_1, other.o72_1))
      return false;
    return true;
  };
  protoOf(SerialDescriptorForNullable).toString = function () {
    return toString(this.o72_1) + '?';
  };
  protoOf(SerialDescriptorForNullable).hashCode = function () {
    return imul(hashCode(this.o72_1), 31);
  };
  protoOf(SerialDescriptorForNullable).u72 = function () {
    return this.o72_1.u72();
  };
  protoOf(SerialDescriptorForNullable).v72 = function () {
    return this.o72_1.v72();
  };
  protoOf(SerialDescriptorForNullable).w72 = function () {
    return this.o72_1.w72();
  };
  protoOf(SerialDescriptorForNullable).x72 = function () {
    return this.o72_1.x72();
  };
  protoOf(SerialDescriptorForNullable).y72 = function (index) {
    return this.o72_1.y72(index);
  };
  protoOf(SerialDescriptorForNullable).z72 = function (name) {
    return this.o72_1.z72(name);
  };
  protoOf(SerialDescriptorForNullable).a73 = function (index) {
    return this.o72_1.a73(index);
  };
  protoOf(SerialDescriptorForNullable).b73 = function (index) {
    return this.o72_1.b73(index);
  };
  protoOf(SerialDescriptorForNullable).c73 = function (index) {
    return this.o72_1.c73(index);
  };
  function ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, $this) {
    ObjectSerializer.call($this, serialName, objectInstance);
    $this.c7d_1 = asList(classAnnotations);
    return $this;
  }
  function ObjectSerializer_init_$Create$(serialName, objectInstance, classAnnotations) {
    return ObjectSerializer_init_$Init$(serialName, objectInstance, classAnnotations, objectCreate(protoOf(ObjectSerializer)));
  }
  function ObjectSerializer$descriptor$delegate$lambda$lambda(this$0) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.g71_1 = this$0.c7d_1;
      return Unit_instance;
    };
  }
  function ObjectSerializer$descriptor$delegate$lambda($serialName, this$0) {
    return function () {
      var tmp = OBJECT_getInstance();
      return buildSerialDescriptor($serialName, tmp, [], ObjectSerializer$descriptor$delegate$lambda$lambda(this$0));
    };
  }
  function ObjectSerializer$_get_descriptor_$ref_7z4xb6() {
    return constructCallableReference(function (p0) {
      return p0.y70();
    }, 1, 0, 27);
  }
  function ObjectSerializer(serialName, objectInstance) {
    this.b7d_1 = objectInstance;
    this.c7d_1 = emptyList();
    var tmp = this;
    var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp.d7d_1 = lazy(tmp_0, ObjectSerializer$descriptor$delegate$lambda(serialName, this));
  }
  protoOf(ObjectSerializer).y70 = function () {
    var tmp0 = this.d7d_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('descriptor', 1, tmp, ObjectSerializer$_get_descriptor_$ref_7z4xb6(), null);
    return tmp0.u1();
  };
  protoOf(ObjectSerializer).q71 = function (encoder, value) {
    encoder.n74(this.y70()).o74(this.y70());
  };
  protoOf(ObjectSerializer).z70 = function (encoder, value) {
    return this.q71(encoder, !(value == null) ? value : THROW_CCE());
  };
  protoOf(ObjectSerializer).a71 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    var tmp$ret$1;
    $l$block_0: {
      if (composite.d75()) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      }
      var index = composite.e75(this.y70());
      if (index === -1) {
        tmp$ret$1 = Unit_instance;
        break $l$block_0;
      } else
        throw SerializationException_init_$Create$_0('Unexpected index ' + index);
    }
    var result = tmp$ret$1;
    composite.o74(descriptor);
    return this.b7d_1;
  };
  function get_EMPTY_DESCRIPTOR_ARRAY() {
    _init_properties_Platform_common_kt__3qzecs();
    return EMPTY_DESCRIPTOR_ARRAY;
  }
  var EMPTY_DESCRIPTOR_ARRAY;
  function serializerNotRegistered(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4));
  }
  function kclass(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var t = _this__u8e3s4.j();
    var tmp;
    if (!(t == null) ? isInterface(t, KClass) : false) {
      tmp = t;
    } else {
      if (!(t == null) ? isInterface(t, KTypeParameter) : false) {
        throw IllegalArgumentException_init_$Create$('Captured type parameter ' + toString(t) + ' from generic non-reified function. ' + ('Such functionality cannot be supported because ' + toString(t) + ' is erased, either specify serializer explicitly or make ') + ('calling function inline with reified ' + toString(t) + '.'));
      } else {
        throw IllegalArgumentException_init_$Create$('Only KClass supported as classifier, got ' + toString_0(t));
      }
    }
    var tmp_0 = tmp;
    return isInterface(tmp_0, KClass) ? tmp_0 : THROW_CCE();
  }
  function typeOrThrow(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0 = _this__u8e3s4.nn_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Star projections in type arguments are not allowed, but had ' + toString_0(_this__u8e3s4.nn_1);
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        tmp$ret$0 = tmp0;
        break $l$block;
      }
    }
    return tmp$ret$0;
  }
  function compactArray(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    // Inline function 'kotlin.takeUnless' call
    var tmp;
    // Inline function 'kotlin.collections.isNullOrEmpty' call
    if (!(_this__u8e3s4 == null || _this__u8e3s4.r())) {
      tmp = _this__u8e3s4;
    } else {
      tmp = null;
    }
    var tmp0_safe_receiver = tmp;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.collections.toTypedArray' call
      tmp_0 = copyToArray(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp1_elvis_lhs == null ? get_EMPTY_DESCRIPTOR_ARRAY() : tmp1_elvis_lhs;
  }
  function cachedSerialNames(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    if (isInterface(_this__u8e3s4, CachedNames))
      return _this__u8e3s4.w73();
    var result = HashSet_init_$Create$_1(_this__u8e3s4.w72());
    var inductionVariable = 0;
    var last = _this__u8e3s4.w72();
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = _this__u8e3s4.y72(i);
        result.j1(element);
      }
       while (inductionVariable < last);
    return result;
  }
  function notRegisteredMessage(_this__u8e3s4) {
    _init_properties_Platform_common_kt__3qzecs();
    var tmp0_elvis_lhs = _this__u8e3s4.o();
    return notRegisteredMessage_0(tmp0_elvis_lhs == null ? '<local class name not available>' : tmp0_elvis_lhs);
  }
  function notRegisteredMessage_0(className) {
    _init_properties_Platform_common_kt__3qzecs();
    return "Serializer for class '" + className + "' is not found.\n" + "Please ensure that class is marked as '@Serializable' and that the serialization compiler plugin is applied.\n";
  }
  var properties_initialized_Platform_common_kt_i7q4ty;
  function _init_properties_Platform_common_kt__3qzecs() {
    if (!properties_initialized_Platform_common_kt_i7q4ty) {
      properties_initialized_Platform_common_kt_i7q4ty = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_DESCRIPTOR_ARRAY = [];
    }
  }
  function throwMissingFieldException(seen, goldenMask, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var missingFieldsBits = goldenMask & ~seen;
    var inductionVariable = 0;
    if (inductionVariable < 32)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (!((missingFieldsBits & 1) === 0)) {
          // Inline function 'kotlin.collections.plusAssign' call
          var element = descriptor.y72(i);
          missingFields.j1(element);
        }
        missingFieldsBits = missingFieldsBits >>> 1 | 0;
      }
       while (inductionVariable < 32);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.z71());
  }
  function throwArrayMissingFieldException(seenArray, goldenMaskArray, descriptor) {
    // Inline function 'kotlin.collections.mutableListOf' call
    var missingFields = ArrayList_init_$Create$_0();
    var inductionVariable = 0;
    var last = goldenMaskArray.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var maskSlot = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var missingFieldsBits = goldenMaskArray[maskSlot] & ~seenArray[maskSlot];
        if (!(missingFieldsBits === 0)) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < 32)
            do {
              var i = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              if (!((missingFieldsBits & 1) === 0)) {
                // Inline function 'kotlin.collections.plusAssign' call
                var element = descriptor.y72(imul(maskSlot, 32) + i | 0);
                missingFields.j1(element);
              }
              missingFieldsBits = missingFieldsBits >>> 1 | 0;
            }
             while (inductionVariable_0 < 32);
        }
      }
       while (inductionVariable <= last);
    throw MissingFieldException_init_$Create$(missingFields, descriptor.z71());
  }
  function _get_childSerializers__7vnyfa($this) {
    var tmp0 = $this.f7b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('childSerializers', 1, tmp, PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca(), null);
    return tmp0.u1();
  }
  function _get__hashCode__tgwhef_0($this) {
    var tmp0 = $this.h7b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_hashCode', 1, tmp, PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz(), null);
    return tmp0.u1();
  }
  function buildIndices($this) {
    var indices = HashMap_init_$Create$();
    var inductionVariable = 0;
    var last = $this.a7b_1.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.collections.set' call
        var key = $this.a7b_1[i];
        indices.z2(key, i);
      }
       while (inductionVariable <= last);
    return indices;
  }
  function PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.x7a_1;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.t7c();
      return tmp1_elvis_lhs == null ? get_EMPTY_SERIALIZER_ARRAY() : tmp1_elvis_lhs;
    };
  }
  function PluginGeneratedSerialDescriptor$_get_childSerializers_$ref_e7suca() {
    return constructCallableReference(function (p0) {
      return _get_childSerializers__7vnyfa(p0);
    }, 1, 0, 28);
  }
  function PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this$0) {
    return function () {
      var tmp0_safe_receiver = this$0.x7a_1;
      var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.u7c();
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList_init_$Create$(tmp1_safe_receiver.length);
        var inductionVariable = 0;
        var last = tmp1_safe_receiver.length;
        while (inductionVariable < last) {
          var item = tmp1_safe_receiver[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$2 = item.y70();
          destination.j1(tmp$ret$2);
        }
        tmp = destination;
      }
      return compactArray(tmp);
    };
  }
  function PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka() {
    return constructCallableReference(function (p0) {
      return p0.z7b();
    }, 1, 0, 29);
  }
  function PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this$0) {
    return function () {
      return hashCodeImpl(this$0, this$0.z7b());
    };
  }
  function PluginGeneratedSerialDescriptor$_get__hashCode_$ref_cmj4vz() {
    return constructCallableReference(function (p0) {
      return _get__hashCode__tgwhef_0(p0);
    }, 1, 0, 30);
  }
  function PluginGeneratedSerialDescriptor(serialName, generatedSerializer, elementsCount) {
    generatedSerializer = generatedSerializer === VOID ? null : generatedSerializer;
    this.w7a_1 = serialName;
    this.x7a_1 = generatedSerializer;
    this.y7a_1 = elementsCount;
    this.z7a_1 = -1;
    var tmp = this;
    var tmp_0 = 0;
    var tmp_1 = this.y7a_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_2 = Array(tmp_1);
    while (tmp_0 < tmp_1) {
      tmp_2[tmp_0] = '[UNINITIALIZED]';
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.a7b_1 = tmp_2;
    var tmp_3 = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.y7a_1;
    tmp_3.b7b_1 = Array(size);
    this.c7b_1 = null;
    this.d7b_1 = booleanArray(this.y7a_1);
    this.e7b_1 = emptyMap();
    var tmp_4 = this;
    var tmp_5 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_4.f7b_1 = lazy(tmp_5, PluginGeneratedSerialDescriptor$childSerializers$delegate$lambda(this));
    var tmp_6 = this;
    var tmp_7 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_6.g7b_1 = lazy(tmp_7, PluginGeneratedSerialDescriptor$typeParameterDescriptors$delegate$lambda(this));
    var tmp_8 = this;
    var tmp_9 = LazyThreadSafetyMode_PUBLICATION_getInstance();
    tmp_8.h7b_1 = lazy(tmp_9, PluginGeneratedSerialDescriptor$_hashCode$delegate$lambda(this));
  }
  protoOf(PluginGeneratedSerialDescriptor).z71 = function () {
    return this.w7a_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).w72 = function () {
    return this.y7a_1;
  };
  protoOf(PluginGeneratedSerialDescriptor).u72 = function () {
    return CLASS_getInstance();
  };
  protoOf(PluginGeneratedSerialDescriptor).x72 = function () {
    var tmp0_elvis_lhs = this.c7b_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).w73 = function () {
    return this.e7b_1.x2();
  };
  protoOf(PluginGeneratedSerialDescriptor).z7b = function () {
    var tmp0 = this.g7b_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('typeParameterDescriptors', 1, tmp, PluginGeneratedSerialDescriptor$_get_typeParameterDescriptors_$ref_jk3pka(), null);
    return tmp0.u1();
  };
  protoOf(PluginGeneratedSerialDescriptor).a7c = function (name, isOptional) {
    this.z7a_1 = this.z7a_1 + 1 | 0;
    this.a7b_1[this.z7a_1] = name;
    this.d7b_1[this.z7a_1] = isOptional;
    this.b7b_1[this.z7a_1] = null;
    if (this.z7a_1 === (this.y7a_1 - 1 | 0)) {
      this.e7b_1 = buildIndices(this);
    }
  };
  protoOf(PluginGeneratedSerialDescriptor).j7b = function (name, isOptional, $super) {
    isOptional = isOptional === VOID ? false : isOptional;
    var tmp;
    if ($super === VOID) {
      this.a7c(name, isOptional);
      tmp = Unit_instance;
    } else {
      tmp = $super.a7c.call(this, name, isOptional);
    }
    return tmp;
  };
  protoOf(PluginGeneratedSerialDescriptor).k7b = function (annotation) {
    // Inline function 'kotlin.let' call
    var it = this.b7b_1[this.z7a_1];
    var tmp;
    if (it == null) {
      var result = ArrayList_init_$Create$(1);
      this.b7b_1[this.z7a_1] = result;
      tmp = result;
    } else {
      tmp = it;
    }
    var list = tmp;
    list.j1(annotation);
  };
  protoOf(PluginGeneratedSerialDescriptor).i7b = function (a) {
    if (this.c7b_1 == null) {
      this.c7b_1 = ArrayList_init_$Create$(1);
    }
    ensureNotNull(this.c7b_1).j1(a);
  };
  protoOf(PluginGeneratedSerialDescriptor).b73 = function (index) {
    return getChecked(_get_childSerializers__7vnyfa(this), index).y70();
  };
  protoOf(PluginGeneratedSerialDescriptor).c73 = function (index) {
    return getChecked_0(this.d7b_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).a73 = function (index) {
    var tmp0_elvis_lhs = getChecked(this.b7b_1, index);
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).y72 = function (index) {
    return getChecked(this.a7b_1, index);
  };
  protoOf(PluginGeneratedSerialDescriptor).z72 = function (name) {
    var tmp0_elvis_lhs = this.e7b_1.w2(name);
    return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
  };
  protoOf(PluginGeneratedSerialDescriptor).equals = function (other) {
    var tmp$ret$0;
    $l$block_5: {
      // Inline function 'kotlinx.serialization.internal.equalsImpl' call
      if (this === other) {
        tmp$ret$0 = true;
        break $l$block_5;
      }
      if (!(other instanceof PluginGeneratedSerialDescriptor)) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.z71() === other.z71())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!contentEquals(this.z7b(), other.z7b())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      if (!(this.w72() === other.w72())) {
        tmp$ret$0 = false;
        break $l$block_5;
      }
      var inductionVariable = 0;
      var last = this.w72();
      if (inductionVariable < last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          if (!(this.b73(index).z71() === other.b73(index).z71())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!equals(this.b73(index).u72(), other.b73(index).u72())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
        }
         while (inductionVariable < last);
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  };
  protoOf(PluginGeneratedSerialDescriptor).hashCode = function () {
    return _get__hashCode__tgwhef_0(this);
  };
  protoOf(PluginGeneratedSerialDescriptor).toString = function () {
    return toStringImpl(this);
  };
  function hashCodeImpl(_this__u8e3s4, typeParams) {
    var result = getStringHashCode(_this__u8e3s4.z71());
    result = imul(31, result) + contentHashCode(typeParams) | 0;
    var elementDescriptors = get_elementDescriptors(_this__u8e3s4);
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator = 1;
    var _iterator__ex2g4s = elementDescriptors.t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      var hash = accumulator;
      var tmp = imul(31, hash);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver = element.z71();
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
      accumulator = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    }
    var namesHash = accumulator;
    // Inline function 'kotlinx.serialization.internal.elementsHashCodeBy' call
    // Inline function 'kotlin.collections.fold' call
    var accumulator_0 = 1;
    var _iterator__ex2g4s_0 = elementDescriptors.t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      var hash_0 = accumulator_0;
      var tmp_0 = imul(31, hash_0);
      // Inline function 'kotlin.hashCode' call
      var tmp0_safe_receiver_0 = element_0.u72();
      var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : hashCode(tmp0_safe_receiver_0);
      accumulator_0 = tmp_0 + (tmp1_elvis_lhs_0 == null ? 0 : tmp1_elvis_lhs_0) | 0;
    }
    var kindHash = accumulator_0;
    result = imul(31, result) + namesHash | 0;
    result = imul(31, result) + kindHash | 0;
    return result;
  }
  function toStringImpl(_this__u8e3s4) {
    var tmp = until(0, _this__u8e3s4.w72());
    var tmp_0 = _this__u8e3s4.z71() + '(';
    return joinToString(tmp, ', ', tmp_0, ')', VOID, VOID, toStringImpl$lambda(_this__u8e3s4));
  }
  function toStringImpl$lambda($this_toStringImpl) {
    return function (i) {
      return $this_toStringImpl.y72(i) + ': ' + $this_toStringImpl.b73(i).z71();
    };
  }
  function get_EMPTY_SERIALIZER_ARRAY() {
    _init_properties_PluginHelperInterfaces_kt__xgvzfp();
    return EMPTY_SERIALIZER_ARRAY;
  }
  var EMPTY_SERIALIZER_ARRAY;
  function SerializerFactory() {
  }
  function GeneratedSerializer() {
  }
  var properties_initialized_PluginHelperInterfaces_kt_ap8in1;
  function _init_properties_PluginHelperInterfaces_kt__xgvzfp() {
    if (!properties_initialized_PluginHelperInterfaces_kt_ap8in1) {
      properties_initialized_PluginHelperInterfaces_kt_ap8in1 = true;
      // Inline function 'kotlin.arrayOf' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      EMPTY_SERIALIZER_ARRAY = [];
    }
  }
  function ByteArraySerializer_0() {
    ByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_8(ByteCompanionObject_instance));
  }
  protoOf(ByteArraySerializer_0).h7d = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ByteArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.h7d((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).i7d = function (_this__u8e3s4) {
    return new ByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(ByteArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.i7d((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ByteArraySerializer_0).k7a = function () {
    return new Int8Array(0);
  };
  protoOf(ByteArraySerializer_0).j7d = function (decoder, index, builder, checkIndex) {
    builder.m7d(decoder.q74(this.b7a_1, index));
  };
  protoOf(ByteArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.j7d(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.j7d(decoder, index, builder instanceof ByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ByteArraySerializer_0).n7d = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.v75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ByteArraySerializer_0).m7a = function (encoder, content, size) {
    return this.n7d(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ByteArraySerializer_instance;
  function ByteArraySerializer_getInstance() {
    if (ByteArraySerializer_instance == null)
      new ByteArraySerializer_0();
    return ByteArraySerializer_instance;
  }
  function BooleanArraySerializer_0() {
    BooleanArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_9(BooleanCompanionObject_instance));
  }
  protoOf(BooleanArraySerializer_0).q7d = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(BooleanArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.q7d((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).r7d = function (_this__u8e3s4) {
    return new BooleanArrayBuilder(_this__u8e3s4);
  };
  protoOf(BooleanArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.r7d((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(BooleanArraySerializer_0).k7a = function () {
    return booleanArray(0);
  };
  protoOf(BooleanArraySerializer_0).s7d = function (decoder, index, builder, checkIndex) {
    builder.v7d(decoder.p74(this.b7a_1, index));
  };
  protoOf(BooleanArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.s7d(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.s7d(decoder, index, builder instanceof BooleanArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(BooleanArraySerializer_0).w7d = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.u75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(BooleanArraySerializer_0).m7a = function (encoder, content, size) {
    return this.w7d(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
  };
  var BooleanArraySerializer_instance;
  function BooleanArraySerializer_getInstance() {
    if (BooleanArraySerializer_instance == null)
      new BooleanArraySerializer_0();
    return BooleanArraySerializer_instance;
  }
  function CharArraySerializer_0() {
    CharArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_10(Companion_getInstance_2()));
  }
  protoOf(CharArraySerializer_0).z7d = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(CharArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.z7d((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).a7e = function (_this__u8e3s4) {
    return new CharArrayBuilder(_this__u8e3s4);
  };
  protoOf(CharArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.a7e((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(CharArraySerializer_0).k7a = function () {
    return charArray(0);
  };
  protoOf(CharArraySerializer_0).b7e = function (decoder, index, builder, checkIndex) {
    builder.e7e(decoder.w74(this.b7a_1, index));
  };
  protoOf(CharArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.b7e(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.b7e(decoder, index, builder instanceof CharArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(CharArraySerializer_0).f7e = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.b76(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(CharArraySerializer_0).m7a = function (encoder, content, size) {
    return this.f7e(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
  };
  var CharArraySerializer_instance;
  function CharArraySerializer_getInstance() {
    if (CharArraySerializer_instance == null)
      new CharArraySerializer_0();
    return CharArraySerializer_instance;
  }
  function DoubleArraySerializer_0() {
    DoubleArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_11(DoubleCompanionObject_instance));
  }
  protoOf(DoubleArraySerializer_0).i7e = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(DoubleArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.i7e((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).j7e = function (_this__u8e3s4) {
    return new DoubleArrayBuilder(_this__u8e3s4);
  };
  protoOf(DoubleArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.j7e((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(DoubleArraySerializer_0).k7a = function () {
    return new Float64Array(0);
  };
  protoOf(DoubleArraySerializer_0).k7e = function (decoder, index, builder, checkIndex) {
    builder.n7e(decoder.v74(this.b7a_1, index));
  };
  protoOf(DoubleArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.k7e(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.k7e(decoder, index, builder instanceof DoubleArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(DoubleArraySerializer_0).o7e = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.a76(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(DoubleArraySerializer_0).m7a = function (encoder, content, size) {
    return this.o7e(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
  };
  var DoubleArraySerializer_instance;
  function DoubleArraySerializer_getInstance() {
    if (DoubleArraySerializer_instance == null)
      new DoubleArraySerializer_0();
    return DoubleArraySerializer_instance;
  }
  function FloatArraySerializer_0() {
    FloatArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_12(FloatCompanionObject_instance));
  }
  protoOf(FloatArraySerializer_0).r7e = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(FloatArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.r7e((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).s7e = function (_this__u8e3s4) {
    return new FloatArrayBuilder(_this__u8e3s4);
  };
  protoOf(FloatArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.s7e((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(FloatArraySerializer_0).k7a = function () {
    return new Float32Array(0);
  };
  protoOf(FloatArraySerializer_0).t7e = function (decoder, index, builder, checkIndex) {
    builder.w7e(decoder.u74(this.b7a_1, index));
  };
  protoOf(FloatArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.t7e(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.t7e(decoder, index, builder instanceof FloatArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(FloatArraySerializer_0).x7e = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.z75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(FloatArraySerializer_0).m7a = function (encoder, content, size) {
    return this.x7e(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
  };
  var FloatArraySerializer_instance;
  function FloatArraySerializer_getInstance() {
    if (FloatArraySerializer_instance == null)
      new FloatArraySerializer_0();
    return FloatArraySerializer_instance;
  }
  function IntArraySerializer_0() {
    IntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_3(IntCompanionObject_instance));
  }
  protoOf(IntArraySerializer_0).a7f = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(IntArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.a7f((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).b7f = function (_this__u8e3s4) {
    return new IntArrayBuilder(_this__u8e3s4);
  };
  protoOf(IntArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.b7f((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(IntArraySerializer_0).k7a = function () {
    return new Int32Array(0);
  };
  protoOf(IntArraySerializer_0).c7f = function (decoder, index, builder, checkIndex) {
    builder.f7f(decoder.s74(this.b7a_1, index));
  };
  protoOf(IntArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.c7f(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.c7f(decoder, index, builder instanceof IntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(IntArraySerializer_0).g7f = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.x75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(IntArraySerializer_0).m7a = function (encoder, content, size) {
    return this.g7f(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
  };
  var IntArraySerializer_instance;
  function IntArraySerializer_getInstance() {
    if (IntArraySerializer_instance == null)
      new IntArraySerializer_0();
    return IntArraySerializer_instance;
  }
  function LongArraySerializer_0() {
    LongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_13(Companion_getInstance_3()));
  }
  protoOf(LongArraySerializer_0).j7f = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(LongArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.j7f((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).k7f = function (_this__u8e3s4) {
    return new LongArrayBuilder(_this__u8e3s4);
  };
  protoOf(LongArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.k7f((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(LongArraySerializer_0).k7a = function () {
    return longArray(0);
  };
  protoOf(LongArraySerializer_0).l7f = function (decoder, index, builder, checkIndex) {
    builder.o7f(decoder.t74(this.b7a_1, index));
  };
  protoOf(LongArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.l7f(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.l7f(decoder, index, builder instanceof LongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(LongArraySerializer_0).p7f = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.y75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(LongArraySerializer_0).m7a = function (encoder, content, size) {
    return this.p7f(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
  };
  var LongArraySerializer_instance;
  function LongArraySerializer_getInstance() {
    if (LongArraySerializer_instance == null)
      new LongArraySerializer_0();
    return LongArraySerializer_instance;
  }
  function ByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.k7d_1 = bufferWithData;
    this.l7d_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(ByteArrayBuilder).d7a = function () {
    return this.l7d_1;
  };
  protoOf(ByteArrayBuilder).h7a = function (requiredCapacity) {
    if (this.k7d_1.length < requiredCapacity)
      this.k7d_1 = copyOf(this.k7d_1, coerceAtLeast(requiredCapacity, imul(this.k7d_1.length, 2)));
  };
  protoOf(ByteArrayBuilder).m7d = function (c) {
    this.o7a();
    var tmp = this.k7d_1;
    var _unary__edvuaz = this.l7d_1;
    this.l7d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ByteArrayBuilder).f7a = function () {
    return copyOf(this.k7d_1, this.l7d_1);
  };
  function BooleanArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.t7d_1 = bufferWithData;
    this.u7d_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(BooleanArrayBuilder).d7a = function () {
    return this.u7d_1;
  };
  protoOf(BooleanArrayBuilder).h7a = function (requiredCapacity) {
    if (this.t7d_1.length < requiredCapacity)
      this.t7d_1 = copyOf_0(this.t7d_1, coerceAtLeast(requiredCapacity, imul(this.t7d_1.length, 2)));
  };
  protoOf(BooleanArrayBuilder).v7d = function (c) {
    this.o7a();
    var tmp = this.t7d_1;
    var _unary__edvuaz = this.u7d_1;
    this.u7d_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(BooleanArrayBuilder).f7a = function () {
    return copyOf_0(this.t7d_1, this.u7d_1);
  };
  function CharArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.c7e_1 = bufferWithData;
    this.d7e_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(CharArrayBuilder).d7a = function () {
    return this.d7e_1;
  };
  protoOf(CharArrayBuilder).h7a = function (requiredCapacity) {
    if (this.c7e_1.length < requiredCapacity)
      this.c7e_1 = copyOf_1(this.c7e_1, coerceAtLeast(requiredCapacity, imul(this.c7e_1.length, 2)));
  };
  protoOf(CharArrayBuilder).e7e = function (c) {
    this.o7a();
    var tmp = this.c7e_1;
    var _unary__edvuaz = this.d7e_1;
    this.d7e_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(CharArrayBuilder).f7a = function () {
    return copyOf_1(this.c7e_1, this.d7e_1);
  };
  function DoubleArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.l7e_1 = bufferWithData;
    this.m7e_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(DoubleArrayBuilder).d7a = function () {
    return this.m7e_1;
  };
  protoOf(DoubleArrayBuilder).h7a = function (requiredCapacity) {
    if (this.l7e_1.length < requiredCapacity)
      this.l7e_1 = copyOf_2(this.l7e_1, coerceAtLeast(requiredCapacity, imul(this.l7e_1.length, 2)));
  };
  protoOf(DoubleArrayBuilder).n7e = function (c) {
    this.o7a();
    var tmp = this.l7e_1;
    var _unary__edvuaz = this.m7e_1;
    this.m7e_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(DoubleArrayBuilder).f7a = function () {
    return copyOf_2(this.l7e_1, this.m7e_1);
  };
  function FloatArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.u7e_1 = bufferWithData;
    this.v7e_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(FloatArrayBuilder).d7a = function () {
    return this.v7e_1;
  };
  protoOf(FloatArrayBuilder).h7a = function (requiredCapacity) {
    if (this.u7e_1.length < requiredCapacity)
      this.u7e_1 = copyOf_3(this.u7e_1, coerceAtLeast(requiredCapacity, imul(this.u7e_1.length, 2)));
  };
  protoOf(FloatArrayBuilder).w7e = function (c) {
    this.o7a();
    var tmp = this.u7e_1;
    var _unary__edvuaz = this.v7e_1;
    this.v7e_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(FloatArrayBuilder).f7a = function () {
    return copyOf_3(this.u7e_1, this.v7e_1);
  };
  function IntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.d7f_1 = bufferWithData;
    this.e7f_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(IntArrayBuilder).d7a = function () {
    return this.e7f_1;
  };
  protoOf(IntArrayBuilder).h7a = function (requiredCapacity) {
    if (this.d7f_1.length < requiredCapacity)
      this.d7f_1 = copyOf_4(this.d7f_1, coerceAtLeast(requiredCapacity, imul(this.d7f_1.length, 2)));
  };
  protoOf(IntArrayBuilder).f7f = function (c) {
    this.o7a();
    var tmp = this.d7f_1;
    var _unary__edvuaz = this.e7f_1;
    this.e7f_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(IntArrayBuilder).f7a = function () {
    return copyOf_4(this.d7f_1, this.e7f_1);
  };
  function LongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.m7f_1 = bufferWithData;
    this.n7f_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(LongArrayBuilder).d7a = function () {
    return this.n7f_1;
  };
  protoOf(LongArrayBuilder).h7a = function (requiredCapacity) {
    if (this.m7f_1.length < requiredCapacity)
      this.m7f_1 = copyOf_5(this.m7f_1, coerceAtLeast(requiredCapacity, imul(this.m7f_1.length, 2)));
  };
  protoOf(LongArrayBuilder).o7f = function (c) {
    this.o7a();
    var tmp = this.m7f_1;
    var _unary__edvuaz = this.n7f_1;
    this.n7f_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(LongArrayBuilder).f7a = function () {
    return copyOf_5(this.m7f_1, this.n7f_1);
  };
  function ULongArraySerializer_0() {
    ULongArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_4(Companion_getInstance_4()));
  }
  protoOf(ULongArraySerializer_0).s7f = function (_this__u8e3s4) {
    return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.s7f(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.xs_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).t7f = function (_this__u8e3s4) {
    return new ULongArrayBuilder(_this__u8e3s4);
  };
  protoOf(ULongArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.t7f(_this__u8e3s4 instanceof ULongArray ? _this__u8e3s4.xs_1 : THROW_CCE());
  };
  protoOf(ULongArraySerializer_0).u7f = function () {
    return _ULongArray___init__impl__twm1l3(0);
  };
  protoOf(ULongArraySerializer_0).k7a = function () {
    return new ULongArray(this.u7f());
  };
  protoOf(ULongArraySerializer_0).v7f = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.y74(this.b7a_1, index).e74();
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    builder.y7f(tmp$ret$0);
  };
  protoOf(ULongArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.v7f(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.v7f(decoder, index, builder instanceof ULongArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ULongArraySerializer_0).z7f = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.d76(this.b7a_1, i);
        // Inline function 'kotlin.ULong.toLong' call
        var this_0 = ULongArray__get_impl_pr71q9(content, i);
        var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
        tmp.n75(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(ULongArraySerializer_0).m7a = function (encoder, content, size) {
    return this.z7f(encoder, content instanceof ULongArray ? content.xs_1 : THROW_CCE(), size);
  };
  var ULongArraySerializer_instance;
  function ULongArraySerializer_getInstance() {
    if (ULongArraySerializer_instance == null)
      new ULongArraySerializer_0();
    return ULongArraySerializer_instance;
  }
  function UIntArraySerializer_0() {
    UIntArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_5(Companion_getInstance_5()));
  }
  protoOf(UIntArraySerializer_0).c7g = function (_this__u8e3s4) {
    return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.c7g(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ls_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).d7g = function (_this__u8e3s4) {
    return new UIntArrayBuilder(_this__u8e3s4);
  };
  protoOf(UIntArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.d7g(_this__u8e3s4 instanceof UIntArray ? _this__u8e3s4.ls_1 : THROW_CCE());
  };
  protoOf(UIntArraySerializer_0).e7g = function () {
    return _UIntArray___init__impl__ghjpc6(0);
  };
  protoOf(UIntArraySerializer_0).k7a = function () {
    return new UIntArray(this.e7g());
  };
  protoOf(UIntArraySerializer_0).f7g = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.y74(this.b7a_1, index).d74();
    var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
    builder.i7g(tmp$ret$0);
  };
  protoOf(UIntArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.f7g(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.f7g(decoder, index, builder instanceof UIntArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UIntArraySerializer_0).j7g = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.d76(this.b7a_1, i);
        // Inline function 'kotlin.UInt.toInt' call
        var this_0 = UIntArray__get_impl_gp5kza(content, i);
        var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
        tmp.m75(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UIntArraySerializer_0).m7a = function (encoder, content, size) {
    return this.j7g(encoder, content instanceof UIntArray ? content.ls_1 : THROW_CCE(), size);
  };
  var UIntArraySerializer_instance;
  function UIntArraySerializer_getInstance() {
    if (UIntArraySerializer_instance == null)
      new UIntArraySerializer_0();
    return UIntArraySerializer_instance;
  }
  function ShortArraySerializer_0() {
    ShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_14(ShortCompanionObject_instance));
  }
  protoOf(ShortArraySerializer_0).m7g = function (_this__u8e3s4) {
    return _this__u8e3s4.length;
  };
  protoOf(ShortArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.m7g((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).n7g = function (_this__u8e3s4) {
    return new ShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(ShortArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.n7g((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(ShortArraySerializer_0).k7a = function () {
    return new Int16Array(0);
  };
  protoOf(ShortArraySerializer_0).o7g = function (decoder, index, builder, checkIndex) {
    builder.r7g(decoder.r74(this.b7a_1, index));
  };
  protoOf(ShortArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.o7g(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.o7g(decoder, index, builder instanceof ShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(ShortArraySerializer_0).s7g = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        encoder.w75(this.b7a_1, i, content[i]);
      }
       while (inductionVariable < size);
  };
  protoOf(ShortArraySerializer_0).m7a = function (encoder, content, size) {
    return this.s7g(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
  };
  var ShortArraySerializer_instance;
  function ShortArraySerializer_getInstance() {
    if (ShortArraySerializer_instance == null)
      new ShortArraySerializer_0();
    return ShortArraySerializer_instance;
  }
  function UShortArraySerializer_0() {
    UShortArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_7(Companion_getInstance_6()));
  }
  protoOf(UShortArraySerializer_0).v7g = function (_this__u8e3s4) {
    return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.v7g(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.jt_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).w7g = function (_this__u8e3s4) {
    return new UShortArrayBuilder(_this__u8e3s4);
  };
  protoOf(UShortArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.w7g(_this__u8e3s4 instanceof UShortArray ? _this__u8e3s4.jt_1 : THROW_CCE());
  };
  protoOf(UShortArraySerializer_0).x7g = function () {
    return _UShortArray___init__impl__9b26ef(0);
  };
  protoOf(UShortArraySerializer_0).k7a = function () {
    return new UShortArray(this.x7g());
  };
  protoOf(UShortArraySerializer_0).y7g = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.y74(this.b7a_1, index).c74();
    var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
    builder.b7h(tmp$ret$0);
  };
  protoOf(UShortArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.y7g(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.y7g(decoder, index, builder instanceof UShortArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UShortArraySerializer_0).c7h = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.d76(this.b7a_1, i);
        // Inline function 'kotlin.UShort.toShort' call
        var this_0 = UShortArray__get_impl_fnbhmx(content, i);
        var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
        tmp.l75(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UShortArraySerializer_0).m7a = function (encoder, content, size) {
    return this.c7h(encoder, content instanceof UShortArray ? content.jt_1 : THROW_CCE(), size);
  };
  var UShortArraySerializer_instance;
  function UShortArraySerializer_getInstance() {
    if (UShortArraySerializer_instance == null)
      new UShortArraySerializer_0();
    return UShortArraySerializer_instance;
  }
  function UByteArraySerializer_0() {
    UByteArraySerializer_instance = this;
    PrimitiveArraySerializer.call(this, serializer_6(Companion_getInstance_7()));
  }
  protoOf(UByteArraySerializer_0).f7h = function (_this__u8e3s4) {
    return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).r77 = function (_this__u8e3s4) {
    return this.f7h(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.zr_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).g7h = function (_this__u8e3s4) {
    return new UByteArrayBuilder(_this__u8e3s4);
  };
  protoOf(UByteArraySerializer_0).z77 = function (_this__u8e3s4) {
    return this.g7h(_this__u8e3s4 instanceof UByteArray ? _this__u8e3s4.zr_1 : THROW_CCE());
  };
  protoOf(UByteArraySerializer_0).h7h = function () {
    return _UByteArray___init__impl__ip4y9n(0);
  };
  protoOf(UByteArraySerializer_0).k7a = function () {
    return new UByteArray(this.h7h());
  };
  protoOf(UByteArraySerializer_0).i7h = function (decoder, index, builder, checkIndex) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.y74(this.b7a_1, index).b74();
    var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
    builder.l7h(tmp$ret$0);
  };
  protoOf(UByteArraySerializer_0).w78 = function (decoder, index, builder, checkIndex) {
    return this.i7h(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).l7a = function (decoder, index, builder, checkIndex) {
    return this.i7h(decoder, index, builder instanceof UByteArrayBuilder ? builder : THROW_CCE(), checkIndex);
  };
  protoOf(UByteArraySerializer_0).m7h = function (encoder, content, size) {
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = encoder.d76(this.b7a_1, i);
        // Inline function 'kotlin.UByte.toByte' call
        var this_0 = UByteArray__get_impl_t5f3hv(content, i);
        var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
        tmp.k75(tmp$ret$0);
      }
       while (inductionVariable < size);
  };
  protoOf(UByteArraySerializer_0).m7a = function (encoder, content, size) {
    return this.m7h(encoder, content instanceof UByteArray ? content.zr_1 : THROW_CCE(), size);
  };
  var UByteArraySerializer_instance;
  function UByteArraySerializer_getInstance() {
    if (UByteArraySerializer_instance == null)
      new UByteArraySerializer_0();
    return UByteArraySerializer_instance;
  }
  function ULongArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.w7f_1 = bufferWithData;
    this.x7f_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
    this.h7a(10);
  }
  protoOf(ULongArrayBuilder).d7a = function () {
    return this.x7f_1;
  };
  protoOf(ULongArrayBuilder).h7a = function (requiredCapacity) {
    if (_ULongArray___get_size__impl__ju6dtr(this.w7f_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.w7f_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.w7f_1), 2));
      tmp.w7f_1 = _ULongArray___init__impl__twm1l3_0(copyOf_5(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
    }
  };
  protoOf(ULongArrayBuilder).y7f = function (c) {
    this.o7a();
    var tmp = this.w7f_1;
    var _unary__edvuaz = this.x7f_1;
    this.x7f_1 = _unary__edvuaz + 1 | 0;
    ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
  };
  protoOf(ULongArrayBuilder).n7h = function () {
    var tmp0 = this.w7f_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.x7f_1;
    return _ULongArray___init__impl__twm1l3_0(copyOf_5(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
  };
  protoOf(ULongArrayBuilder).f7a = function () {
    return new ULongArray(this.n7h());
  };
  function UIntArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.g7g_1 = bufferWithData;
    this.h7g_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
    this.h7a(10);
  }
  protoOf(UIntArrayBuilder).d7a = function () {
    return this.h7g_1;
  };
  protoOf(UIntArrayBuilder).h7a = function (requiredCapacity) {
    if (_UIntArray___get_size__impl__r6l8ci(this.g7g_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.g7g_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.g7g_1), 2));
      tmp.g7g_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_4(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
    }
  };
  protoOf(UIntArrayBuilder).i7g = function (c) {
    this.o7a();
    var tmp = this.g7g_1;
    var _unary__edvuaz = this.h7g_1;
    this.h7g_1 = _unary__edvuaz + 1 | 0;
    UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
  };
  protoOf(UIntArrayBuilder).o7h = function () {
    var tmp0 = this.g7g_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.h7g_1;
    return _UIntArray___init__impl__ghjpc6_0(copyOf_4(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
  };
  protoOf(UIntArrayBuilder).f7a = function () {
    return new UIntArray(this.o7h());
  };
  function ShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.p7g_1 = bufferWithData;
    this.q7g_1 = bufferWithData.length;
    this.h7a(10);
  }
  protoOf(ShortArrayBuilder).d7a = function () {
    return this.q7g_1;
  };
  protoOf(ShortArrayBuilder).h7a = function (requiredCapacity) {
    if (this.p7g_1.length < requiredCapacity)
      this.p7g_1 = copyOf_6(this.p7g_1, coerceAtLeast(requiredCapacity, imul(this.p7g_1.length, 2)));
  };
  protoOf(ShortArrayBuilder).r7g = function (c) {
    this.o7a();
    var tmp = this.p7g_1;
    var _unary__edvuaz = this.q7g_1;
    this.q7g_1 = _unary__edvuaz + 1 | 0;
    tmp[_unary__edvuaz] = c;
  };
  protoOf(ShortArrayBuilder).f7a = function () {
    return copyOf_6(this.p7g_1, this.q7g_1);
  };
  function UShortArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.z7g_1 = bufferWithData;
    this.a7h_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
    this.h7a(10);
  }
  protoOf(UShortArrayBuilder).d7a = function () {
    return this.a7h_1;
  };
  protoOf(UShortArrayBuilder).h7a = function (requiredCapacity) {
    if (_UShortArray___get_size__impl__jqto1b(this.z7g_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.z7g_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.z7g_1), 2));
      tmp.z7g_1 = _UShortArray___init__impl__9b26ef_0(copyOf_6(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
    }
  };
  protoOf(UShortArrayBuilder).b7h = function (c) {
    this.o7a();
    var tmp = this.z7g_1;
    var _unary__edvuaz = this.a7h_1;
    this.a7h_1 = _unary__edvuaz + 1 | 0;
    UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
  };
  protoOf(UShortArrayBuilder).p7h = function () {
    var tmp0 = this.z7g_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.a7h_1;
    return _UShortArray___init__impl__9b26ef_0(copyOf_6(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
  };
  protoOf(UShortArrayBuilder).f7a = function () {
    return new UShortArray(this.p7h());
  };
  function UByteArrayBuilder(bufferWithData) {
    PrimitiveArrayBuilder.call(this);
    this.j7h_1 = bufferWithData;
    this.k7h_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
    this.h7a(10);
  }
  protoOf(UByteArrayBuilder).d7a = function () {
    return this.k7h_1;
  };
  protoOf(UByteArrayBuilder).h7a = function (requiredCapacity) {
    if (_UByteArray___get_size__impl__h6pkdv(this.j7h_1) < requiredCapacity) {
      var tmp = this;
      var tmp0 = this.j7h_1;
      // Inline function 'kotlin.collections.copyOf' call
      var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.j7h_1), 2));
      tmp.j7h_1 = _UByteArray___init__impl__ip4y9n_0(copyOf(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
    }
  };
  protoOf(UByteArrayBuilder).l7h = function (c) {
    this.o7a();
    var tmp = this.j7h_1;
    var _unary__edvuaz = this.k7h_1;
    this.k7h_1 = _unary__edvuaz + 1 | 0;
    UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
  };
  protoOf(UByteArrayBuilder).q7h = function () {
    var tmp0 = this.j7h_1;
    // Inline function 'kotlin.collections.copyOf' call
    var newSize = this.k7h_1;
    return _UByteArray___init__impl__ip4y9n_0(copyOf(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
  };
  protoOf(UByteArrayBuilder).f7a = function () {
    return new UByteArray(this.q7h());
  };
  function get_BUILTIN_SERIALIZERS() {
    _init_properties_Primitives_kt__k0eto4();
    return BUILTIN_SERIALIZERS;
  }
  var BUILTIN_SERIALIZERS;
  function StringSerializer() {
    StringSerializer_instance = this;
    this.r7h_1 = new PrimitiveSerialDescriptor_0('kotlin.String', STRING_getInstance());
  }
  protoOf(StringSerializer).y70 = function () {
    return this.r7h_1;
  };
  protoOf(StringSerializer).s7h = function (encoder, value) {
    return encoder.r75(value);
  };
  protoOf(StringSerializer).z70 = function (encoder, value) {
    return this.s7h(encoder, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
  };
  protoOf(StringSerializer).a71 = function (decoder) {
    return decoder.i74();
  };
  var StringSerializer_instance;
  function StringSerializer_getInstance() {
    if (StringSerializer_instance == null)
      new StringSerializer();
    return StringSerializer_instance;
  }
  function ByteSerializer() {
    ByteSerializer_instance = this;
    this.t7h_1 = new PrimitiveSerialDescriptor_0('kotlin.Byte', BYTE_getInstance());
  }
  protoOf(ByteSerializer).y70 = function () {
    return this.t7h_1;
  };
  protoOf(ByteSerializer).u7h = function (encoder, value) {
    return encoder.k75(value);
  };
  protoOf(ByteSerializer).z70 = function (encoder, value) {
    return this.u7h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ByteSerializer).a71 = function (decoder) {
    return decoder.b74();
  };
  var ByteSerializer_instance;
  function ByteSerializer_getInstance() {
    if (ByteSerializer_instance == null)
      new ByteSerializer();
    return ByteSerializer_instance;
  }
  function LongSerializer() {
    LongSerializer_instance = this;
    this.v7h_1 = new PrimitiveSerialDescriptor_0('kotlin.Long', LONG_getInstance());
  }
  protoOf(LongSerializer).y70 = function () {
    return this.v7h_1;
  };
  protoOf(LongSerializer).w7h = function (encoder, value) {
    return encoder.n75(value);
  };
  protoOf(LongSerializer).z70 = function (encoder, value) {
    return this.w7h(encoder, value instanceof Long ? value : THROW_CCE());
  };
  protoOf(LongSerializer).a71 = function (decoder) {
    return decoder.e74();
  };
  var LongSerializer_instance;
  function LongSerializer_getInstance() {
    if (LongSerializer_instance == null)
      new LongSerializer();
    return LongSerializer_instance;
  }
  function DoubleSerializer() {
    DoubleSerializer_instance = this;
    this.x7h_1 = new PrimitiveSerialDescriptor_0('kotlin.Double', DOUBLE_getInstance());
  }
  protoOf(DoubleSerializer).y70 = function () {
    return this.x7h_1;
  };
  protoOf(DoubleSerializer).y7h = function (encoder, value) {
    return encoder.p75(value);
  };
  protoOf(DoubleSerializer).z70 = function (encoder, value) {
    return this.y7h(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(DoubleSerializer).a71 = function (decoder) {
    return decoder.g74();
  };
  var DoubleSerializer_instance;
  function DoubleSerializer_getInstance() {
    if (DoubleSerializer_instance == null)
      new DoubleSerializer();
    return DoubleSerializer_instance;
  }
  function IntSerializer() {
    IntSerializer_instance = this;
    this.z7h_1 = new PrimitiveSerialDescriptor_0('kotlin.Int', INT_getInstance());
  }
  protoOf(IntSerializer).y70 = function () {
    return this.z7h_1;
  };
  protoOf(IntSerializer).a7i = function (encoder, value) {
    return encoder.m75(value);
  };
  protoOf(IntSerializer).z70 = function (encoder, value) {
    return this.a7i(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(IntSerializer).a71 = function (decoder) {
    return decoder.d74();
  };
  var IntSerializer_instance;
  function IntSerializer_getInstance() {
    if (IntSerializer_instance == null)
      new IntSerializer();
    return IntSerializer_instance;
  }
  function BooleanSerializer() {
    BooleanSerializer_instance = this;
    this.b7i_1 = new PrimitiveSerialDescriptor_0('kotlin.Boolean', BOOLEAN_getInstance());
  }
  protoOf(BooleanSerializer).y70 = function () {
    return this.b7i_1;
  };
  protoOf(BooleanSerializer).c7i = function (encoder, value) {
    return encoder.j75(value);
  };
  protoOf(BooleanSerializer).z70 = function (encoder, value) {
    return this.c7i(encoder, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
  };
  protoOf(BooleanSerializer).a71 = function (decoder) {
    return decoder.a74();
  };
  var BooleanSerializer_instance;
  function BooleanSerializer_getInstance() {
    if (BooleanSerializer_instance == null)
      new BooleanSerializer();
    return BooleanSerializer_instance;
  }
  function FloatSerializer() {
    FloatSerializer_instance = this;
    this.d7i_1 = new PrimitiveSerialDescriptor_0('kotlin.Float', FLOAT_getInstance());
  }
  protoOf(FloatSerializer).y70 = function () {
    return this.d7i_1;
  };
  protoOf(FloatSerializer).e7i = function (encoder, value) {
    return encoder.o75(value);
  };
  protoOf(FloatSerializer).z70 = function (encoder, value) {
    return this.e7i(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(FloatSerializer).a71 = function (decoder) {
    return decoder.f74();
  };
  var FloatSerializer_instance;
  function FloatSerializer_getInstance() {
    if (FloatSerializer_instance == null)
      new FloatSerializer();
    return FloatSerializer_instance;
  }
  function builtinSerializerOrNull(_this__u8e3s4) {
    _init_properties_Primitives_kt__k0eto4();
    var tmp = get_BUILTIN_SERIALIZERS().w2(_this__u8e3s4);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : THROW_CCE();
  }
  function PrimitiveDescriptorSafe(serialName, kind) {
    _init_properties_Primitives_kt__k0eto4();
    checkNameIsNotAPrimitive(serialName);
    return new PrimitiveSerialDescriptor_0(serialName, kind);
  }
  function checkNameIsNotAPrimitive(serialName) {
    _init_properties_Primitives_kt__k0eto4();
    var values = get_BUILTIN_SERIALIZERS().y2();
    var _iterator__ex2g4s = values.t();
    while (_iterator__ex2g4s.u()) {
      var primitive = _iterator__ex2g4s.v();
      var primitiveName = primitive.y70().z71();
      if (serialName === primitiveName) {
        throw IllegalArgumentException_init_$Create$(trimIndent('\n                The name of serial descriptor should uniquely identify associated serializer.\n                For serial name ' + serialName + ' there already exists ' + getKClassFromExpression(primitive).o() + '.\n                Please refer to SerialDescriptor documentation for additional information.\n            '));
      }
    }
  }
  function error_0($this) {
    throw IllegalStateException_init_$Create$('Primitive descriptor ' + $this.f7i_1 + ' does not have elements');
  }
  function PrimitiveSerialDescriptor_0(serialName, kind) {
    this.f7i_1 = serialName;
    this.g7i_1 = kind;
  }
  protoOf(PrimitiveSerialDescriptor_0).z71 = function () {
    return this.f7i_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).u72 = function () {
    return this.g7i_1;
  };
  protoOf(PrimitiveSerialDescriptor_0).w72 = function () {
    return 0;
  };
  protoOf(PrimitiveSerialDescriptor_0).y72 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).z72 = function (name) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).c73 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).b73 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).a73 = function (index) {
    error_0(this);
  };
  protoOf(PrimitiveSerialDescriptor_0).toString = function () {
    return 'PrimitiveDescriptor(' + this.f7i_1 + ')';
  };
  protoOf(PrimitiveSerialDescriptor_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof PrimitiveSerialDescriptor_0))
      return false;
    if (this.f7i_1 === other.f7i_1 && equals(this.g7i_1, other.g7i_1))
      return true;
    return false;
  };
  protoOf(PrimitiveSerialDescriptor_0).hashCode = function () {
    return getStringHashCode(this.f7i_1) + imul(31, this.g7i_1.hashCode()) | 0;
  };
  function CharSerializer() {
    CharSerializer_instance = this;
    this.h7i_1 = new PrimitiveSerialDescriptor_0('kotlin.Char', CHAR_getInstance());
  }
  protoOf(CharSerializer).y70 = function () {
    return this.h7i_1;
  };
  protoOf(CharSerializer).i7i = function (encoder, value) {
    return encoder.q75(value);
  };
  protoOf(CharSerializer).z70 = function (encoder, value) {
    return this.i7i(encoder, value instanceof Char ? value.f2_1 : THROW_CCE());
  };
  protoOf(CharSerializer).j7i = function (decoder) {
    return decoder.h74();
  };
  protoOf(CharSerializer).a71 = function (decoder) {
    return new Char(this.j7i(decoder));
  };
  var CharSerializer_instance;
  function CharSerializer_getInstance() {
    if (CharSerializer_instance == null)
      new CharSerializer();
    return CharSerializer_instance;
  }
  function ShortSerializer() {
    ShortSerializer_instance = this;
    this.k7i_1 = new PrimitiveSerialDescriptor_0('kotlin.Short', SHORT_getInstance());
  }
  protoOf(ShortSerializer).y70 = function () {
    return this.k7i_1;
  };
  protoOf(ShortSerializer).l7i = function (encoder, value) {
    return encoder.l75(value);
  };
  protoOf(ShortSerializer).z70 = function (encoder, value) {
    return this.l7i(encoder, (!(value == null) ? typeof value === 'number' : false) ? value : THROW_CCE());
  };
  protoOf(ShortSerializer).a71 = function (decoder) {
    return decoder.c74();
  };
  var ShortSerializer_instance;
  function ShortSerializer_getInstance() {
    if (ShortSerializer_instance == null)
      new ShortSerializer();
    return ShortSerializer_instance;
  }
  function UnitSerializer() {
    UnitSerializer_instance = this;
    this.m7i_1 = new ObjectSerializer('kotlin.Unit', Unit_instance);
  }
  protoOf(UnitSerializer).y70 = function () {
    return this.m7i_1.y70();
  };
  protoOf(UnitSerializer).n7i = function (encoder, value) {
    this.m7i_1.q71(encoder, Unit_instance);
  };
  protoOf(UnitSerializer).z70 = function (encoder, value) {
    return this.n7i(encoder, value instanceof Unit ? value : THROW_CCE());
  };
  protoOf(UnitSerializer).o7i = function (decoder) {
    this.m7i_1.a71(decoder);
  };
  protoOf(UnitSerializer).a71 = function (decoder) {
    this.o7i(decoder);
    return Unit_instance;
  };
  var UnitSerializer_instance;
  function UnitSerializer_getInstance() {
    if (UnitSerializer_instance == null)
      new UnitSerializer();
    return UnitSerializer_instance;
  }
  var properties_initialized_Primitives_kt_6dpii6;
  function _init_properties_Primitives_kt__k0eto4() {
    if (!properties_initialized_Primitives_kt_6dpii6) {
      properties_initialized_Primitives_kt_6dpii6 = true;
      BUILTIN_SERIALIZERS = initBuiltins();
    }
  }
  function NamedValueDecoder() {
    TaggedDecoder.call(this);
  }
  protoOf(NamedValueDecoder).r7i = function (_this__u8e3s4, index) {
    return this.t7i(this.s7i(_this__u8e3s4, index));
  };
  protoOf(NamedValueDecoder).t7i = function (nestedName) {
    var tmp0_elvis_lhs = this.w7i();
    return this.x7i(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueDecoder).s7i = function (descriptor, index) {
    return descriptor.y72(index);
  };
  protoOf(NamedValueDecoder).x7i = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  protoOf(NamedValueDecoder).y7i = function () {
    return this.u7i_1.r() ? '$' : joinToString(this.u7i_1, '.', '$.');
  };
  function NamedValueEncoder() {
    TaggedEncoder.call(this);
  }
  protoOf(NamedValueEncoder).r7i = function (_this__u8e3s4, index) {
    return this.t7i(this.s7i(_this__u8e3s4, index));
  };
  protoOf(NamedValueEncoder).t7i = function (nestedName) {
    var tmp0_elvis_lhs = this.w7i();
    return this.x7i(tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs, nestedName);
  };
  protoOf(NamedValueEncoder).s7i = function (descriptor, index) {
    return descriptor.y72(index);
  };
  protoOf(NamedValueEncoder).x7i = function (parentName, childName) {
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(parentName) === 0) {
      tmp = childName;
    } else {
      tmp = parentName + '.' + childName;
    }
    return tmp;
  };
  function tagBlock($this, tag, block) {
    $this.m7j(tag);
    var r = block();
    if (!$this.v7i_1) {
      $this.n7j();
    }
    $this.v7i_1 = false;
    return r;
  }
  function TaggedDecoder$decodeSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      return this$0.l74($deserializer, $previousValue);
    };
  }
  function TaggedDecoder$decodeNullableSerializableElement$lambda(this$0, $deserializer, $previousValue) {
    return function () {
      var tmp0 = this$0;
      // Inline function 'kotlinx.serialization.encoding.decodeIfNullable' call
      var isNullabilitySupported = $deserializer.y70().n72();
      var tmp;
      if (isNullabilitySupported || tmp0.y73()) {
        tmp = this$0.l74($deserializer, $previousValue);
      } else {
        tmp = tmp0.z73();
      }
      return tmp;
    };
  }
  function TaggedDecoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.u7i_1 = ArrayList_init_$Create$_0();
    this.v7i_1 = false;
  }
  protoOf(TaggedDecoder).c75 = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedDecoder).z7i = function (tag) {
    throw SerializationException_init_$Create$_0(toString(getKClassFromExpression(this)) + " can't retrieve untyped values");
  };
  protoOf(TaggedDecoder).a7j = function (tag) {
    return true;
  };
  protoOf(TaggedDecoder).b7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'boolean' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).c7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).d7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).e7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).f7j = function (tag) {
    var tmp = this.z7i(tag);
    return tmp instanceof Long ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).g7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).h7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).i7j = function (tag) {
    var tmp = this.z7i(tag);
    return tmp instanceof Char ? tmp.f2_1 : THROW_CCE();
  };
  protoOf(TaggedDecoder).j7j = function (tag) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'string' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).k7j = function (tag, enumDescriptor) {
    var tmp = this.z7i(tag);
    return typeof tmp === 'number' ? tmp : THROW_CCE();
  };
  protoOf(TaggedDecoder).l7j = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.m7j(tag);
    return this;
  };
  protoOf(TaggedDecoder).l74 = function (deserializer, previousValue) {
    return this.m74(deserializer);
  };
  protoOf(TaggedDecoder).k74 = function (descriptor) {
    return this.l7j(this.n7j(), descriptor);
  };
  protoOf(TaggedDecoder).y73 = function () {
    var tmp0_elvis_lhs = this.w7i();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return false;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var currentTag = tmp;
    return this.a7j(currentTag);
  };
  protoOf(TaggedDecoder).z73 = function () {
    return null;
  };
  protoOf(TaggedDecoder).a74 = function () {
    return this.b7j(this.n7j());
  };
  protoOf(TaggedDecoder).b74 = function () {
    return this.c7j(this.n7j());
  };
  protoOf(TaggedDecoder).c74 = function () {
    return this.d7j(this.n7j());
  };
  protoOf(TaggedDecoder).d74 = function () {
    return this.e7j(this.n7j());
  };
  protoOf(TaggedDecoder).e74 = function () {
    return this.f7j(this.n7j());
  };
  protoOf(TaggedDecoder).f74 = function () {
    return this.g7j(this.n7j());
  };
  protoOf(TaggedDecoder).g74 = function () {
    return this.h7j(this.n7j());
  };
  protoOf(TaggedDecoder).h74 = function () {
    return this.i7j(this.n7j());
  };
  protoOf(TaggedDecoder).i74 = function () {
    return this.j7j(this.n7j());
  };
  protoOf(TaggedDecoder).j74 = function (enumDescriptor) {
    return this.k7j(this.n7j(), enumDescriptor);
  };
  protoOf(TaggedDecoder).n74 = function (descriptor) {
    return this;
  };
  protoOf(TaggedDecoder).o74 = function (descriptor) {
  };
  protoOf(TaggedDecoder).p74 = function (descriptor, index) {
    return this.b7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).q74 = function (descriptor, index) {
    return this.c7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).r74 = function (descriptor, index) {
    return this.d7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).s74 = function (descriptor, index) {
    return this.e7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).t74 = function (descriptor, index) {
    return this.f7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).u74 = function (descriptor, index) {
    return this.g7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).v74 = function (descriptor, index) {
    return this.h7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).w74 = function (descriptor, index) {
    return this.i7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).x74 = function (descriptor, index) {
    return this.j7j(this.r7i(descriptor, index));
  };
  protoOf(TaggedDecoder).y74 = function (descriptor, index) {
    return this.l7j(this.r7i(descriptor, index), descriptor.b73(index));
  };
  protoOf(TaggedDecoder).z74 = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.r7i(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).b75 = function (descriptor, index, deserializer, previousValue) {
    var tmp = this.r7i(descriptor, index);
    return tagBlock(this, tmp, TaggedDecoder$decodeNullableSerializableElement$lambda(this, deserializer, previousValue));
  };
  protoOf(TaggedDecoder).w7i = function () {
    return lastOrNull(this.u7i_1);
  };
  protoOf(TaggedDecoder).m7j = function (name) {
    this.u7i_1.j1(name);
  };
  protoOf(TaggedDecoder).n7j = function () {
    var r = this.u7i_1.h3(get_lastIndex_0(this.u7i_1));
    this.v7i_1 = true;
    return r;
  };
  function encodeElement($this, desc, index) {
    var tag = $this.r7i(desc, index);
    $this.m7j(tag);
    return true;
  }
  function TaggedEncoder() {
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.p7j_1 = ArrayList_init_$Create$_0();
  }
  protoOf(TaggedEncoder).c75 = function () {
    return EmptySerializersModule_0();
  };
  protoOf(TaggedEncoder).q7j = function (tag, value) {
    throw SerializationException_init_$Create$_0('Non-serializable ' + toString(getKClassFromExpression(value)) + ' is not supported by ' + toString(getKClassFromExpression(this)) + ' encoder');
  };
  protoOf(TaggedEncoder).r7j = function (tag) {
  };
  protoOf(TaggedEncoder).s7j = function (tag) {
    throw SerializationException_init_$Create$_0('null is not supported');
  };
  protoOf(TaggedEncoder).t7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).u7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).v7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).w7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).x7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).y7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).z7j = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).a7k = function (tag, value) {
    return this.q7j(tag, new Char(value));
  };
  protoOf(TaggedEncoder).b7k = function (tag, value) {
    return this.q7j(tag, value);
  };
  protoOf(TaggedEncoder).c7k = function (tag, enumDescriptor, ordinal) {
    return this.q7j(tag, ordinal);
  };
  protoOf(TaggedEncoder).d7k = function (tag, inlineDescriptor) {
    // Inline function 'kotlin.apply' call
    this.m7j(tag);
    return this;
  };
  protoOf(TaggedEncoder).t75 = function (descriptor) {
    return this.d7k(this.n7j(), descriptor);
  };
  protoOf(TaggedEncoder).i76 = function () {
    return this.r7j(this.f7k());
  };
  protoOf(TaggedEncoder).i75 = function () {
    return this.s7j(this.n7j());
  };
  protoOf(TaggedEncoder).j75 = function (value) {
    return this.z7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).k75 = function (value) {
    return this.u7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).l75 = function (value) {
    return this.v7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).m75 = function (value) {
    return this.t7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).n75 = function (value) {
    return this.w7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).o75 = function (value) {
    return this.x7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).p75 = function (value) {
    return this.y7j(this.n7j(), value);
  };
  protoOf(TaggedEncoder).q75 = function (value) {
    return this.a7k(this.n7j(), value);
  };
  protoOf(TaggedEncoder).r75 = function (value) {
    return this.b7k(this.n7j(), value);
  };
  protoOf(TaggedEncoder).s75 = function (enumDescriptor, index) {
    return this.c7k(this.n7j(), enumDescriptor, index);
  };
  protoOf(TaggedEncoder).n74 = function (descriptor) {
    return this;
  };
  protoOf(TaggedEncoder).o74 = function (descriptor) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.p7j_1.r()) {
      this.n7j();
    }
    this.e7k(descriptor);
  };
  protoOf(TaggedEncoder).e7k = function (descriptor) {
  };
  protoOf(TaggedEncoder).u75 = function (descriptor, index, value) {
    return this.z7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).v75 = function (descriptor, index, value) {
    return this.u7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).w75 = function (descriptor, index, value) {
    return this.v7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).x75 = function (descriptor, index, value) {
    return this.t7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).y75 = function (descriptor, index, value) {
    return this.w7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).z75 = function (descriptor, index, value) {
    return this.x7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).a76 = function (descriptor, index, value) {
    return this.y7j(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).b76 = function (descriptor, index, value) {
    return this.a7k(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).c76 = function (descriptor, index, value) {
    return this.b7k(this.r7i(descriptor, index), value);
  };
  protoOf(TaggedEncoder).d76 = function (descriptor, index) {
    return this.d7k(this.r7i(descriptor, index), descriptor.b73(index));
  };
  protoOf(TaggedEncoder).e76 = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.f76(serializer, value);
    }
  };
  protoOf(TaggedEncoder).g76 = function (descriptor, index, serializer, value) {
    if (encodeElement(this, descriptor, index)) {
      this.h76(serializer, value);
    }
  };
  protoOf(TaggedEncoder).f7k = function () {
    return last(this.p7j_1);
  };
  protoOf(TaggedEncoder).w7i = function () {
    return lastOrNull(this.p7j_1);
  };
  protoOf(TaggedEncoder).m7j = function (name) {
    this.p7j_1.j1(name);
  };
  protoOf(TaggedEncoder).n7j = function () {
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!this.p7j_1.r()) {
      tmp = this.p7j_1.h3(get_lastIndex_0(this.p7j_1));
    } else {
      throw SerializationException_init_$Create$_0('No tag in stack for requested element');
    }
    return tmp;
  };
  function get_NULL() {
    _init_properties_Tuples_kt__dz0qyd();
    return NULL;
  }
  var NULL;
  function MapEntry(key, value) {
    this.g7k_1 = key;
    this.h7k_1 = value;
  }
  protoOf(MapEntry).t1 = function () {
    return this.g7k_1;
  };
  protoOf(MapEntry).u1 = function () {
    return this.h7k_1;
  };
  protoOf(MapEntry).toString = function () {
    return 'MapEntry(key=' + toString_0(this.g7k_1) + ', value=' + toString_0(this.h7k_1) + ')';
  };
  protoOf(MapEntry).hashCode = function () {
    var result = this.g7k_1 == null ? 0 : hashCode(this.g7k_1);
    result = imul(result, 31) + (this.h7k_1 == null ? 0 : hashCode(this.h7k_1)) | 0;
    return result;
  };
  protoOf(MapEntry).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MapEntry))
      return false;
    if (!equals(this.g7k_1, other.g7k_1))
      return false;
    if (!equals(this.h7k_1, other.h7k_1))
      return false;
    return true;
  };
  function MapEntrySerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildSerialDescriptor) {
      $this$buildSerialDescriptor.m71('key', $keySerializer.y70());
      $this$buildSerialDescriptor.m71('value', $valueSerializer.y70());
      return Unit_instance;
    };
  }
  function MapEntrySerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    var tmp_0 = MAP_getInstance();
    tmp.k7k_1 = buildSerialDescriptor('kotlin.collections.Map.Entry', tmp_0, [], MapEntrySerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(MapEntrySerializer_0).y70 = function () {
    return this.k7k_1;
  };
  protoOf(MapEntrySerializer_0).l7k = function (_this__u8e3s4) {
    return _this__u8e3s4.t1();
  };
  protoOf(MapEntrySerializer_0).m7k = function (_this__u8e3s4) {
    return this.l7k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).n7k = function (_this__u8e3s4) {
    return _this__u8e3s4.u1();
  };
  protoOf(MapEntrySerializer_0).o7k = function (_this__u8e3s4) {
    return this.n7k((!(_this__u8e3s4 == null) ? isInterface(_this__u8e3s4, Entry) : false) ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(MapEntrySerializer_0).p7k = function (key, value) {
    return new MapEntry(key, value);
  };
  function PairSerializer$descriptor$lambda($keySerializer, $valueSerializer) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.m71('first', $keySerializer.y70());
      $this$buildClassSerialDescriptor.m71('second', $valueSerializer.y70());
      return Unit_instance;
    };
  }
  function PairSerializer_0(keySerializer, valueSerializer) {
    KeyValueSerializer.call(this, keySerializer, valueSerializer);
    var tmp = this;
    tmp.v7k_1 = buildClassSerialDescriptor('kotlin.Pair', [], PairSerializer$descriptor$lambda(keySerializer, valueSerializer));
  }
  protoOf(PairSerializer_0).y70 = function () {
    return this.v7k_1;
  };
  protoOf(PairSerializer_0).w7k = function (_this__u8e3s4) {
    return _this__u8e3s4.xh_1;
  };
  protoOf(PairSerializer_0).m7k = function (_this__u8e3s4) {
    return this.w7k(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).x7k = function (_this__u8e3s4) {
    return _this__u8e3s4.yh_1;
  };
  protoOf(PairSerializer_0).o7k = function (_this__u8e3s4) {
    return this.x7k(_this__u8e3s4 instanceof Pair ? _this__u8e3s4 : THROW_CCE());
  };
  protoOf(PairSerializer_0).p7k = function (key, value) {
    return to(key, value);
  };
  function decodeSequentially_1($this, composite) {
    var a = composite.a75($this.b7l_1, 0, $this.y7k_1);
    var b = composite.a75($this.b7l_1, 1, $this.z7k_1);
    var c = composite.a75($this.b7l_1, 2, $this.a7l_1);
    composite.o74($this.b7l_1);
    return new Triple(a, b, c);
  }
  function decodeStructure($this, composite) {
    var a = get_NULL();
    var b = get_NULL();
    var c = get_NULL();
    mainLoop: while (true) {
      var index = composite.e75($this.b7l_1);
      switch (index) {
        case -1:
          break mainLoop;
        case 0:
          a = composite.a75($this.b7l_1, 0, $this.y7k_1);
          break;
        case 1:
          b = composite.a75($this.b7l_1, 1, $this.z7k_1);
          break;
        case 2:
          c = composite.a75($this.b7l_1, 2, $this.a7l_1);
          break;
        default:
          throw SerializationException_init_$Create$_0('Unexpected index ' + index);
      }
    }
    composite.o74($this.b7l_1);
    if (a === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'first' is missing");
    if (b === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'second' is missing");
    if (c === get_NULL())
      throw SerializationException_init_$Create$_0("Element 'third' is missing");
    return new Triple(a, b, c);
  }
  function TripleSerializer$descriptor$lambda(this$0) {
    return function ($this$buildClassSerialDescriptor) {
      $this$buildClassSerialDescriptor.m71('first', this$0.y7k_1.y70());
      $this$buildClassSerialDescriptor.m71('second', this$0.z7k_1.y70());
      $this$buildClassSerialDescriptor.m71('third', this$0.a7l_1.y70());
      return Unit_instance;
    };
  }
  function TripleSerializer_0(aSerializer, bSerializer, cSerializer) {
    this.y7k_1 = aSerializer;
    this.z7k_1 = bSerializer;
    this.a7l_1 = cSerializer;
    var tmp = this;
    tmp.b7l_1 = buildClassSerialDescriptor('kotlin.Triple', [], TripleSerializer$descriptor$lambda(this));
  }
  protoOf(TripleSerializer_0).y70 = function () {
    return this.b7l_1;
  };
  protoOf(TripleSerializer_0).c7l = function (encoder, value) {
    var structuredEncoder = encoder.n74(this.b7l_1);
    structuredEncoder.e76(this.b7l_1, 0, this.y7k_1, value.er_1);
    structuredEncoder.e76(this.b7l_1, 1, this.z7k_1, value.fr_1);
    structuredEncoder.e76(this.b7l_1, 2, this.a7l_1, value.gr_1);
    structuredEncoder.o74(this.b7l_1);
  };
  protoOf(TripleSerializer_0).z70 = function (encoder, value) {
    return this.c7l(encoder, value instanceof Triple ? value : THROW_CCE());
  };
  protoOf(TripleSerializer_0).a71 = function (decoder) {
    var composite = decoder.n74(this.b7l_1);
    if (composite.d75()) {
      return decodeSequentially_1(this, composite);
    }
    return decodeStructure(this, composite);
  };
  function KeyValueSerializer(keySerializer, valueSerializer) {
    this.q7k_1 = keySerializer;
    this.r7k_1 = valueSerializer;
  }
  protoOf(KeyValueSerializer).s7k = function (encoder, value) {
    var structuredEncoder = encoder.n74(this.y70());
    structuredEncoder.e76(this.y70(), 0, this.q7k_1, this.m7k(value));
    structuredEncoder.e76(this.y70(), 1, this.r7k_1, this.o7k(value));
    structuredEncoder.o74(this.y70());
  };
  protoOf(KeyValueSerializer).z70 = function (encoder, value) {
    return this.s7k(encoder, value);
  };
  protoOf(KeyValueSerializer).a71 = function (decoder) {
    // Inline function 'kotlinx.serialization.encoding.decodeStructure' call
    var descriptor = this.y70();
    var composite = decoder.n74(descriptor);
    var tmp$ret$1;
    $l$block: {
      if (composite.d75()) {
        var key = composite.a75(this.y70(), 0, this.q7k_1);
        var value = composite.a75(this.y70(), 1, this.r7k_1);
        tmp$ret$1 = this.p7k(key, value);
        break $l$block;
      }
      var key_0 = get_NULL();
      var value_0 = get_NULL();
      mainLoop: while (true) {
        var idx = composite.e75(this.y70());
        switch (idx) {
          case -1:
            break mainLoop;
          case 0:
            key_0 = composite.a75(this.y70(), 0, this.q7k_1);
            break;
          case 1:
            value_0 = composite.a75(this.y70(), 1, this.r7k_1);
            break;
          default:
            throw SerializationException_init_$Create$_0('Invalid index: ' + idx);
        }
      }
      if (key_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'key' is missing");
      if (value_0 === get_NULL())
        throw SerializationException_init_$Create$_0("Element 'value' is missing");
      tmp$ret$1 = this.p7k(key_0, value_0);
    }
    var result = tmp$ret$1;
    composite.o74(descriptor);
    return result;
  };
  var properties_initialized_Tuples_kt_3vs7ar;
  function _init_properties_Tuples_kt__dz0qyd() {
    if (!properties_initialized_Tuples_kt_3vs7ar) {
      properties_initialized_Tuples_kt_3vs7ar = true;
      NULL = new Object();
    }
  }
  function ULongSerializer() {
    ULongSerializer_instance = this;
    this.d7l_1 = InlinePrimitiveDescriptor('kotlin.ULong', serializer_13(Companion_getInstance_3()));
  }
  protoOf(ULongSerializer).y70 = function () {
    return this.d7l_1;
  };
  protoOf(ULongSerializer).e7l = function (encoder, value) {
    var tmp = encoder.t75(this.d7l_1);
    // Inline function 'kotlin.ULong.toLong' call
    var tmp$ret$0 = _ULong___get_data__impl__fggpzb(value);
    tmp.n75(tmp$ret$0);
  };
  protoOf(ULongSerializer).z70 = function (encoder, value) {
    return this.e7l(encoder, value instanceof ULong ? value.ss_1 : THROW_CCE());
  };
  protoOf(ULongSerializer).f7l = function (decoder) {
    // Inline function 'kotlin.toULong' call
    var this_0 = decoder.k74(this.d7l_1).e74();
    return _ULong___init__impl__c78o9k(this_0);
  };
  protoOf(ULongSerializer).a71 = function (decoder) {
    return new ULong(this.f7l(decoder));
  };
  var ULongSerializer_instance;
  function ULongSerializer_getInstance() {
    if (ULongSerializer_instance == null)
      new ULongSerializer();
    return ULongSerializer_instance;
  }
  function UIntSerializer() {
    UIntSerializer_instance = this;
    this.g7l_1 = InlinePrimitiveDescriptor('kotlin.UInt', serializer_3(IntCompanionObject_instance));
  }
  protoOf(UIntSerializer).y70 = function () {
    return this.g7l_1;
  };
  protoOf(UIntSerializer).h7l = function (encoder, value) {
    var tmp = encoder.t75(this.g7l_1);
    // Inline function 'kotlin.UInt.toInt' call
    var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(value);
    tmp.m75(tmp$ret$0);
  };
  protoOf(UIntSerializer).z70 = function (encoder, value) {
    return this.h7l(encoder, value instanceof UInt ? value.gs_1 : THROW_CCE());
  };
  protoOf(UIntSerializer).i7l = function (decoder) {
    // Inline function 'kotlin.toUInt' call
    var this_0 = decoder.k74(this.g7l_1).d74();
    return _UInt___init__impl__l7qpdl(this_0);
  };
  protoOf(UIntSerializer).a71 = function (decoder) {
    return new UInt(this.i7l(decoder));
  };
  var UIntSerializer_instance;
  function UIntSerializer_getInstance() {
    if (UIntSerializer_instance == null)
      new UIntSerializer();
    return UIntSerializer_instance;
  }
  function UByteSerializer() {
    UByteSerializer_instance = this;
    this.j7l_1 = InlinePrimitiveDescriptor('kotlin.UByte', serializer_8(ByteCompanionObject_instance));
  }
  protoOf(UByteSerializer).y70 = function () {
    return this.j7l_1;
  };
  protoOf(UByteSerializer).k7l = function (encoder, value) {
    var tmp = encoder.t75(this.j7l_1);
    // Inline function 'kotlin.UByte.toByte' call
    var tmp$ret$0 = _UByte___get_data__impl__jof9qr(value);
    tmp.k75(tmp$ret$0);
  };
  protoOf(UByteSerializer).z70 = function (encoder, value) {
    return this.k7l(encoder, value instanceof UByte ? value.ur_1 : THROW_CCE());
  };
  protoOf(UByteSerializer).l7l = function (decoder) {
    // Inline function 'kotlin.toUByte' call
    var this_0 = decoder.k74(this.j7l_1).b74();
    return _UByte___init__impl__g9hnc4(this_0);
  };
  protoOf(UByteSerializer).a71 = function (decoder) {
    return new UByte(this.l7l(decoder));
  };
  var UByteSerializer_instance;
  function UByteSerializer_getInstance() {
    if (UByteSerializer_instance == null)
      new UByteSerializer();
    return UByteSerializer_instance;
  }
  function UShortSerializer() {
    UShortSerializer_instance = this;
    this.m7l_1 = InlinePrimitiveDescriptor('kotlin.UShort', serializer_14(ShortCompanionObject_instance));
  }
  protoOf(UShortSerializer).y70 = function () {
    return this.m7l_1;
  };
  protoOf(UShortSerializer).n7l = function (encoder, value) {
    var tmp = encoder.t75(this.m7l_1);
    // Inline function 'kotlin.UShort.toShort' call
    var tmp$ret$0 = _UShort___get_data__impl__g0245(value);
    tmp.l75(tmp$ret$0);
  };
  protoOf(UShortSerializer).z70 = function (encoder, value) {
    return this.n7l(encoder, value instanceof UShort ? value.et_1 : THROW_CCE());
  };
  protoOf(UShortSerializer).o7l = function (decoder) {
    // Inline function 'kotlin.toUShort' call
    var this_0 = decoder.k74(this.m7l_1).c74();
    return _UShort___init__impl__jigrne(this_0);
  };
  protoOf(UShortSerializer).a71 = function (decoder) {
    return new UShort(this.o7l(decoder));
  };
  var UShortSerializer_instance;
  function UShortSerializer_getInstance() {
    if (UShortSerializer_instance == null)
      new UShortSerializer();
    return UShortSerializer_instance;
  }
  function get_EmptySerializersModuleLegacyJs() {
    _init_properties_SerializersModule_kt__u78ha3();
    return EmptySerializersModule;
  }
  var EmptySerializersModule;
  function SerializersModule() {
  }
  protoOf(SerializersModule).j72 = function (kClass, typeArgumentsSerializers, $super) {
    typeArgumentsSerializers = typeArgumentsSerializers === VOID ? emptyList() : typeArgumentsSerializers;
    return $super === VOID ? this.k72(kClass, typeArgumentsSerializers) : $super.k72.call(this, kClass, typeArgumentsSerializers);
  };
  function SerialModuleImpl(class2ContextualFactory, polyBase2Serializers, polyBase2DefaultSerializerProvider, polyBase2NamedSerializers, polyBase2DefaultDeserializerProvider, hasInterfaceContextualSerializers) {
    SerializersModule.call(this);
    this.q7l_1 = class2ContextualFactory;
    this.r7l_1 = polyBase2Serializers;
    this.s7l_1 = polyBase2DefaultSerializerProvider;
    this.t7l_1 = polyBase2NamedSerializers;
    this.u7l_1 = polyBase2DefaultDeserializerProvider;
    this.v7l_1 = hasInterfaceContextualSerializers;
  }
  protoOf(SerialModuleImpl).i72 = function () {
    return this.v7l_1;
  };
  protoOf(SerialModuleImpl).m76 = function (baseClass, value) {
    if (!baseClass.ob(value))
      return null;
    var tmp0_safe_receiver = this.r7l_1.w2(baseClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w2(getKClassFromExpression(value));
    var registered = (!(tmp == null) ? isInterface(tmp, SerializationStrategy) : false) ? tmp : null;
    if (!(registered == null))
      return registered;
    var tmp_0 = this.s7l_1.w2(baseClass);
    var tmp1_safe_receiver = (!(tmp_0 == null) ? typeof tmp_0 === 'function' : false) ? tmp_0 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(value);
  };
  protoOf(SerialModuleImpl).l76 = function (baseClass, serializedClassName) {
    var tmp0_safe_receiver = this.t7l_1.w2(baseClass);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.collections.get' call
      tmp = (isInterface(tmp0_safe_receiver, KtMap) ? tmp0_safe_receiver : THROW_CCE()).w2(serializedClassName);
    }
    var tmp_0 = tmp;
    var registered = (!(tmp_0 == null) ? isInterface(tmp_0, KSerializer) : false) ? tmp_0 : null;
    if (!(registered == null))
      return registered;
    var tmp_1 = this.u7l_1.w2(baseClass);
    var tmp1_safe_receiver = (!(tmp_1 == null) ? typeof tmp_1 === 'function' : false) ? tmp_1 : null;
    return tmp1_safe_receiver == null ? null : tmp1_safe_receiver(serializedClassName);
  };
  protoOf(SerialModuleImpl).k72 = function (kClass, typeArgumentsSerializers) {
    var tmp0_safe_receiver = this.q7l_1.w2(kClass);
    var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w7l(typeArgumentsSerializers);
    return (tmp == null ? true : isInterface(tmp, KSerializer)) ? tmp : null;
  };
  protoOf(SerialModuleImpl).p7l = function (collector) {
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = this.q7l_1.s1().t();
    while (_iterator__ex2g4s.u()) {
      var element = _iterator__ex2g4s.v();
      // Inline function 'kotlin.collections.component1' call
      var kclass = element.t1();
      // Inline function 'kotlin.collections.component2' call
      var serial = element.u1();
      if (serial instanceof Argless) {
        var tmp = isInterface(kclass, KClass) ? kclass : THROW_CCE();
        var tmp_0 = serial.z7l_1;
        collector.a7m(tmp, isInterface(tmp_0, KSerializer) ? tmp_0 : THROW_CCE());
      } else {
        if (serial instanceof WithTypeArguments) {
          collector.y7l(kclass, serial.x7l_1);
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_0 = this.r7l_1.s1().t();
    while (_iterator__ex2g4s_0.u()) {
      var element_0 = _iterator__ex2g4s_0.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass = element_0.t1();
      // Inline function 'kotlin.collections.component2' call
      var classMap = element_0.u1();
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = classMap.s1().t();
      while (_iterator__ex2g4s_1.u()) {
        var element_1 = _iterator__ex2g4s_1.v();
        // Inline function 'kotlin.collections.component1' call
        var actualClass = element_1.t1();
        // Inline function 'kotlin.collections.component2' call
        var serializer = element_1.u1();
        var tmp_1 = isInterface(baseClass, KClass) ? baseClass : THROW_CCE();
        var tmp_2 = isInterface(actualClass, KClass) ? actualClass : THROW_CCE();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var tmp$ret$15 = isInterface(serializer, KSerializer) ? serializer : THROW_CCE();
        collector.b7m(tmp_1, tmp_2, tmp$ret$15);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_2 = this.s7l_1.s1().t();
    while (_iterator__ex2g4s_2.u()) {
      var element_2 = _iterator__ex2g4s_2.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_0 = element_2.t1();
      // Inline function 'kotlin.collections.component2' call
      var provider = element_2.u1();
      var tmp_3 = isInterface(baseClass_0, KClass) ? baseClass_0 : THROW_CCE();
      collector.c7m(tmp_3, typeof provider === 'function' ? provider : THROW_CCE());
    }
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_3 = this.u7l_1.s1().t();
    while (_iterator__ex2g4s_3.u()) {
      var element_3 = _iterator__ex2g4s_3.v();
      // Inline function 'kotlin.collections.component1' call
      var baseClass_1 = element_3.t1();
      // Inline function 'kotlin.collections.component2' call
      var provider_0 = element_3.u1();
      var tmp_4 = isInterface(baseClass_1, KClass) ? baseClass_1 : THROW_CCE();
      collector.d7m(tmp_4, typeof provider_0 === 'function' ? provider_0 : THROW_CCE());
    }
  };
  function Argless() {
  }
  function WithTypeArguments() {
  }
  function ContextualProvider() {
  }
  var properties_initialized_SerializersModule_kt_fjigjn;
  function _init_properties_SerializersModule_kt__u78ha3() {
    if (!properties_initialized_SerializersModule_kt_fjigjn) {
      properties_initialized_SerializersModule_kt_fjigjn = true;
      EmptySerializersModule = new SerialModuleImpl(emptyMap(), emptyMap(), emptyMap(), emptyMap(), emptyMap(), false);
    }
  }
  function EmptySerializersModule_0() {
    return get_EmptySerializersModuleLegacyJs();
  }
  function SerializersModuleCollector$contextual$lambda($serializer) {
    return function (it) {
      return $serializer;
    };
  }
  function SerializersModuleCollector() {
  }
  function SerializableWith(serializer) {
    this.e7m_1 = serializer;
  }
  protoOf(SerializableWith).equals = function (other) {
    if (!(other instanceof SerializableWith))
      return false;
    var tmp0_other_with_cast = other instanceof SerializableWith ? other : THROW_CCE();
    if (!this.e7m_1.equals(tmp0_other_with_cast.e7m_1))
      return false;
    return true;
  };
  protoOf(SerializableWith).hashCode = function () {
    return imul(getStringHashCode('serializer'), 127) ^ this.e7m_1.hashCode();
  };
  protoOf(SerializableWith).toString = function () {
    return '@kotlinx.serialization.SerializableWith(' + 'serializer=' + toString(this.e7m_1) + ')';
  };
  function platformSpecificSerializerNotRegistered(_this__u8e3s4) {
    throw SerializationException_init_$Create$_0(notRegisteredMessage(_this__u8e3s4) + 'To get enum serializer on Kotlin/JS, it should be annotated with @Serializable annotation.');
  }
  function isInterface_0(_this__u8e3s4) {
    return get_isInterfaceHack(_this__u8e3s4);
  }
  function compiledSerializerImpl(_this__u8e3s4) {
    var tmp0_elvis_lhs = constructSerializerForGivenTypeArgs(_this__u8e3s4, []);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      if (_this__u8e3s4 === PrimitiveClasses_getInstance().ic()) {
        tmp_0 = NothingSerializer_getInstance();
      } else {
        // Inline function 'kotlin.js.asDynamic' call
        var tmp1_safe_receiver = get_js(_this__u8e3s4).Companion;
        tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.serializer();
      }
      var tmp_1 = tmp_0;
      tmp = (!(tmp_1 == null) ? isInterface(tmp_1, KSerializer) : false) ? tmp_1 : null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function isReferenceArray(rootClass) {
    return rootClass.equals(PrimitiveClasses_getInstance().qc());
  }
  function constructSerializerForGivenTypeArgs(_this__u8e3s4, args) {
    var tmp;
    try {
      // Inline function 'kotlin.reflect.findAssociatedObject' call
      var assocObject = findAssociatedObject(_this__u8e3s4, getKClass(SerializableWith));
      var tmp_0;
      if (!(assocObject == null) ? isInterface(assocObject, KSerializer) : false) {
        tmp_0 = isInterface(assocObject, KSerializer) ? assocObject : THROW_CCE();
      } else {
        if (!(assocObject == null) ? isInterface(assocObject, SerializerFactory) : false) {
          var tmp_1 = assocObject.e7d(args.slice());
          tmp_0 = isInterface(tmp_1, KSerializer) ? tmp_1 : THROW_CCE();
        } else {
          tmp_0 = null;
        }
      }
      tmp = tmp_0;
    } catch ($p) {
      var tmp_2;
      var e = $p;
      tmp_2 = null;
      tmp = tmp_2;
    }
    return tmp;
  }
  function createCache(factory) {
    return new createCache$1(factory);
  }
  function createParametrizedCache(factory) {
    return new createParametrizedCache$1(factory);
  }
  function getChecked(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function getChecked_0(_this__u8e3s4, index) {
    if (!(0 <= index ? index <= (_this__u8e3s4.length - 1 | 0) : false))
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' out of bounds ' + get_indices_0(_this__u8e3s4).toString());
    return _this__u8e3s4[index];
  }
  function toNativeArrayImpl(_this__u8e3s4, eClass) {
    // Inline function 'kotlin.collections.toTypedArray' call
    return copyToArray(_this__u8e3s4);
  }
  function initBuiltins() {
    return mapOf([to(PrimitiveClasses_getInstance().rc(), serializer_2(StringCompanionObject_instance)), to(getKClass(Char), serializer_10(Companion_getInstance_2())), to(PrimitiveClasses_getInstance().uc(), CharArraySerializer()), to(PrimitiveClasses_getInstance().pc(), serializer_11(DoubleCompanionObject_instance)), to(PrimitiveClasses_getInstance().ad(), DoubleArraySerializer()), to(PrimitiveClasses_getInstance().oc(), serializer_12(FloatCompanionObject_instance)), to(PrimitiveClasses_getInstance().zc(), FloatArraySerializer()), to(getKClass(Long), serializer_13(Companion_getInstance_3())), to(get_longArrayClass(), LongArraySerializer()), to(getKClass(ULong), serializer_4(Companion_getInstance_4())), to(getKClass(ULongArray), ULongArraySerializer()), to(PrimitiveClasses_getInstance().mc(), serializer_3(IntCompanionObject_instance)), to(PrimitiveClasses_getInstance().xc(), IntArraySerializer()), to(getKClass(UInt), serializer_5(Companion_getInstance_5())), to(getKClass(UIntArray), UIntArraySerializer()), to(PrimitiveClasses_getInstance().lc(), serializer_14(ShortCompanionObject_instance)), to(PrimitiveClasses_getInstance().wc(), ShortArraySerializer()), to(getKClass(UShort), serializer_7(Companion_getInstance_6())), to(getKClass(UShortArray), UShortArraySerializer()), to(PrimitiveClasses_getInstance().kc(), serializer_8(ByteCompanionObject_instance)), to(PrimitiveClasses_getInstance().vc(), ByteArraySerializer()), to(getKClass(UByte), serializer_6(Companion_getInstance_7())), to(getKClass(UByteArray), UByteArraySerializer()), to(PrimitiveClasses_getInstance().jc(), serializer_9(BooleanCompanionObject_instance)), to(PrimitiveClasses_getInstance().tc(), BooleanArraySerializer()), to(getKClass(Unit), serializer_15(Unit_instance)), to(PrimitiveClasses_getInstance().ic(), NothingSerializer()), to(getKClass(Duration), serializer_16(Companion_getInstance())), to(getKClass(Instant), serializer_17(Companion_getInstance_0())), to(getKClass(Uuid), serializer_18(Companion_getInstance_1()))]);
  }
  function get_isInterfaceHack(_this__u8e3s4) {
    if (_this__u8e3s4 === PrimitiveClasses_getInstance().ic())
      return false;
    // Inline function 'kotlin.js.asDynamic' call
    var tmp0_safe_receiver = get_js(_this__u8e3s4).$metadata$;
    return (tmp0_safe_receiver == null ? null : tmp0_safe_receiver.kind) == 'interface';
  }
  function createCache$1($factory) {
    this.f7m_1 = $factory;
  }
  protoOf(createCache$1).l72 = function (key) {
    return this.f7m_1(key);
  };
  function createParametrizedCache$1($factory) {
    this.g7m_1 = $factory;
  }
  protoOf(createParametrizedCache$1).m72 = function (key, types) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = this.g7m_1(key, types);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  //region block: post-declaration
  protoOf(SerialDescriptorImpl).n72 = get_isNullable;
  protoOf(SerialDescriptorImpl).v72 = get_isInline;
  protoOf(AbstractDecoder).a75 = decodeSerializableElement$default;
  protoOf(AbstractDecoder).m74 = decodeSerializableValue;
  protoOf(AbstractDecoder).d75 = decodeSequentially;
  protoOf(AbstractDecoder).f75 = decodeCollectionSize;
  protoOf(AbstractEncoder).i76 = encodeNotNullMark;
  protoOf(AbstractEncoder).j76 = beginCollection;
  protoOf(AbstractEncoder).f76 = encodeSerializableValue;
  protoOf(AbstractEncoder).h76 = encodeNullableSerializableValue;
  protoOf(AbstractEncoder).k76 = shouldEncodeElementDefault;
  protoOf(MapLikeDescriptor).n72 = get_isNullable;
  protoOf(MapLikeDescriptor).v72 = get_isInline;
  protoOf(MapLikeDescriptor).x72 = get_annotations;
  protoOf(ListLikeDescriptor).n72 = get_isNullable;
  protoOf(ListLikeDescriptor).v72 = get_isInline;
  protoOf(ListLikeDescriptor).x72 = get_annotations;
  protoOf(PluginGeneratedSerialDescriptor).n72 = get_isNullable;
  protoOf(PluginGeneratedSerialDescriptor).v72 = get_isInline;
  protoOf(InlinePrimitiveDescriptor$1).u7c = typeParametersSerializers;
  protoOf(NothingSerialDescriptor).n72 = get_isNullable;
  protoOf(NothingSerialDescriptor).v72 = get_isInline;
  protoOf(NothingSerialDescriptor).x72 = get_annotations;
  protoOf(PrimitiveSerialDescriptor_0).n72 = get_isNullable;
  protoOf(PrimitiveSerialDescriptor_0).v72 = get_isInline;
  protoOf(PrimitiveSerialDescriptor_0).x72 = get_annotations;
  protoOf(TaggedDecoder).a75 = decodeSerializableElement$default;
  protoOf(TaggedDecoder).m74 = decodeSerializableValue;
  protoOf(TaggedDecoder).d75 = decodeSequentially;
  protoOf(TaggedDecoder).f75 = decodeCollectionSize;
  protoOf(TaggedEncoder).j76 = beginCollection;
  protoOf(TaggedEncoder).f76 = encodeSerializableValue;
  protoOf(TaggedEncoder).h76 = encodeNullableSerializableValue;
  protoOf(TaggedEncoder).k76 = shouldEncodeElementDefault;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = SEALED_getInstance;
  _.$_$.b = DOUBLE_getInstance;
  _.$_$.c = STRING_getInstance;
  _.$_$.d = CONTEXTUAL_getInstance;
  _.$_$.e = ENUM_getInstance;
  _.$_$.f = CLASS_getInstance;
  _.$_$.g = LIST_getInstance;
  _.$_$.h = MAP_getInstance;
  _.$_$.i = OBJECT_getInstance;
  _.$_$.j = BooleanSerializer_getInstance;
  _.$_$.k = ByteSerializer_getInstance;
  _.$_$.l = DoubleSerializer_getInstance;
  _.$_$.m = FloatSerializer_getInstance;
  _.$_$.n = InstantSerializer_getInstance;
  _.$_$.o = IntSerializer_getInstance;
  _.$_$.p = LongSerializer_getInstance;
  _.$_$.q = StringSerializer_getInstance;
  _.$_$.r = ObjectSerializer_init_$Create$;
  _.$_$.s = MissingFieldException_init_$Create$_0;
  _.$_$.t = SealedClassSerializer_init_$Create$;
  _.$_$.u = SerializationException_init_$Init$_0;
  _.$_$.v = SerializationException_init_$Create$_0;
  _.$_$.w = UnknownFieldException_init_$Create$;
  _.$_$.x = ListSerializer;
  _.$_$.y = MapSerializer;
  _.$_$.z = SetSerializer;
  _.$_$.a1 = get_nullable;
  _.$_$.b1 = serializer_2;
  _.$_$.c1 = serializer_7;
  _.$_$.d1 = serializer_5;
  _.$_$.e1 = serializer_6;
  _.$_$.f1 = serializer_4;
  _.$_$.g1 = PolymorphicKind;
  _.$_$.h1 = PrimitiveKind;
  _.$_$.i1 = PrimitiveSerialDescriptor;
  _.$_$.j1 = get_annotations;
  _.$_$.k1 = get_isInline;
  _.$_$.l1 = get_isNullable;
  _.$_$.m1 = SerialDescriptor;
  _.$_$.n1 = ENUM;
  _.$_$.o1 = buildClassSerialDescriptor;
  _.$_$.p1 = buildSerialDescriptor;
  _.$_$.q1 = getContextualDescriptor;
  _.$_$.r1 = AbstractDecoder;
  _.$_$.s1 = AbstractEncoder;
  _.$_$.t1 = CompositeDecoder;
  _.$_$.u1 = CompositeEncoder;
  _.$_$.v1 = Decoder;
  _.$_$.w1 = Encoder;
  _.$_$.x1 = AbstractPolymorphicSerializer;
  _.$_$.y1 = ArrayListSerializer;
  _.$_$.z1 = ElementMarker;
  _.$_$.a2 = typeParametersSerializers;
  _.$_$.b2 = GeneratedSerializer;
  _.$_$.c2 = InlinePrimitiveDescriptor;
  _.$_$.d2 = LinkedHashMapSerializer;
  _.$_$.e2 = NamedValueDecoder;
  _.$_$.f2 = NamedValueEncoder;
  _.$_$.g2 = PluginGeneratedSerialDescriptor;
  _.$_$.h2 = SerializerFactory;
  _.$_$.i2 = createAnnotatedEnumSerializer;
  _.$_$.j2 = createSimpleEnumSerializer;
  _.$_$.k2 = jsonCachedSerialNames;
  _.$_$.l2 = missingFieldExceptionWithNewMessage;
  _.$_$.m2 = throwArrayMissingFieldException;
  _.$_$.n2 = throwMissingFieldException;
  _.$_$.o2 = EmptySerializersModule_0;
  _.$_$.p2 = contextual;
  _.$_$.q2 = SerializersModuleCollector;
  _.$_$.r2 = BinaryFormat;
  _.$_$.s2 = DeserializationStrategy;
  _.$_$.t2 = KSerializer;
  _.$_$.u2 = MissingFieldException;
  _.$_$.v2 = SealedClassSerializer;
  _.$_$.w2 = SerializableWith;
  _.$_$.x2 = SerializationException;
  _.$_$.y2 = SerializationStrategy;
  _.$_$.z2 = StringFormat;
  _.$_$.a3 = findPolymorphicSerializer;
  _.$_$.b3 = findPolymorphicSerializer_0;
  _.$_$.c3 = serializerOrNull_0;
  _.$_$.d3 = serializer_0;
  _.$_$.e3 = serializer_1;
  _.$_$.f3 = serializer;
  //endregion
  return _;
}));

//# sourceMappingURL=kotlinx-serialization-kotlinx-serialization-core.js.map
